import SignOneZeroZeroZeroHyphenOneZero from '@/assets/signs/1000-10.svg?url';
import SignOneZeroZeroZeroHyphenOneOne from '@/assets/signs/1000-11.svg?url';
import SignOneZeroZeroZeroHyphenOneTwo from '@/assets/signs/1000-12.svg?url';
import SignOneZeroZeroZeroHyphenOneThree from '@/assets/signs/1000-13.svg?url';
import SignOneZeroZeroZeroHyphenTwoZero from '@/assets/signs/1000-20.svg?url';
import SignOneZeroZeroZeroHyphenTwoOne from '@/assets/signs/1000-21.svg?url';
import SignOneZeroZeroZeroHyphenTwoTwo from '@/assets/signs/1000-22.svg?url';
import SignOneZeroZeroZeroHyphenTwoThree from '@/assets/signs/1000-23.svg?url';
import SignOneZeroZeroZeroHyphenThreeZero from '@/assets/signs/1000-30.svg?url';
import SignOneZeroZeroZeroHyphenThreeOne from '@/assets/signs/1000-31.svg?url';
import SignOneZeroZeroZeroHyphenThreeTwo from '@/assets/signs/1000-32.svg?url';
import SignOneZeroZeroZeroHyphenThreeFour from '@/assets/signs/1000-34.svg?url';
import SignOneZeroZeroOneHyphenThreeZero from '@/assets/signs/1001-30.svg?url';
import SignOneZeroZeroOneHyphenThreeOne from '@/assets/signs/1001-31.svg?url';
import SignOneZeroZeroOneHyphenThreeTwo from '@/assets/signs/1001-32.svg?url';
import SignOneZeroZeroOneHyphenThreeThree from '@/assets/signs/1001-33.svg?url';
import SignOneZeroZeroOneHyphenThreeFour from '@/assets/signs/1001-34.svg?url';
import SignOneZeroZeroOneHyphenThreeFive from '@/assets/signs/1001-35.svg?url';
import SignOneZeroZeroTwoHyphenOneZero from '@/assets/signs/1002-10.svg?url';
import SignOneZeroZeroTwoHyphenOneOne from '@/assets/signs/1002-11.svg?url';
import SignOneZeroZeroTwoHyphenOneTwo from '@/assets/signs/1002-12.svg?url';
import SignOneZeroZeroTwoHyphenOneThree from '@/assets/signs/1002-13.svg?url';
import SignOneZeroZeroTwoHyphenOneFour from '@/assets/signs/1002-14.svg?url';
import SignOneZeroZeroTwoHyphenTwoZero from '@/assets/signs/1002-20.svg?url';
import SignOneZeroZeroTwoHyphenTwoOne from '@/assets/signs/1002-21.svg?url';
import SignOneZeroZeroTwoHyphenTwoTwo from '@/assets/signs/1002-22.svg?url';
import SignOneZeroZeroTwoHyphenTwoThree from '@/assets/signs/1002-23.svg?url';
import SignOneZeroZeroTwoHyphenTwoFour from '@/assets/signs/1002-24.svg?url';
import SignOneZeroZeroFourHyphenThreeZero from '@/assets/signs/1004-30.svg?url';
import SignOneZeroZeroFourHyphenThreeOne from '@/assets/signs/1004-31.svg?url';
import SignOneZeroZeroFourHyphenThreeTwo from '@/assets/signs/1004-32.svg?url';
import SignOneZeroZeroFiveHyphenThreeZero from '@/assets/signs/1005-30.svg?url';
import SignOneZeroZeroSixHyphenThreeZero from '@/assets/signs/1006-30.svg?url';
import SignOneZeroZeroSixHyphenThreeOne from '@/assets/signs/1006-31.svg?url';
import SignOneZeroZeroSevenHyphenThreeZero from '@/assets/signs/1007-30.svg?url';
import SignOneZeroZeroSevenHyphenThreeOne from '@/assets/signs/1007-31.svg?url';
import SignOneZeroZeroSevenHyphenThreeTwo from '@/assets/signs/1007-32.svg?url';
import SignOneZeroZeroSevenHyphenThreeThree from '@/assets/signs/1007-33.svg?url';
import SignOneZeroZeroSevenHyphenThreeFour from '@/assets/signs/1007-34.svg?url';
import SignOneZeroZeroSevenHyphenThreeFive from '@/assets/signs/1007-35.svg?url';
import SignOneZeroZeroSevenHyphenThreeSix from '@/assets/signs/1007-36.svg?url';
import SignOneZeroZeroSevenHyphenThreeSeven from '@/assets/signs/1007-37.svg?url';
import SignOneZeroZeroSevenHyphenThreeEight from '@/assets/signs/1007-38.svg?url';
import SignOneZeroZeroSevenHyphenThreeNine from '@/assets/signs/1007-39.svg?url';
import SignOneZeroZeroSevenHyphenFiveZero from '@/assets/signs/1007-50.svg?url';
import SignOneZeroZeroSevenHyphenFiveOne from '@/assets/signs/1007-51.svg?url';
import SignOneZeroZeroSevenHyphenFiveTwo from '@/assets/signs/1007-52.svg?url';
import SignOneZeroZeroSevenHyphenFiveThree from '@/assets/signs/1007-53.svg?url';
import SignOneZeroZeroSevenHyphenFiveFour from '@/assets/signs/1007-54.svg?url';
import SignOneZeroZeroSevenHyphenFiveFive from '@/assets/signs/1007-55.svg?url';
import SignOneZeroZeroSevenHyphenFiveSix from '@/assets/signs/1007-56.svg?url';
import SignOneZeroZeroSevenHyphenFiveSeven from '@/assets/signs/1007-57.svg?url';
import SignOneZeroZeroSevenHyphenFiveEight from '@/assets/signs/1007-58.svg?url';
import SignOneZeroZeroSevenHyphenFiveNine from '@/assets/signs/1007-59.svg?url';
import SignOneZeroZeroSevenHyphenSixZero from '@/assets/signs/1007-60.svg?url';
import SignOneZeroZeroSevenHyphenSixOne from '@/assets/signs/1007-61.svg?url';
import SignOneZeroZeroSevenHyphenSixTwo from '@/assets/signs/1007-62.svg?url';
import SignOneZeroZeroEightHyphenThreeZero from '@/assets/signs/1008-30.svg?url';
import SignOneZeroZeroEightHyphenThreeOne from '@/assets/signs/1008-31.svg?url';
import SignOneZeroZeroEightHyphenThreeTwo from '@/assets/signs/1008-32.svg?url';
import SignOneZeroZeroEightHyphenThreeThree from '@/assets/signs/1008-33.svg?url';
import SignOneZeroZeroEightHyphenThreeFour from '@/assets/signs/1008-34.svg?url';
import SignOneZeroOneHyphenOneZero from '@/assets/signs/101-10.svg?url';
import SignOneZeroOneHyphenOneOne from '@/assets/signs/101-11.svg?url';
import SignOneZeroOneHyphenOneTwo from '@/assets/signs/101-12.svg?url';
import SignOneZeroOneHyphenOneThree from '@/assets/signs/101-13.svg?url';
import SignOneZeroOneHyphenOneFour from '@/assets/signs/101-14.svg?url';
import SignOneZeroOneHyphenOneFive from '@/assets/signs/101-15.svg?url';
import SignOneZeroOneHyphenTwoZero from '@/assets/signs/101-20.svg?url';
import SignOneZeroOneHyphenTwoOne from '@/assets/signs/101-21.svg?url';
import SignOneZeroOneHyphenTwoTwo from '@/assets/signs/101-22.svg?url';
import SignOneZeroOneHyphenTwoThree from '@/assets/signs/101-23.svg?url';
import SignOneZeroOneHyphenTwoFour from '@/assets/signs/101-24.svg?url';
import SignOneZeroOneHyphenTwoFive from '@/assets/signs/101-25.svg?url';
import SignOneZeroOneHyphenFiveOne from '@/assets/signs/101-51.svg?url';
import SignOneZeroOneHyphenFiveTwo from '@/assets/signs/101-52.svg?url';
import SignOneZeroOneHyphenFiveThree from '@/assets/signs/101-53.svg?url';
import SignOneZeroOneHyphenFiveFour from '@/assets/signs/101-54.svg?url';
import SignOneZeroOneHyphenFiveFive from '@/assets/signs/101-55.svg?url';
import SignOneZeroOne from '@/assets/signs/101.svg?url';
import SignOneZeroOneZeroHyphenOneZero from '@/assets/signs/1010-10.svg?url';
import SignOneZeroOneZeroHyphenOneOne from '@/assets/signs/1010-11.svg?url';
import SignOneZeroOneZeroHyphenOneTwo from '@/assets/signs/1010-12.svg?url';
import SignOneZeroOneZeroHyphenOneThree from '@/assets/signs/1010-13.svg?url';
import SignOneZeroOneZeroHyphenOneFour from '@/assets/signs/1010-14.svg?url';
import SignOneZeroOneZeroHyphenOneFive from '@/assets/signs/1010-15.svg?url';
import SignOneZeroOneZeroHyphenFiveZero from '@/assets/signs/1010-50.svg?url';
import SignOneZeroOneZeroHyphenFiveOne from '@/assets/signs/1010-51.svg?url';
import SignOneZeroOneZeroHyphenFiveTwo from '@/assets/signs/1010-52.svg?url';
import SignOneZeroOneZeroHyphenFiveThree from '@/assets/signs/1010-53.svg?url';
import SignOneZeroOneZeroHyphenFiveFour from '@/assets/signs/1010-54.svg?url';
import SignOneZeroOneZeroHyphenFiveFive from '@/assets/signs/1010-55.svg?url';
import SignOneZeroOneZeroHyphenFiveSix from '@/assets/signs/1010-56.svg?url';
import SignOneZeroOneZeroHyphenFiveSeven from '@/assets/signs/1010-57.svg?url';
import SignOneZeroOneZeroHyphenFiveEight from '@/assets/signs/1010-58.svg?url';
import SignOneZeroOneZeroHyphenFiveNine from '@/assets/signs/1010-59.svg?url';
import SignOneZeroOneZeroHyphenSixZero from '@/assets/signs/1010-60.svg?url';
import SignOneZeroOneZeroHyphenSixOne from '@/assets/signs/1010-61.svg?url';
import SignOneZeroOneZeroHyphenSixTwo from '@/assets/signs/1010-62.svg?url';
import SignOneZeroOneZeroHyphenSixThree from '@/assets/signs/1010-63.svg?url';
import SignOneZeroOneZeroHyphenSixFour from '@/assets/signs/1010-64.svg?url';
import SignOneZeroOneZeroHyphenSixFive from '@/assets/signs/1010-65.svg?url';
import SignOneZeroOneZeroHyphenSixSix from '@/assets/signs/1010-66.svg?url';
import SignOneZeroOneZeroHyphenSixSeven from '@/assets/signs/1010-67.svg?url';
import SignOneZeroOneZeroHyphenSixEight from '@/assets/signs/1010-68.svg?url';
import SignOneZeroOneZeroHyphenSixNine from '@/assets/signs/1010-69.svg?url';
import SignOneZeroOneZeroHyphenSevenZero from '@/assets/signs/1010-70.svg?url';
import SignOneZeroOneZeroHyphenSevenOne from '@/assets/signs/1010-71.svg?url';
import SignOneZeroOneZeroHyphenSevenTwo from '@/assets/signs/1010-72.svg?url';
import SignOneZeroOneTwoHyphenThreeZero from '@/assets/signs/1012-30.svg?url';
import SignOneZeroOneTwoHyphenThreeOne from '@/assets/signs/1012-31.svg?url';
import SignOneZeroOneTwoHyphenThreeTwo from '@/assets/signs/1012-32.svg?url';
import SignOneZeroOneTwoHyphenThreeThree from '@/assets/signs/1012-33.svg?url';
import SignOneZeroOneTwoHyphenThreeFour from '@/assets/signs/1012-34.svg?url';
import SignOneZeroOneTwoHyphenThreeFive from '@/assets/signs/1012-35.svg?url';
import SignOneZeroOneTwoHyphenThreeSix from '@/assets/signs/1012-36.svg?url';
import SignOneZeroOneTwoHyphenThreeSeven from '@/assets/signs/1012-37.svg?url';
import SignOneZeroOneTwoHyphenThreeEight from '@/assets/signs/1012-38.svg?url';
import SignOneZeroOneTwoHyphenFiveZero from '@/assets/signs/1012-50.svg?url';
import SignOneZeroOneTwoHyphenFiveOne from '@/assets/signs/1012-51.svg?url';
import SignOneZeroOneTwoHyphenFiveTwo from '@/assets/signs/1012-52.svg?url';
import SignOneZeroOneTwoHyphenFiveThree from '@/assets/signs/1012-53.svg?url';
import SignOneZeroOneTwoHyphenFiveFour from '@/assets/signs/1012-54.svg?url';
import SignOneZeroOneThreeHyphenFiveZero from '@/assets/signs/1013-50.svg?url';
import SignOneZeroOneThreeHyphenFiveOne from '@/assets/signs/1013-51.svg?url';
import SignOneZeroOneThreeHyphenFiveTwo from '@/assets/signs/1013-52.svg?url';
import SignOneZeroOneFourHyphenFiveZero from '@/assets/signs/1014-50.svg?url';
import SignOneZeroOneFourHyphenFiveOne from '@/assets/signs/1014-51.svg?url';
import SignOneZeroOneFourHyphenFiveTwo from '@/assets/signs/1014-52.svg?url';
import SignOneZeroOneFourHyphenFiveThree from '@/assets/signs/1014-53.svg?url';
import SignOneZeroTwo from '@/assets/signs/102.svg?url';
import SignOneZeroTwoZeroHyphenOneOne from '@/assets/signs/1020-11.svg?url';
import SignOneZeroTwoZeroHyphenOneTwo from '@/assets/signs/1020-12.svg?url';
import SignOneZeroTwoZeroHyphenOneThree from '@/assets/signs/1020-13.svg?url';
import SignOneZeroTwoZeroHyphenOneFour from '@/assets/signs/1020-14.svg?url';
import SignOneZeroTwoZeroHyphenThreeZero from '@/assets/signs/1020-30.svg?url';
import SignOneZeroTwoZeroHyphenThreeOne from '@/assets/signs/1020-31.svg?url';
import SignOneZeroTwoZeroHyphenThreeTwo from '@/assets/signs/1020-32.svg?url';
import SignOneZeroTwoTwoHyphenOneZero from '@/assets/signs/1022-10.svg?url';
import SignOneZeroTwoTwoHyphenOneOne from '@/assets/signs/1022-11.svg?url';
import SignOneZeroTwoTwoHyphenOneTwo from '@/assets/signs/1022-12.svg?url';
import SignOneZeroTwoTwoHyphenOneThree from '@/assets/signs/1022-13.svg?url';
import SignOneZeroTwoTwoHyphenOneFour from '@/assets/signs/1022-14.svg?url';
import SignOneZeroTwoTwoHyphenOneFive from '@/assets/signs/1022-15.svg?url';
import SignOneZeroTwoTwoHyphenOneSix from '@/assets/signs/1022-16.svg?url';
import SignOneZeroTwoTwoHyphenOneSeven from '@/assets/signs/1022-17.svg?url';
import SignOneZeroTwoFourHyphenOneZero from '@/assets/signs/1024-10.svg?url';
import SignOneZeroTwoFourHyphenOneOne from '@/assets/signs/1024-11.svg?url';
import SignOneZeroTwoFourHyphenOneTwo from '@/assets/signs/1024-12.svg?url';
import SignOneZeroTwoFourHyphenOneThree from '@/assets/signs/1024-13.svg?url';
import SignOneZeroTwoFourHyphenOneFour from '@/assets/signs/1024-14.svg?url';
import SignOneZeroTwoFourHyphenOneFive from '@/assets/signs/1024-15.svg?url';
import SignOneZeroTwoFourHyphenOneSix from '@/assets/signs/1024-16.svg?url';
import SignOneZeroTwoFourHyphenOneSeven from '@/assets/signs/1024-17.svg?url';
import SignOneZeroTwoFourHyphenOneEight from '@/assets/signs/1024-18.svg?url';
import SignOneZeroTwoFourHyphenOneNine from '@/assets/signs/1024-19.svg?url';
import SignOneZeroTwoFourHyphenTwoZero from '@/assets/signs/1024-20.svg?url';
import SignOneZeroTwoFourHyphenTwoOne from '@/assets/signs/1024-21.svg?url';
import SignOneZeroTwoSixHyphenThreeZero from '@/assets/signs/1026-30.svg?url';
import SignOneZeroTwoSixHyphenThreeOne from '@/assets/signs/1026-31.svg?url';
import SignOneZeroTwoSixHyphenThreeTwo from '@/assets/signs/1026-32.svg?url';
import SignOneZeroTwoSixHyphenThreeThree from '@/assets/signs/1026-33.svg?url';
import SignOneZeroTwoSixHyphenThreeFour from '@/assets/signs/1026-34.svg?url';
import SignOneZeroTwoSixHyphenThreeFive from '@/assets/signs/1026-35.svg?url';
import SignOneZeroTwoSixHyphenThreeSix from '@/assets/signs/1026-36.svg?url';
import SignOneZeroTwoSixHyphenThreeSeven from '@/assets/signs/1026-37.svg?url';
import SignOneZeroTwoSixHyphenThreeEight from '@/assets/signs/1026-38.svg?url';
import SignOneZeroTwoSixHyphenThreeNine from '@/assets/signs/1026-39.svg?url';
import SignOneZeroTwoSixHyphenSixZero from '@/assets/signs/1026-60.svg?url';
import SignOneZeroTwoSixHyphenSixOne from '@/assets/signs/1026-61.svg?url';
import SignOneZeroTwoSixHyphenSixTwo from '@/assets/signs/1026-62.svg?url';
import SignOneZeroTwoSixHyphenSixThree from '@/assets/signs/1026-63.svg?url';
import SignOneZeroTwoEightHyphenThreeZero from '@/assets/signs/1028-30.svg?url';
import SignOneZeroTwoEightHyphenThreeOne from '@/assets/signs/1028-31.svg?url';
import SignOneZeroTwoEightHyphenThreeTwo from '@/assets/signs/1028-32.svg?url';
import SignOneZeroTwoEightHyphenThreeThree from '@/assets/signs/1028-33.svg?url';
import SignOneZeroTwoEightHyphenThreeFour from '@/assets/signs/1028-34.svg?url';
import SignOneZeroThreeHyphenOneZero from '@/assets/signs/103-10.svg?url';
import SignOneZeroThreeHyphenTwoZero from '@/assets/signs/103-20.svg?url';
import SignOneZeroThreeOneHyphenFiveZero from '@/assets/signs/1031-50.svg?url';
import SignOneZeroThreeOneHyphenFiveOne from '@/assets/signs/1031-51.svg?url';
import SignOneZeroThreeOneHyphenFiveTwo from '@/assets/signs/1031-52.svg?url';
import SignOneZeroFourZeroHyphenOneZero from '@/assets/signs/1040-10.svg?url';
import SignOneZeroFourZeroHyphenThreeZero from '@/assets/signs/1040-30.svg?url';
import SignOneZeroFourZeroHyphenThreeOne from '@/assets/signs/1040-31.svg?url';
import SignOneZeroFourZeroHyphenThreeTwo from '@/assets/signs/1040-32.svg?url';
import SignOneZeroFourZeroHyphenThreeThree from '@/assets/signs/1040-33.svg?url';
import SignOneZeroFourZeroHyphenThreeFour from '@/assets/signs/1040-34.svg?url';
import SignOneZeroFourZeroHyphenThreeFive from '@/assets/signs/1040-35.svg?url';
import SignOneZeroFourZeroHyphenThreeSix from '@/assets/signs/1040-36.svg?url';
import SignOneZeroFourTwoHyphenThreeZero from '@/assets/signs/1042-30.svg?url';
import SignOneZeroFourTwoHyphenThreeOne from '@/assets/signs/1042-31.svg?url';
import SignOneZeroFourTwoHyphenThreeTwo from '@/assets/signs/1042-32.svg?url';
import SignOneZeroFourTwoHyphenThreeThree from '@/assets/signs/1042-33.svg?url';
import SignOneZeroFourTwoHyphenThreeFour from '@/assets/signs/1042-34.svg?url';
import SignOneZeroFourTwoHyphenThreeFive from '@/assets/signs/1042-35.svg?url';
import SignOneZeroFourTwoHyphenThreeSix from '@/assets/signs/1042-36.svg?url';
import SignOneZeroFourTwoHyphenThreeSeven from '@/assets/signs/1042-37.svg?url';
import SignOneZeroFourTwoHyphenThreeEight from '@/assets/signs/1042-38.svg?url';
import SignOneZeroFourTwoHyphenFiveZero from '@/assets/signs/1042-50.svg?url';
import SignOneZeroFourTwoHyphenFiveOne from '@/assets/signs/1042-51.svg?url';
import SignOneZeroFourTwoHyphenFiveTwo from '@/assets/signs/1042-52.svg?url';
import SignOneZeroFourTwoHyphenFiveThree from '@/assets/signs/1042-53.svg?url';
import SignOneZeroFourFourHyphenOneZero from '@/assets/signs/1044-10.svg?url';
import SignOneZeroFourFourHyphenOneOne from '@/assets/signs/1044-11.svg?url';
import SignOneZeroFourFourHyphenOneTwo from '@/assets/signs/1044-12.svg?url';
import SignOneZeroFourFourHyphenThreeZero from '@/assets/signs/1044-30.svg?url';
import SignOneZeroFourEightHyphenOneFour from '@/assets/signs/1048-14.svg?url';
import SignOneZeroFourEightHyphenOneFive from '@/assets/signs/1048-15.svg?url';
import SignOneZeroFourEightHyphenOneEight from '@/assets/signs/1048-18.svg?url';
import SignOneZeroFourEightHyphenTwoZero from '@/assets/signs/1048-20.svg?url';
import SignOneZeroFourNineHyphenOneOne from '@/assets/signs/1049-11.svg?url';
import SignOneZeroFourNineHyphenOneTwo from '@/assets/signs/1049-12.svg?url';
import SignOneZeroFourNineHyphenOneThree from '@/assets/signs/1049-13.svg?url';
import SignOneZeroFiveHyphenOneZero from '@/assets/signs/105-10.svg?url';
import SignOneZeroFiveHyphenTwoZero from '@/assets/signs/105-20.svg?url';
import SignOneZeroFiveZeroHyphenThreeZero from '@/assets/signs/1050-30.svg?url';
import SignOneZeroFiveZeroHyphenThreeOne from '@/assets/signs/1050-31.svg?url';
import SignOneZeroFiveZeroHyphenThreeTwo from '@/assets/signs/1050-32.svg?url';
import SignOneZeroFiveZeroHyphenThreeThree from '@/assets/signs/1050-33.svg?url';
import SignOneZeroFiveTwoHyphenThreeZero from '@/assets/signs/1052-30.svg?url';
import SignOneZeroFiveTwoHyphenThreeOne from '@/assets/signs/1052-31.svg?url';
import SignOneZeroFiveThreeHyphenThreeZero from '@/assets/signs/1053-30.svg?url';
import SignOneZeroFiveThreeHyphenThreeOne from '@/assets/signs/1053-31.svg?url';
import SignOneZeroFiveThreeHyphenThreeTwo from '@/assets/signs/1053-32.svg?url';
import SignOneZeroFiveThreeHyphenThreeThree from '@/assets/signs/1053-33.svg?url';
import SignOneZeroFiveThreeHyphenThreeFour from '@/assets/signs/1053-34.svg?url';
import SignOneZeroFiveThreeHyphenThreeFive from '@/assets/signs/1053-35.svg?url';
import SignOneZeroFiveThreeHyphenThreeSix from '@/assets/signs/1053-36.svg?url';
import SignOneZeroFiveThreeHyphenThreeSeven from '@/assets/signs/1053-37.svg?url';
import SignOneZeroFiveThreeHyphenThreeEight from '@/assets/signs/1053-38.svg?url';
import SignOneZeroFiveThreeHyphenThreeNine from '@/assets/signs/1053-39.svg?url';
import SignOneZeroFiveThreeHyphenFiveTwo from '@/assets/signs/1053-52.svg?url';
import SignOneZeroFiveThreeHyphenFiveThree from '@/assets/signs/1053-53.svg?url';
import SignOneZeroFiveThreeHyphenFiveFour from '@/assets/signs/1053-54.svg?url';
import SignOneZeroSixZeroHyphenThreeOne from '@/assets/signs/1060-31.svg?url';
import SignOneZeroSixZeroHyphenThreeTwo from '@/assets/signs/1060-32.svg?url';
import SignOneZeroSixZeroHyphenThreeThree from '@/assets/signs/1060-33.svg?url';
import SignOneZeroEightHyphenOneZero from '@/assets/signs/108-10.svg?url';
import SignOneZeroEightHyphenOneOne from '@/assets/signs/108-11.svg?url';
import SignOneZeroEightHyphenOneTwo from '@/assets/signs/108-12.svg?url';
import SignOneZeroEightHyphenOneThree from '@/assets/signs/108-13.svg?url';
import SignOneZeroEightHyphenOneFour from '@/assets/signs/108-14.svg?url';
import SignOneZeroEightHyphenOneFive from '@/assets/signs/108-15.svg?url';
import SignOneZeroEightHyphenOneSix from '@/assets/signs/108-16.svg?url';
import SignOneZeroEightHyphenOneSeven from '@/assets/signs/108-17.svg?url';
import SignOneZeroEightHyphenOneEight from '@/assets/signs/108-18.svg?url';
import SignOneZeroEightHyphenOneNine from '@/assets/signs/108-19.svg?url';
import SignOneZeroEightHyphenTwoZero from '@/assets/signs/108-20.svg?url';
import SignOneZeroEightHyphenTwoOne from '@/assets/signs/108-21.svg?url';
import SignOneZeroEightHyphenTwoTwo from '@/assets/signs/108-22.svg?url';
import SignOneZeroEightHyphenTwoThree from '@/assets/signs/108-23.svg?url';
import SignOneZeroEightHyphenTwoFour from '@/assets/signs/108-24.svg?url';
import SignOneZeroEightHyphenTwoFive from '@/assets/signs/108-25.svg?url';
import SignOneZeroEightHyphenFour from '@/assets/signs/108-4.svg?url';
import SignOneZeroEightHyphenFive from '@/assets/signs/108-5.svg?url';
import SignOneZeroEightHyphenSix from '@/assets/signs/108-6.svg?url';
import SignOneZeroEightHyphenSeven from '@/assets/signs/108-7.svg?url';
import SignOneZeroEightHyphenEight from '@/assets/signs/108-8.svg?url';
import SignOneZeroEightHyphenNine from '@/assets/signs/108-9.svg?url';
import SignOneOneZeroHyphenOneZero from '@/assets/signs/110-10.svg?url';
import SignOneOneZeroHyphenOneOne from '@/assets/signs/110-11.svg?url';
import SignOneOneZeroHyphenOneTwo from '@/assets/signs/110-12.svg?url';
import SignOneOneZeroHyphenOneThree from '@/assets/signs/110-13.svg?url';
import SignOneOneZeroHyphenOneFour from '@/assets/signs/110-14.svg?url';
import SignOneOneZeroHyphenOneFive from '@/assets/signs/110-15.svg?url';
import SignOneOneZeroHyphenOneSix from '@/assets/signs/110-16.svg?url';
import SignOneOneZeroHyphenOneSeven from '@/assets/signs/110-17.svg?url';
import SignOneOneZeroHyphenOneEight from '@/assets/signs/110-18.svg?url';
import SignOneOneZeroHyphenOneNine from '@/assets/signs/110-19.svg?url';
import SignOneOneZeroHyphenTwoZero from '@/assets/signs/110-20.svg?url';
import SignOneOneZeroHyphenTwoOne from '@/assets/signs/110-21.svg?url';
import SignOneOneZeroHyphenTwoTwo from '@/assets/signs/110-22.svg?url';
import SignOneOneZeroHyphenTwoThree from '@/assets/signs/110-23.svg?url';
import SignOneOneZeroHyphenTwoFour from '@/assets/signs/110-24.svg?url';
import SignOneOneZeroHyphenTwoFive from '@/assets/signs/110-25.svg?url';
import SignOneOneZeroHyphenFour from '@/assets/signs/110-4.svg?url';
import SignOneOneZeroHyphenFive from '@/assets/signs/110-5.svg?url';
import SignOneOneZeroHyphenSix from '@/assets/signs/110-6.svg?url';
import SignOneOneZeroHyphenSeven from '@/assets/signs/110-7.svg?url';
import SignOneOneZeroHyphenEight from '@/assets/signs/110-8.svg?url';
import SignOneOneZeroHyphenNine from '@/assets/signs/110-9.svg?url';
import SignOneOneTwo from '@/assets/signs/112.svg?url';
import SignOneOneFour from '@/assets/signs/114.svg?url';
import SignOneOneSevenHyphenOneZero from '@/assets/signs/117-10.svg?url';
import SignOneOneSevenHyphenTwoZero from '@/assets/signs/117-20.svg?url';
import SignOneTwoZero from '@/assets/signs/120.svg?url';
import SignOneTwoOneHyphenOneZero from '@/assets/signs/121-10.svg?url';
import SignOneTwoOneHyphenTwoZero from '@/assets/signs/121-20.svg?url';
import SignOneTwoThree from '@/assets/signs/123.svg?url';
import SignOneTwoFour from '@/assets/signs/124.svg?url';
import SignOneTwoFive from '@/assets/signs/125.svg?url';
import SignOneThreeOne from '@/assets/signs/131.svg?url';
import SignOneThreeThreeHyphenOneZero from '@/assets/signs/133-10.svg?url';
import SignOneThreeThreeHyphenTwoZero from '@/assets/signs/133-20.svg?url';
import SignOneThreeSixHyphenOneZeroHyphenOne from '@/assets/signs/136-10-1.svg?url';
import SignOneThreeSixHyphenOneZero from '@/assets/signs/136-10.svg?url';
import SignOneThreeSixHyphenTwoZero from '@/assets/signs/136-20.svg?url';
import SignOneThreeEightHyphenOneZero from '@/assets/signs/138-10.svg?url';
import SignOneThreeEightHyphenTwoZero from '@/assets/signs/138-20.svg?url';
import SignOneFourTwoHyphenOneZero from '@/assets/signs/142-10.svg?url';
import SignOneFourTwoHyphenTwoZero from '@/assets/signs/142-20.svg?url';
import SignOneFiveOne from '@/assets/signs/151.svg?url';
import SignOneFiveSixHyphenOneZero from '@/assets/signs/156-10.svg?url';
import SignOneFiveSixHyphenOneOne from '@/assets/signs/156-11.svg?url';
import SignOneFiveSixHyphenTwoZero from '@/assets/signs/156-20.svg?url';
import SignOneFiveSixHyphenTwoOne from '@/assets/signs/156-21.svg?url';
import SignOneFiveSevenHyphenOneZero from '@/assets/signs/157-10.svg?url';
import SignOneFiveSevenHyphenOneOne from '@/assets/signs/157-11.svg?url';
import SignOneFiveSevenHyphenTwoZero from '@/assets/signs/157-20.svg?url';
import SignOneFiveSevenHyphenTwoOne from '@/assets/signs/157-21.svg?url';
import SignOneFiveNineHyphenOneZero from '@/assets/signs/159-10.svg?url';
import SignOneFiveNineHyphenOneOne from '@/assets/signs/159-11.svg?url';
import SignOneFiveNineHyphenTwoZero from '@/assets/signs/159-20.svg?url';
import SignOneFiveNineHyphenTwoOne from '@/assets/signs/159-21.svg?url';
import SignOneSixTwoHyphenOneZero from '@/assets/signs/162-10.svg?url';
import SignOneSixTwoHyphenOneOne from '@/assets/signs/162-11.svg?url';
import SignOneSixTwoHyphenTwoZero from '@/assets/signs/162-20.svg?url';
import SignOneSixTwoHyphenTwoOne from '@/assets/signs/162-21.svg?url';
import SignTwoZeroOneHyphenFiveZero from '@/assets/signs/201-50.svg?url';
import SignTwoZeroOneHyphenFiveOne from '@/assets/signs/201-51.svg?url';
import SignTwoZeroOneHyphenFiveTwo from '@/assets/signs/201-52.svg?url';
import SignTwoZeroOneHyphenFiveThree from '@/assets/signs/201-53.svg?url';
import SignTwoZeroFive from '@/assets/signs/205.svg?url';
import SignTwoZeroSix from '@/assets/signs/206.svg?url';
import SignTwoZeroEight from '@/assets/signs/208.svg?url';
import SignTwoZeroNineHyphenOneZero from '@/assets/signs/209-10.svg?url';
import SignTwoZeroNineHyphenThreeZero from '@/assets/signs/209-30.svg?url';
import SignTwoZeroNine from '@/assets/signs/209.svg?url';
import SignTwoOneOneHyphenOneZero from '@/assets/signs/211-10.svg?url';
import SignTwoOneOne from '@/assets/signs/211.svg?url';
import SignTwoOneFourHyphenOneZero from '@/assets/signs/214-10.svg?url';
import SignTwoOneFourHyphenThreeZero from '@/assets/signs/214-30.svg?url';
import SignTwoOneFour from '@/assets/signs/214.svg?url';
import SignTwoOneFive from '@/assets/signs/215.svg?url';
import SignTwoTwoZeroHyphenOneZero from '@/assets/signs/220-10.svg?url';
import SignTwoTwoZeroHyphenTwoZero from '@/assets/signs/220-20.svg?url';
import SignTwoTwoTwoHyphenOneZero from '@/assets/signs/222-10.svg?url';
import SignTwoTwoTwo from '@/assets/signs/222.svg?url';
import SignTwoTwoThreeDotOneHyphenFiveZero from '@/assets/signs/223.1-50.svg?url';
import SignTwoTwoThreeDotOneHyphenFiveOne from '@/assets/signs/223.1-51.svg?url';
import SignTwoTwoThreeDotOneHyphenFiveTwo from '@/assets/signs/223.1-52.svg?url';
import SignTwoTwoThreeDotTwoHyphenFiveZero from '@/assets/signs/223.2-50.svg?url';
import SignTwoTwoThreeDotTwoHyphenFiveOne from '@/assets/signs/223.2-51.svg?url';
import SignTwoTwoThreeDotTwoHyphenFiveTwo from '@/assets/signs/223.2-52.svg?url';
import SignTwoTwoThreeDotThreeHyphenFiveZero from '@/assets/signs/223.3-50.svg?url';
import SignTwoTwoThreeDotThreeHyphenFiveOne from '@/assets/signs/223.3-51.svg?url';
import SignTwoTwoThreeDotThreeHyphenFiveTwo from '@/assets/signs/223.3-52.svg?url';
import SignTwoTwoFourHyphenFiveOne from '@/assets/signs/224-51.svg?url';
import SignTwoTwoFour from '@/assets/signs/224.svg?url';
import SignTwoTwoNineHyphenOneZero from '@/assets/signs/229-10.svg?url';
import SignTwoTwoNineHyphenOneOne from '@/assets/signs/229-11.svg?url';
import SignTwoTwoNineHyphenTwoZero from '@/assets/signs/229-20.svg?url';
import SignTwoTwoNineHyphenTwoOne from '@/assets/signs/229-21.svg?url';
import SignTwoTwoNineHyphenThreeZero from '@/assets/signs/229-30.svg?url';
import SignTwoTwoNineHyphenThreeOne from '@/assets/signs/229-31.svg?url';
import SignTwoTwoNine from '@/assets/signs/229.svg?url';
import SignTwoThreeSeven from '@/assets/signs/237.svg?url';
import SignTwoThreeEight from '@/assets/signs/238.svg?url';
import SignTwoThreeNine from '@/assets/signs/239.svg?url';
import SignTwoFourZero from '@/assets/signs/240.svg?url';
import SignTwoFourOneHyphenThreeZero from '@/assets/signs/241-30.svg?url';
import SignTwoFourOneHyphenThreeOne from '@/assets/signs/241-31.svg?url';
import SignTwoFourTwoDotOne from '@/assets/signs/242.1.svg?url';
import SignTwoFourTwoDotTwo from '@/assets/signs/242.2.svg?url';
import SignTwoFourFourDotOne from '@/assets/signs/244.1.svg?url';
import SignTwoFourFourDotTwo from '@/assets/signs/244.2.svg?url';
import SignTwoFourFourDotThree from '@/assets/signs/244.3.svg?url';
import SignTwoFourFourDotFour from '@/assets/signs/244.4.svg?url';
import SignTwoFourFive from '@/assets/signs/245.svg?url';
import SignTwoFiveZero from '@/assets/signs/250.svg?url';
import SignTwoFiveOne from '@/assets/signs/251.svg?url';
import SignTwoFiveThree from '@/assets/signs/253.svg?url';
import SignTwoFiveFour from '@/assets/signs/254.svg?url';
import SignTwoFiveFive from '@/assets/signs/255.svg?url';
import SignTwoFiveSevenHyphenFiveZero from '@/assets/signs/257-50.svg?url';
import SignTwoFiveSevenHyphenFiveOne from '@/assets/signs/257-51.svg?url';
import SignTwoFiveSevenHyphenFiveTwo from '@/assets/signs/257-52.svg?url';
import SignTwoFiveSevenHyphenFiveThree from '@/assets/signs/257-53.svg?url';
import SignTwoFiveSevenHyphenFiveFour from '@/assets/signs/257-54.svg?url';
import SignTwoFiveSevenHyphenFiveFive from '@/assets/signs/257-55.svg?url';
import SignTwoFiveSevenHyphenFiveSix from '@/assets/signs/257-56.svg?url';
import SignTwoFiveSevenHyphenFiveSeven from '@/assets/signs/257-57.svg?url';
import SignTwoFiveSevenHyphenFiveEight from '@/assets/signs/257-58.svg?url';
import SignTwoFiveNine from '@/assets/signs/259.svg?url';
import SignTwoSixZero from '@/assets/signs/260.svg?url';
import SignTwoSixOne from '@/assets/signs/261.svg?url';
import SignTwoSixTwo from '@/assets/signs/262.svg?url';
import SignTwoSixThree from '@/assets/signs/263.svg?url';
import SignTwoSixFourHyphenTwoDotThree from '@/assets/signs/264-2.3.svg?url';
import SignTwoSixFourHyphenTwo from '@/assets/signs/264-2.svg?url';
import SignTwoSixFour from '@/assets/signs/264.svg?url';
import SignTwoSixFive from '@/assets/signs/265.svg?url';
import SignTwoSixSix from '@/assets/signs/266.svg?url';
import SignTwoSixSeven from '@/assets/signs/267.svg?url';
import SignTwoSixEight from '@/assets/signs/268.svg?url';
import SignTwoSixNine from '@/assets/signs/269.svg?url';
import SignTwoSevenZeroDotOne from '@/assets/signs/270.1.svg?url';
import SignTwoSevenZeroDotTwo from '@/assets/signs/270.2.svg?url';
import SignTwoSevenTwo from '@/assets/signs/272.svg?url';
import SignTwoSevenThree from '@/assets/signs/273.svg?url';
import SignTwoSevenFourHyphenOneZero from '@/assets/signs/274-10.svg?url';
import SignTwoSevenFourHyphenOneZeroZero from '@/assets/signs/274-100.svg?url';
import SignTwoSevenFourHyphenOneOneZero from '@/assets/signs/274-110.svg?url';
import SignTwoSevenFourHyphenOneTwoZero from '@/assets/signs/274-120.svg?url';
import SignTwoSevenFourHyphenOneThreeZero from '@/assets/signs/274-130.svg?url';
import SignTwoSevenFourHyphenTwoZero from '@/assets/signs/274-20.svg?url';
import SignTwoSevenFourHyphenThreeZero from '@/assets/signs/274-30.svg?url';
import SignTwoSevenFourHyphenFourZero from '@/assets/signs/274-40.svg?url';
import SignTwoSevenFourHyphenFive from '@/assets/signs/274-5.svg?url';
import SignTwoSevenFourHyphenFiveZero from '@/assets/signs/274-50.svg?url';
import SignTwoSevenFourHyphenSixZero from '@/assets/signs/274-60.svg?url';
import SignTwoSevenFourHyphenSevenZero from '@/assets/signs/274-70.svg?url';
import SignTwoSevenFourHyphenEightZero from '@/assets/signs/274-80.svg?url';
import SignTwoSevenFourHyphenNineZero from '@/assets/signs/274-90.svg?url';
import SignTwoSevenFourDotOneHyphenTwoZero from '@/assets/signs/274.1-20.svg?url';
import SignTwoSevenFourDotOne from '@/assets/signs/274.1.svg?url';
import SignTwoSevenFourDotTwoHyphenTwoZero from '@/assets/signs/274.2-20.svg?url';
import SignTwoSevenFourDotTwo from '@/assets/signs/274.2.svg?url';
import SignTwoSevenFive from '@/assets/signs/275.svg?url';
import SignTwoSevenSix from '@/assets/signs/276.svg?url';
import SignTwoSevenSevenDotOne from '@/assets/signs/277.1.svg?url';
import SignTwoSevenSeven from '@/assets/signs/277.svg?url';
import SignTwoSevenEightHyphenOneZero from '@/assets/signs/278-10.svg?url';
import SignTwoSevenEightHyphenOneZeroZero from '@/assets/signs/278-100.svg?url';
import SignTwoSevenEightHyphenOneOneZero from '@/assets/signs/278-110.svg?url';
import SignTwoSevenEightHyphenOneTwoZero from '@/assets/signs/278-120.svg?url';
import SignTwoSevenEightHyphenOneThreeZero from '@/assets/signs/278-130.svg?url';
import SignTwoSevenEightHyphenTwoZero from '@/assets/signs/278-20.svg?url';
import SignTwoSevenEightHyphenThreeZero from '@/assets/signs/278-30.svg?url';
import SignTwoSevenEightHyphenFourZero from '@/assets/signs/278-40.svg?url';
import SignTwoSevenEightHyphenFive from '@/assets/signs/278-5.svg?url';
import SignTwoSevenEightHyphenFiveZero from '@/assets/signs/278-50.svg?url';
import SignTwoSevenEightHyphenSixZero from '@/assets/signs/278-60.svg?url';
import SignTwoSevenEightHyphenSevenZero from '@/assets/signs/278-70.svg?url';
import SignTwoSevenEightHyphenEightZero from '@/assets/signs/278-80.svg?url';
import SignTwoSevenEightHyphenNineZero from '@/assets/signs/278-90.svg?url';
import SignTwoSevenNine from '@/assets/signs/279.svg?url';
import SignTwoEightZero from '@/assets/signs/280.svg?url';
import SignTwoEightOneDotOne from '@/assets/signs/281.1.svg?url';
import SignTwoEightOne from '@/assets/signs/281.svg?url';
import SignTwoEightTwo from '@/assets/signs/282.svg?url';
import SignTwoEightThreeHyphenOneZero from '@/assets/signs/283-10.svg?url';
import SignTwoEightThreeHyphenOneOne from '@/assets/signs/283-11.svg?url';
import SignTwoEightThreeHyphenTwoZero from '@/assets/signs/283-20.svg?url';
import SignTwoEightThreeHyphenTwoOne from '@/assets/signs/283-21.svg?url';
import SignTwoEightThreeHyphenThreeZero from '@/assets/signs/283-30.svg?url';
import SignTwoEightThreeHyphenThreeOne from '@/assets/signs/283-31.svg?url';
import SignTwoEightThree from '@/assets/signs/283.svg?url';
import SignTwoEightSixHyphenOneZero from '@/assets/signs/286-10.svg?url';
import SignTwoEightSixHyphenOneOne from '@/assets/signs/286-11.svg?url';
import SignTwoEightSixHyphenTwoZero from '@/assets/signs/286-20.svg?url';
import SignTwoEightSixHyphenTwoOne from '@/assets/signs/286-21.svg?url';
import SignTwoEightSixHyphenThreeZero from '@/assets/signs/286-30.svg?url';
import SignTwoEightSixHyphenThreeOne from '@/assets/signs/286-31.svg?url';
import SignTwoEightSix from '@/assets/signs/286.svg?url';
import SignTwoNineZeroDotOne from '@/assets/signs/290.1.svg?url';
import SignTwoNineZeroDotTwo from '@/assets/signs/290.2.svg?url';
import SignTwoNineThree from '@/assets/signs/293.svg?url';
import SignTwoNineFour from '@/assets/signs/294.svg?url';
import SignTwoNineFive from '@/assets/signs/295.svg?url';
import SignTwoNineSix from '@/assets/signs/296.svg?url';
import SignTwoNineSevenDotOne from '@/assets/signs/297.1.svg?url';
import SignTwoNineSeven from '@/assets/signs/297.svg?url';
import SignTwoNineEight from '@/assets/signs/298.svg?url';
import SignTwoNineNine from '@/assets/signs/299.svg?url';
import SignThreeZeroOne from '@/assets/signs/301.svg?url';
import SignThreeZeroSix from '@/assets/signs/306.svg?url';
import SignThreeZeroSeven from '@/assets/signs/307.svg?url';
import SignThreeZeroEight from '@/assets/signs/308.svg?url';
import SignThreeOneZero from '@/assets/signs/310.svg?url';
import SignThreeOneOne from '@/assets/signs/311.svg?url';
import SignThreeOneFourHyphenOneZero from '@/assets/signs/314-10.svg?url';
import SignThreeOneFourHyphenTwoZero from '@/assets/signs/314-20.svg?url';
import SignThreeOneFourHyphenThreeZero from '@/assets/signs/314-30.svg?url';
import SignThreeOneFourHyphenThreeOne from '@/assets/signs/314-31.svg?url';
import SignThreeOneFourHyphenFiveZero from '@/assets/signs/314-50.svg?url';
import SignThreeOneFourDotOne from '@/assets/signs/314.1.svg?url';
import SignThreeOneFourDotTwo from '@/assets/signs/314.2.svg?url';
import SignThreeOneFour from '@/assets/signs/314.svg?url';
import SignThreeOneFiveHyphenFiveZero from '@/assets/signs/315-50.svg?url';
import SignThreeOneFiveHyphenFiveOne from '@/assets/signs/315-51.svg?url';
import SignThreeOneFiveHyphenFiveTwo from '@/assets/signs/315-52.svg?url';
import SignThreeOneFiveHyphenFiveThree from '@/assets/signs/315-53.svg?url';
import SignThreeOneFiveHyphenFiveFive from '@/assets/signs/315-55.svg?url';
import SignThreeOneFiveHyphenFiveSix from '@/assets/signs/315-56.svg?url';
import SignThreeOneFiveHyphenFiveSeven from '@/assets/signs/315-57.svg?url';
import SignThreeOneFiveHyphenFiveEight from '@/assets/signs/315-58.svg?url';
import SignThreeOneFiveHyphenSixZero from '@/assets/signs/315-60.svg?url';
import SignThreeOneFiveHyphenSixOne from '@/assets/signs/315-61.svg?url';
import SignThreeOneFiveHyphenSixTwo from '@/assets/signs/315-62.svg?url';
import SignThreeOneFiveHyphenSixThree from '@/assets/signs/315-63.svg?url';
import SignThreeOneFiveHyphenSixFive from '@/assets/signs/315-65.svg?url';
import SignThreeOneFiveHyphenSixSix from '@/assets/signs/315-66.svg?url';
import SignThreeOneFiveHyphenSixSeven from '@/assets/signs/315-67.svg?url';
import SignThreeOneFiveHyphenSixEight from '@/assets/signs/315-68.svg?url';
import SignThreeOneFiveHyphenSevenZero from '@/assets/signs/315-70.svg?url';
import SignThreeOneFiveHyphenSevenOne from '@/assets/signs/315-71.svg?url';
import SignThreeOneFiveHyphenSevenTwo from '@/assets/signs/315-72.svg?url';
import SignThreeOneFiveHyphenSevenThree from '@/assets/signs/315-73.svg?url';
import SignThreeOneFiveHyphenSevenFive from '@/assets/signs/315-75.svg?url';
import SignThreeOneFiveHyphenSevenSix from '@/assets/signs/315-76.svg?url';
import SignThreeOneFiveHyphenSevenSeven from '@/assets/signs/315-77.svg?url';
import SignThreeOneFiveHyphenSevenEight from '@/assets/signs/315-78.svg?url';
import SignThreeOneFiveHyphenEightZero from '@/assets/signs/315-80.svg?url';
import SignThreeOneFiveHyphenEightOne from '@/assets/signs/315-81.svg?url';
import SignThreeOneFiveHyphenEightTwo from '@/assets/signs/315-82.svg?url';
import SignThreeOneFiveHyphenEightThree from '@/assets/signs/315-83.svg?url';
import SignThreeOneFiveHyphenEightFive from '@/assets/signs/315-85.svg?url';
import SignThreeOneFiveHyphenEightSix from '@/assets/signs/315-86.svg?url';
import SignThreeOneFiveHyphenEightSeven from '@/assets/signs/315-87.svg?url';
import SignThreeOneFiveHyphenEightEight from '@/assets/signs/315-88.svg?url';
import SignThreeOneSixHyphenFiveZero from '@/assets/signs/316-50.svg?url';
import SignThreeOneSix from '@/assets/signs/316.svg?url';
import SignThreeOneSeven from '@/assets/signs/317.svg?url';
import SignThreeOneEight from '@/assets/signs/318.svg?url';
import SignThreeTwoFiveDotOne from '@/assets/signs/325.1.svg?url';
import SignThreeTwoFiveDotTwo from '@/assets/signs/325.2.svg?url';
import SignThreeTwoSevenHyphenFiveZero from '@/assets/signs/327-50.svg?url';
import SignThreeTwoSevenHyphenFiveOne from '@/assets/signs/327-51.svg?url';
import SignThreeTwoSeven from '@/assets/signs/327.svg?url';
import SignThreeTwoEight from '@/assets/signs/328.svg?url';
import SignThreeThreeZeroDotOne from '@/assets/signs/330.1.svg?url';
import SignThreeThreeZeroDotTwo from '@/assets/signs/330.2.svg?url';
import SignThreeThreeOneDotOne from '@/assets/signs/331.1.svg?url';
import SignThreeThreeOneDotTwo from '@/assets/signs/331.2.svg?url';
import SignThreeThreeTwoDotOneHyphenTwoZero from '@/assets/signs/332.1-20.svg?url';
import SignThreeThreeTwoDotOne from '@/assets/signs/332.1.svg?url';
import SignThreeThreeTwo from '@/assets/signs/332.svg?url';
import SignThreeThreeThreeDotOneHyphenTwoZero from '@/assets/signs/333.1-20.svg?url';
import SignThreeThreeThreeDotOne from '@/assets/signs/333.1.svg?url';
import SignThreeThreeThree from '@/assets/signs/333.svg?url';
import SignThreeFourZero from '@/assets/signs/340.svg?url';
import SignThreeFourOne from '@/assets/signs/341.svg?url';
import SignThreeFourTwo from '@/assets/signs/342.svg?url';
import SignThreeFiveZeroHyphenOneZero from '@/assets/signs/350-10.svg?url';
import SignThreeFiveZeroHyphenTwoZero from '@/assets/signs/350-20.svg?url';
import SignThreeFiveZeroDotOne from '@/assets/signs/350.1.svg?url';
import SignThreeFiveZeroDotTwo from '@/assets/signs/350.2.svg?url';
import SignThreeFiveFour from '@/assets/signs/354.svg?url';
import SignThreeFiveSix from '@/assets/signs/356.svg?url';
import SignThreeFiveSevenHyphenFiveZero from '@/assets/signs/357-50.svg?url';
import SignThreeFiveSevenHyphenFiveOne from '@/assets/signs/357-51.svg?url';
import SignThreeFiveSevenHyphenFiveTwo from '@/assets/signs/357-52.svg?url';
import SignThreeFiveSeven from '@/assets/signs/357.svg?url';
import SignThreeFiveEight from '@/assets/signs/358.svg?url';
import SignThreeSixThree from '@/assets/signs/363.svg?url';
import SignThreeSixFiveHyphenFiveZero from '@/assets/signs/365-50.svg?url';
import SignThreeSixFiveHyphenFiveOne from '@/assets/signs/365-51.svg?url';
import SignThreeSixFiveHyphenFiveTwo from '@/assets/signs/365-52.svg?url';
import SignThreeSixFiveHyphenFiveThree from '@/assets/signs/365-53.svg?url';
import SignThreeSixFiveHyphenFiveFour from '@/assets/signs/365-54.svg?url';
import SignThreeSixFiveHyphenFiveFive from '@/assets/signs/365-55.svg?url';
import SignThreeSixFiveHyphenFiveSix from '@/assets/signs/365-56.svg?url';
import SignThreeSixFiveHyphenFiveSeven from '@/assets/signs/365-57.svg?url';
import SignThreeSixFiveHyphenFiveEight from '@/assets/signs/365-58.svg?url';
import SignThreeSixFiveHyphenFiveNine from '@/assets/signs/365-59.svg?url';
import SignThreeSixFiveHyphenSixZero from '@/assets/signs/365-60.svg?url';
import SignThreeSixFiveHyphenSixOne from '@/assets/signs/365-61.svg?url';
import SignThreeSixFiveHyphenSixTwo from '@/assets/signs/365-62.svg?url';
import SignThreeSixFiveHyphenSixThree from '@/assets/signs/365-63.svg?url';
import SignThreeSixFiveHyphenSixFour from '@/assets/signs/365-64.svg?url';
import SignThreeSixFiveHyphenSixFive from '@/assets/signs/365-65.svg?url';
import SignThreeSixFiveHyphenSixSix from '@/assets/signs/365-66.svg?url';
import SignThreeSixFiveHyphenSixSeven from '@/assets/signs/365-67.svg?url';
import SignThreeSixFiveHyphenSixEight from '@/assets/signs/365-68.svg?url';
import SignThreeSixFiveHyphenSixNine from '@/assets/signs/365-69.svg?url';
import SignThreeSixFiveHyphenSevenZero from '@/assets/signs/365-70.svg?url';
import SignThreeSixFiveHyphenSevenOne from '@/assets/signs/365-71.svg?url';
import SignThreeEightFive from '@/assets/signs/385.svg?url';
import SignThreeEightSixDotOneHyphenOneZero from '@/assets/signs/386.1-10.svg?url';
import SignThreeEightSixDotOneHyphenOneOne from '@/assets/signs/386.1-11.svg?url';
import SignThreeEightSixDotOneHyphenOneTwo from '@/assets/signs/386.1-12.svg?url';
import SignThreeEightSixDotOneHyphenTwoZero from '@/assets/signs/386.1-20.svg?url';
import SignThreeEightSixDotOneHyphenTwoOne from '@/assets/signs/386.1-21.svg?url';
import SignThreeEightSixDotOneHyphenTwoTwo from '@/assets/signs/386.1-22.svg?url';
import SignThreeEightSixDotOneHyphenThreeZero from '@/assets/signs/386.1-30.svg?url';
import SignThreeEightSixDotOneHyphenFiveZero from '@/assets/signs/386.1-50.svg?url';
import SignThreeEightSixDotOneHyphenFiveOne from '@/assets/signs/386.1-51.svg?url';
import SignThreeEightSixDotOneHyphenFiveTwo from '@/assets/signs/386.1-52.svg?url';
import SignThreeEightSixDotOneHyphenFiveThree from '@/assets/signs/386.1-53.svg?url';
import SignThreeEightSixDotOne from '@/assets/signs/386.1.svg?url';
import SignThreeEightSixDotTwoHyphenOneZero from '@/assets/signs/386.2-10.svg?url';
import SignThreeEightSixDotTwoHyphenOneOne from '@/assets/signs/386.2-11.svg?url';
import SignThreeEightSixDotTwoHyphenOneTwo from '@/assets/signs/386.2-12.svg?url';
import SignThreeEightSixDotTwoHyphenTwoZero from '@/assets/signs/386.2-20.svg?url';
import SignThreeEightSixDotTwoHyphenTwoOne from '@/assets/signs/386.2-21.svg?url';
import SignThreeEightSixDotTwoHyphenTwoTwo from '@/assets/signs/386.2-22.svg?url';
import SignThreeEightSixDotTwoHyphenThreeZero from '@/assets/signs/386.2-30.svg?url';
import SignThreeEightSixDotTwoHyphenFiveOne from '@/assets/signs/386.2-51.svg?url';
import SignThreeEightSixDotTwoHyphenFiveTwo from '@/assets/signs/386.2-52.svg?url';
import SignThreeEightSixDotTwoHyphenFiveThree from '@/assets/signs/386.2-53.svg?url';
import SignThreeEightSixDotTwo from '@/assets/signs/386.2.svg?url';
import SignThreeEightSixDotThreeHyphenFiveZero from '@/assets/signs/386.3-50.svg?url';
import SignThreeEightSixDotThree from '@/assets/signs/386.3.svg?url';
import SignThreeNineZeroDotTwo from '@/assets/signs/390.2.svg?url';
import SignThreeNineZero from '@/assets/signs/390.svg?url';
import SignThreeNineOne from '@/assets/signs/391.svg?url';
import SignThreeNineTwo from '@/assets/signs/392.svg?url';
import SignThreeNineThree from '@/assets/signs/393.svg?url';
import SignThreeNineFourHyphenFiveZero from '@/assets/signs/394-50.svg?url';
import SignThreeNineFour from '@/assets/signs/394.svg?url';
import SignFourZeroOne from '@/assets/signs/401.svg?url';
import SignFourZeroFive from '@/assets/signs/405.svg?url';
import SignFourZeroSixHyphenFiveZero from '@/assets/signs/406-50.svg?url';
import SignFourZeroSixHyphenFiveOne from '@/assets/signs/406-51.svg?url';
import SignFourOneZero from '@/assets/signs/410.svg?url';
import SignFourOneFiveHyphenOneZero from '@/assets/signs/415-10.svg?url';
import SignFourOneFiveHyphenTwoZero from '@/assets/signs/415-20.svg?url';
import SignFourOneEightHyphenOneZero from '@/assets/signs/418-10.svg?url';
import SignFourOneEightHyphenTwoZero from '@/assets/signs/418-20.svg?url';
import SignFourOneNineHyphenOneZero from '@/assets/signs/419-10.svg?url';
import SignFourOneNineHyphenTwoZero from '@/assets/signs/419-20.svg?url';
import SignFourTwoOneHyphenOneZero from '@/assets/signs/421-10.svg?url';
import SignFourTwoOneHyphenOneOne from '@/assets/signs/421-11.svg?url';
import SignFourTwoOneHyphenOneTwo from '@/assets/signs/421-12.svg?url';
import SignFourTwoOneHyphenTwoZero from '@/assets/signs/421-20.svg?url';
import SignFourTwoOneHyphenTwoOne from '@/assets/signs/421-21.svg?url';
import SignFourTwoOneHyphenTwoTwo from '@/assets/signs/421-22.svg?url';
import SignFourTwoTwoHyphenOneZero from '@/assets/signs/422-10.svg?url';
import SignFourTwoTwoHyphenOneOne from '@/assets/signs/422-11.svg?url';
import SignFourTwoTwoHyphenOneTwo from '@/assets/signs/422-12.svg?url';
import SignFourTwoTwoHyphenOneThree from '@/assets/signs/422-13.svg?url';
import SignFourTwoTwoHyphenOneFour from '@/assets/signs/422-14.svg?url';
import SignFourTwoTwoHyphenOneFive from '@/assets/signs/422-15.svg?url';
import SignFourTwoTwoHyphenOneSix from '@/assets/signs/422-16.svg?url';
import SignFourTwoTwoHyphenOneSeven from '@/assets/signs/422-17.svg?url';
import SignFourTwoTwoHyphenTwoZero from '@/assets/signs/422-20.svg?url';
import SignFourTwoTwoHyphenTwoOne from '@/assets/signs/422-21.svg?url';
import SignFourTwoTwoHyphenTwoTwo from '@/assets/signs/422-22.svg?url';
import SignFourTwoTwoHyphenTwoThree from '@/assets/signs/422-23.svg?url';
import SignFourTwoTwoHyphenTwoFour from '@/assets/signs/422-24.svg?url';
import SignFourTwoTwoHyphenTwoFive from '@/assets/signs/422-25.svg?url';
import SignFourTwoTwoHyphenTwoSix from '@/assets/signs/422-26.svg?url';
import SignFourTwoTwoHyphenTwoSeven from '@/assets/signs/422-27.svg?url';
import SignFourTwoTwoHyphenThreeZero from '@/assets/signs/422-30.svg?url';
import SignFourTwoTwoHyphenThreeTwo from '@/assets/signs/422-32.svg?url';
import SignFourTwoTwoHyphenThreeFour from '@/assets/signs/422-34.svg?url';
import SignFourTwoTwoHyphenThreeSix from '@/assets/signs/422-36.svg?url';
import SignFourThreeZeroHyphenOneZero from '@/assets/signs/430-10.svg?url';
import SignFourThreeZeroHyphenTwoZero from '@/assets/signs/430-20.svg?url';
import SignFourThreeTwoHyphenOneZero from '@/assets/signs/432-10.svg?url';
import SignFourThreeTwoHyphenTwoZero from '@/assets/signs/432-20.svg?url';
import SignFourThreeFourHyphenFiveZero from '@/assets/signs/434-50.svg?url';
import SignFourThreeFourHyphenFiveOne from '@/assets/signs/434-51.svg?url';
import SignFourThreeFourHyphenFiveTwo from '@/assets/signs/434-52.svg?url';
import SignFourThreeFourHyphenFiveThree from '@/assets/signs/434-53.svg?url';
import SignFourThreeSeven from '@/assets/signs/437.svg?url';
import SignFourThreeEight from '@/assets/signs/438.svg?url';
import SignFourThreeNine from '@/assets/signs/439.svg?url';
import SignFourFourZero from '@/assets/signs/440.svg?url';
import SignFourFourOne from '@/assets/signs/441.svg?url';
import SignFourFourTwoHyphenOneZero from '@/assets/signs/442-10.svg?url';
import SignFourFourTwoHyphenOneOne from '@/assets/signs/442-11.svg?url';
import SignFourFourTwoHyphenOneTwo from '@/assets/signs/442-12.svg?url';
import SignFourFourTwoHyphenOneThree from '@/assets/signs/442-13.svg?url';
import SignFourFourTwoHyphenOneFour from '@/assets/signs/442-14.svg?url';
import SignFourFourTwoHyphenOneFive from '@/assets/signs/442-15.svg?url';
import SignFourFourTwoHyphenOneSix from '@/assets/signs/442-16.svg?url';
import SignFourFourTwoHyphenOneSeven from '@/assets/signs/442-17.svg?url';
import SignFourFourTwoHyphenTwoZero from '@/assets/signs/442-20.svg?url';
import SignFourFourTwoHyphenTwoOne from '@/assets/signs/442-21.svg?url';
import SignFourFourTwoHyphenTwoTwo from '@/assets/signs/442-22.svg?url';
import SignFourFourTwoHyphenTwoThree from '@/assets/signs/442-23.svg?url';
import SignFourFourTwoHyphenTwoFour from '@/assets/signs/442-24.svg?url';
import SignFourFourTwoHyphenTwoFive from '@/assets/signs/442-25.svg?url';
import SignFourFourTwoHyphenTwoSix from '@/assets/signs/442-26.svg?url';
import SignFourFourTwoHyphenTwoSeven from '@/assets/signs/442-27.svg?url';
import SignFourFourTwoHyphenThreeZero from '@/assets/signs/442-30.svg?url';
import SignFourFourTwoHyphenThreeOne from '@/assets/signs/442-31.svg?url';
import SignFourFourTwoHyphenThreeTwo from '@/assets/signs/442-32.svg?url';
import SignFourFourTwoHyphenThreeThree from '@/assets/signs/442-33.svg?url';
import SignFourFourTwoHyphenFiveZero from '@/assets/signs/442-50.svg?url';
import SignFourFourTwoHyphenFiveOne from '@/assets/signs/442-51.svg?url';
import SignFourFourTwoHyphenFiveTwo from '@/assets/signs/442-52.svg?url';
import SignFourFourTwoHyphenFiveThree from '@/assets/signs/442-53.svg?url';
import SignFourFourEightHyphenFiveZero from '@/assets/signs/448-50.svg?url';
import SignFourFourEightDotOne from '@/assets/signs/448.1.svg?url';
import SignFourFourEight from '@/assets/signs/448.svg?url';
import SignFourFourEightAK from '@/assets/signs/448AK.svg?url';
import SignFourFourNineHyphenFiveZero from '@/assets/signs/449-50.svg?url';
import SignFourFourNine from '@/assets/signs/449.svg?url';
import SignFourFiveZeroHyphenFiveZero from '@/assets/signs/450-50.svg?url';
import SignFourFiveZeroHyphenFiveOne from '@/assets/signs/450-51.svg?url';
import SignFourFiveZeroHyphenFiveTwo from '@/assets/signs/450-52.svg?url';
import SignFourFiveZeroHyphenFiveThree from '@/assets/signs/450-53.svg?url';
import SignFourFiveZeroHyphenFiveFour from '@/assets/signs/450-54.svg?url';
import SignFourFiveZeroHyphenFiveFive from '@/assets/signs/450-55.svg?url';
import SignFourFiveThreeHyphenFiveZero from '@/assets/signs/453-50.svg?url';
import SignFourFiveThree from '@/assets/signs/453.svg?url';
import SignFourFiveFourHyphenOneZero from '@/assets/signs/454-10.svg?url';
import SignFourFiveFourHyphenTwoZero from '@/assets/signs/454-20.svg?url';
import SignFourFiveFiveDotOneHyphenOneZero from '@/assets/signs/455.1-10.svg?url';
import SignFourFiveFiveDotOneHyphenOneOne from '@/assets/signs/455.1-11.svg?url';
import SignFourFiveFiveDotOneHyphenOneTwo from '@/assets/signs/455.1-12.svg?url';
import SignFourFiveFiveDotOneHyphenOneThree from '@/assets/signs/455.1-13.svg?url';
import SignFourFiveFiveDotOneHyphenTwoZero from '@/assets/signs/455.1-20.svg?url';
import SignFourFiveFiveDotOneHyphenTwoOne from '@/assets/signs/455.1-21.svg?url';
import SignFourFiveFiveDotOneHyphenTwoTwo from '@/assets/signs/455.1-22.svg?url';
import SignFourFiveFiveDotOneHyphenTwoThree from '@/assets/signs/455.1-23.svg?url';
import SignFourFiveFiveDotOneHyphenThreeZero from '@/assets/signs/455.1-30.svg?url';
import SignFourFiveFiveDotOneHyphenThreeOne from '@/assets/signs/455.1-31.svg?url';
import SignFourFiveFiveDotOneHyphenFiveZero from '@/assets/signs/455.1-50.svg?url';
import SignFourFiveFiveDotTwo from '@/assets/signs/455.2.svg?url';
import SignFourFiveSevenDotOne from '@/assets/signs/457.1.svg?url';
import SignFourFiveSevenDotTwo from '@/assets/signs/457.2.svg?url';
import SignFourFiveEight from '@/assets/signs/458.svg?url';
import SignFourSixZeroHyphenOneZero from '@/assets/signs/460-10.svg?url';
import SignFourSixZeroHyphenOneOne from '@/assets/signs/460-11.svg?url';
import SignFourSixZeroHyphenOneTwo from '@/assets/signs/460-12.svg?url';
import SignFourSixZeroHyphenOneThree from '@/assets/signs/460-13.svg?url';
import SignFourSixZeroHyphenTwoZero from '@/assets/signs/460-20.svg?url';
import SignFourSixZeroHyphenTwoOne from '@/assets/signs/460-21.svg?url';
import SignFourSixZeroHyphenTwoTwo from '@/assets/signs/460-22.svg?url';
import SignFourSixZeroHyphenTwoThree from '@/assets/signs/460-23.svg?url';
import SignFourSixZeroHyphenThreeZero from '@/assets/signs/460-30.svg?url';
import SignFourSixZeroHyphenThreeOne from '@/assets/signs/460-31.svg?url';
import SignFourSixZeroHyphenFiveZero from '@/assets/signs/460-50.svg?url';
import SignFourSixSix from '@/assets/signs/466.svg?url';
import SignFourSixSevenDotOneHyphenOneZero from '@/assets/signs/467.1-10.svg?url';
import SignFourSixSevenDotOneHyphenTwoZero from '@/assets/signs/467.1-20.svg?url';
import SignFourSixSevenDotOneHyphenThreeZero from '@/assets/signs/467.1-30.svg?url';
import SignFourSixSevenDotTwo from '@/assets/signs/467.2.svg?url';
import SignFiveZeroOneHyphenOneZero from '@/assets/signs/501-10.svg?url';
import SignFiveZeroOneHyphenOneOne from '@/assets/signs/501-11.svg?url';
import SignFiveZeroOneHyphenOneTwo from '@/assets/signs/501-12.svg?url';
import SignFiveZeroOneHyphenOneThree from '@/assets/signs/501-13.svg?url';
import SignFiveZeroOneHyphenOneFour from '@/assets/signs/501-14.svg?url';
import SignFiveZeroOneHyphenOneFive from '@/assets/signs/501-15.svg?url';
import SignFiveZeroOneHyphenOneSix from '@/assets/signs/501-16.svg?url';
import SignFiveZeroOneHyphenOneSeven from '@/assets/signs/501-17.svg?url';
import SignFiveZeroOneHyphenOneEight from '@/assets/signs/501-18.svg?url';
import SignFiveZeroOneHyphenOneNine from '@/assets/signs/501-19.svg?url';
import SignFiveZeroOneHyphenTwoZero from '@/assets/signs/501-20.svg?url';
import SignFiveZeroOneHyphenTwoOne from '@/assets/signs/501-21.svg?url';
import SignFiveZeroOneHyphenTwoTwo from '@/assets/signs/501-22.svg?url';
import SignFiveZeroOneHyphenTwoThree from '@/assets/signs/501-23.svg?url';
import SignFiveZeroOneHyphenTwoFour from '@/assets/signs/501-24.svg?url';
import SignFiveZeroOneHyphenTwoFive from '@/assets/signs/501-25.svg?url';
import SignFiveZeroOneHyphenTwoSix from '@/assets/signs/501-26.svg?url';
import SignFiveZeroOneHyphenTwoSeven from '@/assets/signs/501-27.svg?url';
import SignFiveZeroOneHyphenTwoEight from '@/assets/signs/501-28.svg?url';
import SignFiveZeroOneHyphenTwoNine from '@/assets/signs/501-29.svg?url';
import SignFiveZeroOneHyphenFiveZero from '@/assets/signs/501-50.svg?url';
import SignFiveZeroOneHyphenFiveOne from '@/assets/signs/501-51.svg?url';
import SignFiveZeroOneHyphenFiveTwo from '@/assets/signs/501-52.svg?url';
import SignFiveZeroOneHyphenFiveThree from '@/assets/signs/501-53.svg?url';
import SignFiveZeroOneHyphenFiveFour from '@/assets/signs/501-54.svg?url';
import SignFiveZeroOneHyphenSixZero from '@/assets/signs/501-60.svg?url';
import SignFiveZeroOneHyphenSixOne from '@/assets/signs/501-61.svg?url';
import SignFiveZeroOneHyphenSixTwo from '@/assets/signs/501-62.svg?url';
import SignFiveZeroOneHyphenSixThree from '@/assets/signs/501-63.svg?url';
import SignFiveZeroOneHyphenSixFour from '@/assets/signs/501-64.svg?url';
import SignFiveZeroOneHyphenSevenZero from '@/assets/signs/501-70.svg?url';
import SignFiveZeroOneHyphenSevenOne from '@/assets/signs/501-71.svg?url';
import SignFiveZeroOneHyphenSevenTwo from '@/assets/signs/501-72.svg?url';
import SignFiveZeroOneHyphenSevenThree from '@/assets/signs/501-73.svg?url';
import SignFiveZeroOneHyphenSevenFour from '@/assets/signs/501-74.svg?url';
import SignFiveZeroOneHyphenSevenFive from '@/assets/signs/501-75.svg?url';
import SignFiveZeroOneHyphenEightZero from '@/assets/signs/501-80.svg?url';
import SignFiveZeroOneHyphenEightOne from '@/assets/signs/501-81.svg?url';
import SignFiveZeroOneHyphenEightTwo from '@/assets/signs/501-82.svg?url';
import SignFiveZeroOneHyphenEightThree from '@/assets/signs/501-83.svg?url';
import SignFiveZeroOneHyphenEightFour from '@/assets/signs/501-84.svg?url';
import SignFiveZeroOneHyphenEightFive from '@/assets/signs/501-85.svg?url';
import SignFiveZeroFiveHyphenOneOne from '@/assets/signs/505-11.svg?url';
import SignFiveZeroFiveHyphenOneTwo from '@/assets/signs/505-12.svg?url';
import SignFiveZeroFiveHyphenTwoOne from '@/assets/signs/505-21.svg?url';
import SignFiveZeroFiveHyphenTwoTwo from '@/assets/signs/505-22.svg?url';
import SignFiveOneOneHyphenOneZero from '@/assets/signs/511-10.svg?url';
import SignFiveOneOneHyphenOneOne from '@/assets/signs/511-11.svg?url';
import SignFiveOneOneHyphenOneTwo from '@/assets/signs/511-12.svg?url';
import SignFiveOneOneHyphenOneThree from '@/assets/signs/511-13.svg?url';
import SignFiveOneOneHyphenTwoZero from '@/assets/signs/511-20.svg?url';
import SignFiveOneOneHyphenTwoOne from '@/assets/signs/511-21.svg?url';
import SignFiveOneOneHyphenTwoTwo from '@/assets/signs/511-22.svg?url';
import SignFiveOneOneHyphenTwoThree from '@/assets/signs/511-23.svg?url';
import SignFiveOneOneHyphenTwoFive from '@/assets/signs/511-25.svg?url';
import SignFiveOneOneHyphenTwoSix from '@/assets/signs/511-26.svg?url';
import SignFiveOneOneHyphenTwoSeven from '@/assets/signs/511-27.svg?url';
import SignFiveOneOneHyphenTwoEight from '@/assets/signs/511-28.svg?url';
import SignFiveOneTwoHyphenOneZero from '@/assets/signs/512-10.svg?url';
import SignFiveOneTwoHyphenOneOne from '@/assets/signs/512-11.svg?url';
import SignFiveOneTwoHyphenOneTwo from '@/assets/signs/512-12.svg?url';
import SignFiveOneTwoHyphenTwoZero from '@/assets/signs/512-20.svg?url';
import SignFiveOneTwoHyphenTwoOne from '@/assets/signs/512-21.svg?url';
import SignFiveOneTwoHyphenTwoTwo from '@/assets/signs/512-22.svg?url';
import SignFiveOneThreeHyphenOneZero from '@/assets/signs/513-10.svg?url';
import SignFiveOneThreeHyphenOneOne from '@/assets/signs/513-11.svg?url';
import SignFiveOneThreeHyphenOneTwo from '@/assets/signs/513-12.svg?url';
import SignFiveOneThreeHyphenOneThree from '@/assets/signs/513-13.svg?url';
import SignFiveOneThreeHyphenOneFour from '@/assets/signs/513-14.svg?url';
import SignFiveOneThreeHyphenTwoZero from '@/assets/signs/513-20.svg?url';
import SignFiveOneThreeHyphenTwoOne from '@/assets/signs/513-21.svg?url';
import SignFiveOneThreeHyphenTwoTwo from '@/assets/signs/513-22.svg?url';
import SignFiveOneThreeHyphenTwoThree from '@/assets/signs/513-23.svg?url';
import SignFiveOneThreeHyphenTwoFour from '@/assets/signs/513-24.svg?url';
import SignFiveOneFourHyphenOneZero from '@/assets/signs/514-10.svg?url';
import SignFiveOneFourHyphenOneOne from '@/assets/signs/514-11.svg?url';
import SignFiveOneFourHyphenOneTwo from '@/assets/signs/514-12.svg?url';
import SignFiveOneFourHyphenOneThree from '@/assets/signs/514-13.svg?url';
import SignFiveOneFourHyphenOneFour from '@/assets/signs/514-14.svg?url';
import SignFiveOneFourHyphenOneFive from '@/assets/signs/514-15.svg?url';
import SignFiveOneFourHyphenOneSix from '@/assets/signs/514-16.svg?url';
import SignFiveOneFourHyphenOneSeven from '@/assets/signs/514-17.svg?url';
import SignFiveOneFourHyphenOneEight from '@/assets/signs/514-18.svg?url';
import SignFiveOneFourHyphenTwoZero from '@/assets/signs/514-20.svg?url';
import SignFiveOneFourHyphenTwoOne from '@/assets/signs/514-21.svg?url';
import SignFiveOneFourHyphenTwoTwo from '@/assets/signs/514-22.svg?url';
import SignFiveOneFourHyphenTwoThree from '@/assets/signs/514-23.svg?url';
import SignFiveOneFourHyphenTwoFour from '@/assets/signs/514-24.svg?url';
import SignFiveOneFourHyphenTwoFive from '@/assets/signs/514-25.svg?url';
import SignFiveOneFourHyphenTwoSix from '@/assets/signs/514-26.svg?url';
import SignFiveOneFourHyphenTwoSeven from '@/assets/signs/514-27.svg?url';
import SignFiveOneFourHyphenTwoEight from '@/assets/signs/514-28.svg?url';
import SignFiveOneFiveHyphenOneOne from '@/assets/signs/515-11.svg?url';
import SignFiveOneFiveHyphenOneTwo from '@/assets/signs/515-12.svg?url';
import SignFiveOneFiveHyphenTwoOne from '@/assets/signs/515-21.svg?url';
import SignFiveOneFiveHyphenTwoTwo from '@/assets/signs/515-22.svg?url';
import SignFiveTwoOneHyphenThreeZero from '@/assets/signs/521-30.svg?url';
import SignFiveTwoOneHyphenThreeOne from '@/assets/signs/521-31.svg?url';
import SignFiveTwoOneHyphenThreeTwo from '@/assets/signs/521-32.svg?url';
import SignFiveTwoOneHyphenThreeThree from '@/assets/signs/521-33.svg?url';
import SignFiveTwoTwoHyphenThreeZero from '@/assets/signs/522-30.svg?url';
import SignFiveTwoTwoHyphenThreeOne from '@/assets/signs/522-31.svg?url';
import SignFiveTwoTwoHyphenThreeTwo from '@/assets/signs/522-32.svg?url';
import SignFiveTwoTwoHyphenThreeThree from '@/assets/signs/522-33.svg?url';
import SignFiveTwoTwoHyphenThreeFour from '@/assets/signs/522-34.svg?url';
import SignFiveTwoTwoHyphenThreeFive from '@/assets/signs/522-35.svg?url';
import SignFiveTwoTwoHyphenThreeSix from '@/assets/signs/522-36.svg?url';
import SignFiveTwoTwoHyphenThreeSeven from '@/assets/signs/522-37.svg?url';
import SignFiveTwoTwoHyphenThreeEight from '@/assets/signs/522-38.svg?url';
import SignFiveTwoThreeHyphenThreeZero from '@/assets/signs/523-30.svg?url';
import SignFiveTwoThreeHyphenThreeOne from '@/assets/signs/523-31.svg?url';
import SignFiveTwoFourHyphenThreeZero from '@/assets/signs/524-30.svg?url';
import SignFiveTwoFourHyphenThreeOne from '@/assets/signs/524-31.svg?url';
import SignFiveTwoFourHyphenThreeTwo from '@/assets/signs/524-32.svg?url';
import SignFiveTwoFourHyphenThreeThree from '@/assets/signs/524-33.svg?url';
import SignFiveTwoFiveHyphenThreeOne from '@/assets/signs/525-31.svg?url';
import SignFiveTwoSixHyphenThreeOne from '@/assets/signs/526-31.svg?url';
import SignFiveTwoSixHyphenThreeThree from '@/assets/signs/526-33.svg?url';
import SignFiveTwoSevenHyphenThreeZero from '@/assets/signs/527-30.svg?url';
import SignFiveTwoSevenHyphenThreeOne from '@/assets/signs/527-31.svg?url';
import SignFiveTwoEightHyphenThreeZero from '@/assets/signs/528-30.svg?url';
import SignFiveTwoEightHyphenThreeOne from '@/assets/signs/528-31.svg?url';
import SignFiveTwoNineHyphenThreeZero from '@/assets/signs/529-30.svg?url';
import SignFiveTwoNineHyphenThreeOne from '@/assets/signs/529-31.svg?url';
import SignFiveThreeOneHyphenOneZero from '@/assets/signs/531-10.svg?url';
import SignFiveThreeOneHyphenOneOne from '@/assets/signs/531-11.svg?url';
import SignFiveThreeOneHyphenOneTwo from '@/assets/signs/531-12.svg?url';
import SignFiveThreeOneHyphenOneThree from '@/assets/signs/531-13.svg?url';
import SignFiveThreeOneHyphenOneFour from '@/assets/signs/531-14.svg?url';
import SignFiveThreeOneHyphenOneFive from '@/assets/signs/531-15.svg?url';
import SignFiveThreeOneHyphenOneSix from '@/assets/signs/531-16.svg?url';
import SignFiveThreeOneHyphenTwoZero from '@/assets/signs/531-20.svg?url';
import SignFiveThreeOneHyphenTwoOne from '@/assets/signs/531-21.svg?url';
import SignFiveThreeOneHyphenTwoTwo from '@/assets/signs/531-22.svg?url';
import SignFiveThreeOneHyphenTwoThree from '@/assets/signs/531-23.svg?url';
import SignFiveThreeOneHyphenTwoFour from '@/assets/signs/531-24.svg?url';
import SignFiveThreeOneHyphenTwoFive from '@/assets/signs/531-25.svg?url';
import SignFiveThreeOneHyphenTwoSix from '@/assets/signs/531-26.svg?url';
import SignFiveThreeTwoHyphenOneZero from '@/assets/signs/532-10.svg?url';
import SignFiveThreeTwoHyphenTwoZero from '@/assets/signs/532-20.svg?url';
import SignFiveThreeTwoHyphenTwoOne from '@/assets/signs/532-21.svg?url';
import SignFiveThreeThreeHyphenTwoZero from '@/assets/signs/533-20.svg?url';
import SignFiveThreeThreeHyphenTwoOne from '@/assets/signs/533-21.svg?url';
import SignFiveThreeThreeHyphenTwoTwo from '@/assets/signs/533-22.svg?url';
import SignFiveThreeThreeHyphenTwoThree from '@/assets/signs/533-23.svg?url';
import SignFiveThreeThreeHyphenTwoFour from '@/assets/signs/533-24.svg?url';
import SignFiveThreeThreeHyphenTwoFive from '@/assets/signs/533-25.svg?url';
import SignFiveThreeThreeHyphenTwoSix from '@/assets/signs/533-26.svg?url';
import SignFiveThreeThreeHyphenTwoSeven from '@/assets/signs/533-27.svg?url';
import SignFiveThreeThreeHyphenTwoEight from '@/assets/signs/533-28.svg?url';
import SignFiveThreeThreeHyphenTwoNine from '@/assets/signs/533-29.svg?url';
import SignFiveThreeThreeHyphenSixZero from '@/assets/signs/533-60.svg?url';
import SignFiveThreeThreeHyphenSixOne from '@/assets/signs/533-61.svg?url';
import SignFiveThreeThreeHyphenSixTwo from '@/assets/signs/533-62.svg?url';
import SignFiveThreeThreeHyphenSixThree from '@/assets/signs/533-63.svg?url';
import SignFiveThreeFiveHyphenOneOne from '@/assets/signs/535-11.svg?url';
import SignFiveThreeFiveHyphenTwoOne from '@/assets/signs/535-21.svg?url';
import SignFiveThreeSixHyphenTwoZero from '@/assets/signs/536-20.svg?url';
import SignFiveThreeSixHyphenTwoOne from '@/assets/signs/536-21.svg?url';
import SignFiveThreeSevenHyphenThreeZero from '@/assets/signs/537-30.svg?url';
import SignFiveThreeSevenHyphenThreeOne from '@/assets/signs/537-31.svg?url';
import SignFiveThreeEightHyphenThreeZero from '@/assets/signs/538-30.svg?url';
import SignFiveThreeEightHyphenThreeOne from '@/assets/signs/538-31.svg?url';
import SignFiveFourOneHyphenOneZero from '@/assets/signs/541-10.svg?url';
import SignFiveFourOneHyphenOneOne from '@/assets/signs/541-11.svg?url';
import SignFiveFourOneHyphenOneTwo from '@/assets/signs/541-12.svg?url';
import SignFiveFourOneHyphenOneThree from '@/assets/signs/541-13.svg?url';
import SignFiveFourOneHyphenTwoZero from '@/assets/signs/541-20.svg?url';
import SignFiveFourOneHyphenTwoOne from '@/assets/signs/541-21.svg?url';
import SignFiveFourOneHyphenTwoTwo from '@/assets/signs/541-22.svg?url';
import SignFiveFourOneHyphenTwoThree from '@/assets/signs/541-23.svg?url';
import SignFiveFourTwoHyphenOneZero from '@/assets/signs/542-10.svg?url';
import SignFiveFourTwoHyphenOneOne from '@/assets/signs/542-11.svg?url';
import SignFiveFourTwoHyphenOneTwo from '@/assets/signs/542-12.svg?url';
import SignFiveFourTwoHyphenOneThree from '@/assets/signs/542-13.svg?url';
import SignFiveFourTwoHyphenOneFour from '@/assets/signs/542-14.svg?url';
import SignFiveFourTwoHyphenOneFive from '@/assets/signs/542-15.svg?url';
import SignFiveFourFiveHyphenOneOne from '@/assets/signs/545-11.svg?url';
import SignFiveFourSixHyphenOneZero from '@/assets/signs/546-10.svg?url';
import SignFiveFourSixHyphenOneOne from '@/assets/signs/546-11.svg?url';
import SignFiveFiveZeroHyphenTwoZero from '@/assets/signs/550-20.svg?url';
import SignFiveFiveZeroHyphenTwoOne from '@/assets/signs/550-21.svg?url';
import SignFiveFiveZeroHyphenTwoTwo from '@/assets/signs/550-22.svg?url';
import SignFiveFiveZeroHyphenTwoThree from '@/assets/signs/550-23.svg?url';
import SignFiveFiveZeroHyphenTwoFour from '@/assets/signs/550-24.svg?url';
import SignFiveFiveZeroHyphenTwoFive from '@/assets/signs/550-25.svg?url';
import SignFiveFiveZeroHyphenTwoSix from '@/assets/signs/550-26.svg?url';
import SignFiveFiveZeroHyphenTwoSeven from '@/assets/signs/550-27.svg?url';
import SignFiveFiveZeroHyphenTwoEight from '@/assets/signs/550-28.svg?url';
import SignFiveFiveZeroHyphenTwoNine from '@/assets/signs/550-29.svg?url';
import SignFiveFiveZeroHyphenSixZero from '@/assets/signs/550-60.svg?url';
import SignFiveFiveOneHyphenTwoZero from '@/assets/signs/551-20.svg?url';
import SignFiveFiveOneHyphenTwoOne from '@/assets/signs/551-21.svg?url';
import SignFiveFiveOneHyphenTwoTwo from '@/assets/signs/551-22.svg?url';
import SignFiveFiveOneHyphenTwoThree from '@/assets/signs/551-23.svg?url';
import SignFiveFiveOneHyphenTwoFour from '@/assets/signs/551-24.svg?url';
import SignFiveFiveOneHyphenTwoFive from '@/assets/signs/551-25.svg?url';
import SignFiveFiveOneHyphenTwoSix from '@/assets/signs/551-26.svg?url';
import SignFiveFiveOneHyphenTwoSeven from '@/assets/signs/551-27.svg?url';
import SignFiveFiveOneHyphenTwoEight from '@/assets/signs/551-28.svg?url';
import SignFiveFiveOneHyphenTwoNine from '@/assets/signs/551-29.svg?url';
import SignFiveFiveOneHyphenSixZero from '@/assets/signs/551-60.svg?url';
import SignFiveNineZeroHyphenOneZero from '@/assets/signs/590-10.svg?url';
import SignFiveNineZeroHyphenOneOne from '@/assets/signs/590-11.svg?url';
import SignSixZeroZeroHyphenThreeZero from '@/assets/signs/600-30.svg?url';
import SignSixZeroZeroHyphenThreeOne from '@/assets/signs/600-31.svg?url';
import SignSixZeroZeroHyphenThreeTwo from '@/assets/signs/600-32.svg?url';
import SignSixZeroZeroHyphenThreeThree from '@/assets/signs/600-33.svg?url';
import SignSixZeroZeroHyphenThreeFour from '@/assets/signs/600-34.svg?url';
import SignSixZeroZeroHyphenThreeFive from '@/assets/signs/600-35.svg?url';
import SignSixZeroZeroHyphenThreeSix from '@/assets/signs/600-36.svg?url';
import SignSixZeroZeroHyphenThreeSeven from '@/assets/signs/600-37.svg?url';
import SignSixZeroZeroHyphenThreeEight from '@/assets/signs/600-38.svg?url';
import SignSixZeroZeroHyphenThreeNine from '@/assets/signs/600-39.svg?url';
import SignSixZeroZeroHyphenSixZero from '@/assets/signs/600-60.svg?url';
import SignSixZeroFiveHyphenOneZero from '@/assets/signs/605-10.svg?url';
import SignSixZeroFiveHyphenOneOne from '@/assets/signs/605-11.svg?url';
import SignSixZeroFiveHyphenOneTwo from '@/assets/signs/605-12.svg?url';
import SignSixZeroFiveHyphenOneThree from '@/assets/signs/605-13.svg?url';
import SignSixZeroFiveHyphenOneFour from '@/assets/signs/605-14.svg?url';
import SignSixZeroFiveHyphenTwoZero from '@/assets/signs/605-20.svg?url';
import SignSixZeroFiveHyphenTwoOne from '@/assets/signs/605-21.svg?url';
import SignSixZeroFiveHyphenTwoTwo from '@/assets/signs/605-22.svg?url';
import SignSixZeroFiveHyphenTwoThree from '@/assets/signs/605-23.svg?url';
import SignSixZeroFiveHyphenTwoFour from '@/assets/signs/605-24.svg?url';
import SignSixOneZeroHyphenFourZero from '@/assets/signs/610-40.svg?url';
import SignSixOneZeroHyphenFourOne from '@/assets/signs/610-41.svg?url';
import SignSixOneZeroHyphenFourTwo from '@/assets/signs/610-42.svg?url';
import SignSixOneZeroHyphenFourThree from '@/assets/signs/610-43.svg?url';
import SignSixOneFive from '@/assets/signs/615.svg?url';
import SignSixOneSixHyphenThreeZero from '@/assets/signs/616-30.svg?url';
import SignSixOneSixHyphenThreeOne from '@/assets/signs/616-31.svg?url';
import SignSixTwoZeroHyphenFourZero from '@/assets/signs/620-40.svg?url';
import SignSixTwoZeroHyphenFourOne from '@/assets/signs/620-41.svg?url';
import SignSixTwoFiveHyphenOneZero from '@/assets/signs/625-10.svg?url';
import SignSixTwoFiveHyphenOneOne from '@/assets/signs/625-11.svg?url';
import SignSixTwoFiveHyphenOneTwo from '@/assets/signs/625-12.svg?url';
import SignSixTwoFiveHyphenOneThree from '@/assets/signs/625-13.svg?url';
import SignSixTwoFiveHyphenTwoZero from '@/assets/signs/625-20.svg?url';
import SignSixTwoFiveHyphenTwoOne from '@/assets/signs/625-21.svg?url';
import SignSixTwoFiveHyphenTwoTwo from '@/assets/signs/625-22.svg?url';
import SignSixTwoFiveHyphenTwoThree from '@/assets/signs/625-23.svg?url';
import SignSixTwoSixHyphenOneZero from '@/assets/signs/626-10.svg?url';
import SignSixTwoSixHyphenTwoZero from '@/assets/signs/626-20.svg?url';
import SignSixTwoSixHyphenThreeZero from '@/assets/signs/626-30.svg?url';
import SignSixTwoSixHyphenThreeOne from '@/assets/signs/626-31.svg?url';
import SignSixTwoSixHyphenThreeTwo from '@/assets/signs/626-32.svg?url';
import SignSixTwoSevenHyphenOneZero from '@/assets/signs/627-10.svg?url';
import SignSixTwoSevenHyphenTwoZero from '@/assets/signs/627-20.svg?url';
import SignSixTwoSevenHyphenThreeZero from '@/assets/signs/627-30.svg?url';
import SignSixTwoSevenHyphenFiveZero from '@/assets/signs/627-50.svg?url';
import SignSixTwoEightHyphenOneZero from '@/assets/signs/628-10.svg?url';
import SignSixTwoEightHyphenOneOne from '@/assets/signs/628-11.svg?url';
import SignSixTwoEightHyphenTwoZero from '@/assets/signs/628-20.svg?url';
import SignSixTwoEightHyphenTwoOne from '@/assets/signs/628-21.svg?url';
import SignSixTwoNineHyphenOneZero from '@/assets/signs/629-10.svg?url';
import SignSixTwoNineHyphenOneOne from '@/assets/signs/629-11.svg?url';
import SignSixTwoNineHyphenTwoZero from '@/assets/signs/629-20.svg?url';
import SignSixTwoNineHyphenTwoOne from '@/assets/signs/629-21.svg?url';
import SignSixThreeZeroHyphenOneZero from '@/assets/signs/630-10.svg?url';
import SignSixThreeZeroHyphenTwoZero from '@/assets/signs/630-20.svg?url';
import SignSevenTwoZero from '@/assets/signs/720.svg?url';
import SignSevenTwoOne from '@/assets/signs/721.svg?url';
import SignKNrHyphenOneZeroZero from '@/assets/signs/KNr-100.svg?url';
import SignKNrHyphenOneZeroZeroa from '@/assets/signs/KNr-100a.svg?url';
import SignKNrHyphenOneZeroZerob from '@/assets/signs/KNr-100b.svg?url';
import SignKNrHyphenOneZeroOne from '@/assets/signs/KNr-101.svg?url';
import SignKNrHyphenOneZeroOnea from '@/assets/signs/KNr-101a.svg?url';
import SignKNrHyphenOneZeroOneb from '@/assets/signs/KNr-101b.svg?url';
import SignKNrHyphenOneZeroTwo from '@/assets/signs/KNr-102.svg?url';
import SignKNrHyphenOneZeroTwoa from '@/assets/signs/KNr-102a.svg?url';
import SignKNrHyphenOneZeroTwob from '@/assets/signs/KNr-102b.svg?url';
import SignKNrHyphenOneZeroThree from '@/assets/signs/KNr-103.svg?url';
import SignKNrHyphenOneZeroThreea from '@/assets/signs/KNr-103a.svg?url';
import SignKNrHyphenOneZeroThreeb from '@/assets/signs/KNr-103b.svg?url';
import SignKNrHyphenOneZeroFour from '@/assets/signs/KNr-104.svg?url';
import SignKNrHyphenOneZeroFoura from '@/assets/signs/KNr-104a.svg?url';
import SignKNrHyphenOneZeroFourb from '@/assets/signs/KNr-104b.svg?url';
import SignKNrHyphenOneZeroFive from '@/assets/signs/KNr-105.svg?url';
import SignKNrHyphenOneZeroFivea from '@/assets/signs/KNr-105a.svg?url';
import SignKNrHyphenOneZeroFiveb from '@/assets/signs/KNr-105b.svg?url';
import SignKNrHyphenOneZeroSix from '@/assets/signs/KNr-106.svg?url';
import SignKNrHyphenOneZeroSixa from '@/assets/signs/KNr-106a.svg?url';
import SignKNrHyphenOneZeroSixb from '@/assets/signs/KNr-106b.svg?url';
import SignKNrHyphenOneZeroSeven from '@/assets/signs/KNr-107.svg?url';
import SignKNrHyphenOneZeroSevena from '@/assets/signs/KNr-107a.svg?url';
import SignKNrHyphenOneZeroSevenb from '@/assets/signs/KNr-107b.svg?url';
import SignKNrHyphenOneZeroEight from '@/assets/signs/KNr-108.svg?url';
import SignKNrHyphenOneZeroEighta from '@/assets/signs/KNr-108a.svg?url';
import SignKNrHyphenOneZeroEightb from '@/assets/signs/KNr-108b.svg?url';
import SignKNrHyphenOneZeroNine from '@/assets/signs/KNr-109.svg?url';
import SignKNrHyphenOneZeroNinea from '@/assets/signs/KNr-109a.svg?url';
import SignKNrHyphenOneZeroNineb from '@/assets/signs/KNr-109b.svg?url';
import SignKNrHyphenOneOneZero from '@/assets/signs/KNr-110.svg?url';
import SignKNrHyphenOneOneZeroa from '@/assets/signs/KNr-110a.svg?url';
import SignKNrHyphenOneOneZerob from '@/assets/signs/KNr-110b.svg?url';
import SignKNrHyphenOneOneOne from '@/assets/signs/KNr-111.svg?url';
import SignKNrHyphenOneOneOnea from '@/assets/signs/KNr-111a.svg?url';
import SignKNrHyphenOneOneOneb from '@/assets/signs/KNr-111b.svg?url';
import SignKNrHyphenOneOneTwo from '@/assets/signs/KNr-112.svg?url';
import SignKNrHyphenOneOneTwoa from '@/assets/signs/KNr-112a.svg?url';
import SignKNrHyphenOneOneTwob from '@/assets/signs/KNr-112b.svg?url';
import SignKNrHyphenOneOneThree from '@/assets/signs/KNr-113.svg?url';
import SignKNrHyphenOneOneThreea from '@/assets/signs/KNr-113a.svg?url';
import SignKNrHyphenOneOneThreeb from '@/assets/signs/KNr-113b.svg?url';
import SignKNrHyphenOneOneFour from '@/assets/signs/KNr-114.svg?url';
import SignKNrHyphenOneOneFoura from '@/assets/signs/KNr-114a.svg?url';
import SignKNrHyphenOneOneFourb from '@/assets/signs/KNr-114b.svg?url';
import SignKNrHyphenOneOneFive from '@/assets/signs/KNr-115.svg?url';
import SignKNrHyphenOneOneFivea from '@/assets/signs/KNr-115a.svg?url';
import SignKNrHyphenOneOneFiveb from '@/assets/signs/KNr-115b.svg?url';
import SignKNrHyphenOneOneSix from '@/assets/signs/KNr-116.svg?url';
import SignKNrHyphenOneOneSixa from '@/assets/signs/KNr-116a.svg?url';
import SignKNrHyphenOneOneSixb from '@/assets/signs/KNr-116b.svg?url';
import SignKNrHyphenOneOneSeven from '@/assets/signs/KNr-117.svg?url';
import SignKNrHyphenOneOneSevena from '@/assets/signs/KNr-117a.svg?url';
import SignKNrHyphenOneOneSevenb from '@/assets/signs/KNr-117b.svg?url';
import SignKNrHyphenOneOneEight from '@/assets/signs/KNr-118.svg?url';
import SignKNrHyphenOneOneEighta from '@/assets/signs/KNr-118a.svg?url';
import SignKNrHyphenOneOneEightb from '@/assets/signs/KNr-118b.svg?url';
import SignKNrHyphenOneOneNine from '@/assets/signs/KNr-119.svg?url';
import SignKNrHyphenOneOneNinea from '@/assets/signs/KNr-119a.svg?url';
import SignKNrHyphenOneOneNineb from '@/assets/signs/KNr-119b.svg?url';
import SignKNrHyphenOneTwoZero from '@/assets/signs/KNr-120.svg?url';
import SignKNrHyphenOneTwoZeroa from '@/assets/signs/KNr-120a.svg?url';
import SignKNrHyphenOneTwoZerob from '@/assets/signs/KNr-120b.svg?url';
import SignKNrHyphenOneTwoOne from '@/assets/signs/KNr-121.svg?url';
import SignKNrHyphenOneTwoOnea from '@/assets/signs/KNr-121a.svg?url';
import SignKNrHyphenOneTwoOneb from '@/assets/signs/KNr-121b.svg?url';
import SignKNrHyphenOneTwoTwo from '@/assets/signs/KNr-122.svg?url';
import SignKNrHyphenOneTwoTwoa from '@/assets/signs/KNr-122a.svg?url';
import SignKNrHyphenOneTwoTwob from '@/assets/signs/KNr-122b.svg?url';
import SignKNrHyphenOneTwoThree from '@/assets/signs/KNr-123.svg?url';
import SignKNrHyphenOneTwoThreea from '@/assets/signs/KNr-123a.svg?url';
import SignKNrHyphenOneTwoThreeb from '@/assets/signs/KNr-123b.svg?url';
import SignKNrHyphenOneTwoFour from '@/assets/signs/KNr-124.svg?url';
import SignKNrHyphenOneTwoFoura from '@/assets/signs/KNr-124a.svg?url';
import SignKNrHyphenOneTwoFourb from '@/assets/signs/KNr-124b.svg?url';
import SignKNrHyphenOneTwoFive from '@/assets/signs/KNr-125.svg?url';
import SignKNrHyphenOneTwoFivea from '@/assets/signs/KNr-125a.svg?url';
import SignKNrHyphenOneTwoFiveb from '@/assets/signs/KNr-125b.svg?url';
import SignKNrHyphenOneTwoSix from '@/assets/signs/KNr-126.svg?url';
import SignKNrHyphenOneTwoSixa from '@/assets/signs/KNr-126a.svg?url';
import SignKNrHyphenOneTwoSixb from '@/assets/signs/KNr-126b.svg?url';
import SignKNrHyphenOneTwoSeven from '@/assets/signs/KNr-127.svg?url';
import SignKNrHyphenOneTwoSevena from '@/assets/signs/KNr-127a.svg?url';
import SignKNrHyphenOneTwoSevenb from '@/assets/signs/KNr-127b.svg?url';
import SignKNrHyphenOneTwoEight from '@/assets/signs/KNr-128.svg?url';
import SignKNrHyphenOneTwoEighta from '@/assets/signs/KNr-128a.svg?url';
import SignKNrHyphenOneTwoEightb from '@/assets/signs/KNr-128b.svg?url';
import SignKNrHyphenOneTwoNine from '@/assets/signs/KNr-129.svg?url';
import SignKNrHyphenOneTwoNinea from '@/assets/signs/KNr-129a.svg?url';
import SignKNrHyphenOneTwoNineb from '@/assets/signs/KNr-129b.svg?url';
import SignKNrHyphenOneThreeZero from '@/assets/signs/KNr-130.svg?url';
import SignKNrHyphenOneThreeZeroa from '@/assets/signs/KNr-130a.svg?url';
import SignKNrHyphenOneThreeZerob from '@/assets/signs/KNr-130b.svg?url';
import SignKNrHyphenOneThreeOne from '@/assets/signs/KNr-131.svg?url';
import SignKNrHyphenOneThreeOnea from '@/assets/signs/KNr-131a.svg?url';
import SignKNrHyphenOneThreeOneb from '@/assets/signs/KNr-131b.svg?url';
import SignKNrHyphenOneThreeTwo from '@/assets/signs/KNr-132.svg?url';
import SignKNrHyphenOneThreeTwoa from '@/assets/signs/KNr-132a.svg?url';
import SignKNrHyphenOneThreeTwob from '@/assets/signs/KNr-132b.svg?url';
import SignKNrHyphenOneThreeThree from '@/assets/signs/KNr-133.svg?url';
import SignKNrHyphenOneThreeThreea from '@/assets/signs/KNr-133a.svg?url';
import SignKNrHyphenOneThreeThreeb from '@/assets/signs/KNr-133b.svg?url';
import SignKNrHyphenOneThreeFour from '@/assets/signs/KNr-134.svg?url';
import SignKNrHyphenOneThreeFoura from '@/assets/signs/KNr-134a.svg?url';
import SignKNrHyphenOneThreeFourb from '@/assets/signs/KNr-134b.svg?url';
import SignKNrHyphenOneThreeFive from '@/assets/signs/KNr-135.svg?url';
import SignKNrHyphenOneThreeFivea from '@/assets/signs/KNr-135a.svg?url';
import SignKNrHyphenOneThreeFiveb from '@/assets/signs/KNr-135b.svg?url';
import SignKNrHyphenOneThreeSix from '@/assets/signs/KNr-136.svg?url';
import SignKNrHyphenOneThreeSixa from '@/assets/signs/KNr-136a.svg?url';
import SignKNrHyphenOneThreeSixb from '@/assets/signs/KNr-136b.svg?url';
import SignKNrHyphenOneThreeSeven from '@/assets/signs/KNr-137.svg?url';
import SignKNrHyphenOneThreeSevena from '@/assets/signs/KNr-137a.svg?url';
import SignKNrHyphenOneThreeSevenb from '@/assets/signs/KNr-137b.svg?url';
import SignKNrHyphenOneThreeEight from '@/assets/signs/KNr-138.svg?url';
import SignKNrHyphenOneThreeEighta from '@/assets/signs/KNr-138a.svg?url';
import SignKNrHyphenOneThreeEightb from '@/assets/signs/KNr-138b.svg?url';
import SignKNrHyphenOneThreeNine from '@/assets/signs/KNr-139.svg?url';
import SignKNrHyphenOneThreeNinea from '@/assets/signs/KNr-139a.svg?url';
import SignKNrHyphenOneThreeNineb from '@/assets/signs/KNr-139b.svg?url';
import SignKNrHyphenOneFourZero from '@/assets/signs/KNr-140.svg?url';
import SignKNrHyphenOneFourZeroa from '@/assets/signs/KNr-140a.svg?url';
import SignKNrHyphenOneFourZerob from '@/assets/signs/KNr-140b.svg?url';
import SignKNrHyphenOneFourOne from '@/assets/signs/KNr-141.svg?url';
import SignKNrHyphenOneFourOnea from '@/assets/signs/KNr-141a.svg?url';
import SignKNrHyphenOneFourOneb from '@/assets/signs/KNr-141b.svg?url';
import SignKNrHyphenOneFourTwo from '@/assets/signs/KNr-142.svg?url';
import SignKNrHyphenOneFourTwoa from '@/assets/signs/KNr-142a.svg?url';
import SignKNrHyphenOneFourTwob from '@/assets/signs/KNr-142b.svg?url';
import SignKNrHyphenOneFourThree from '@/assets/signs/KNr-143.svg?url';
import SignKNrHyphenOneFourThreea from '@/assets/signs/KNr-143a.svg?url';
import SignKNrHyphenOneFourThreeb from '@/assets/signs/KNr-143b.svg?url';
import SignKNrHyphenOneFourFour from '@/assets/signs/KNr-144.svg?url';
import SignKNrHyphenOneFourFoura from '@/assets/signs/KNr-144a.svg?url';
import SignKNrHyphenOneFourFourb from '@/assets/signs/KNr-144b.svg?url';
import SignKNrHyphenOneFourFive from '@/assets/signs/KNr-145.svg?url';
import SignKNrHyphenOneFourFivea from '@/assets/signs/KNr-145a.svg?url';
import SignKNrHyphenOneFourFiveb from '@/assets/signs/KNr-145b.svg?url';
import SignKNrHyphenOneFourSix from '@/assets/signs/KNr-146.svg?url';
import SignKNrHyphenOneFourSixa from '@/assets/signs/KNr-146a.svg?url';
import SignKNrHyphenOneFourSixb from '@/assets/signs/KNr-146b.svg?url';
import SignKNrHyphenOneFourSeven from '@/assets/signs/KNr-147.svg?url';
import SignKNrHyphenOneFourSevena from '@/assets/signs/KNr-147a.svg?url';
import SignKNrHyphenOneFourSevenb from '@/assets/signs/KNr-147b.svg?url';
import SignKNrHyphenOneFourEight from '@/assets/signs/KNr-148.svg?url';
import SignKNrHyphenOneFourEighta from '@/assets/signs/KNr-148a.svg?url';
import SignKNrHyphenOneFourEightb from '@/assets/signs/KNr-148b.svg?url';
import SignKNrHyphenOneFourNine from '@/assets/signs/KNr-149.svg?url';
import SignKNrHyphenOneFourNinea from '@/assets/signs/KNr-149a.svg?url';
import SignKNrHyphenOneFourNineb from '@/assets/signs/KNr-149b.svg?url';
import SignKNrHyphenOneFiveZero from '@/assets/signs/KNr-150.svg?url';
import SignKNrHyphenOneFiveZeroa from '@/assets/signs/KNr-150a.svg?url';
import SignKNrHyphenOneFiveZerob from '@/assets/signs/KNr-150b.svg?url';
import SignKNrHyphenOneFiveOne from '@/assets/signs/KNr-151.svg?url';
import SignKNrHyphenOneFiveOnea from '@/assets/signs/KNr-151a.svg?url';
import SignKNrHyphenOneFiveOneb from '@/assets/signs/KNr-151b.svg?url';
import SignKNrHyphenOneFiveTwo from '@/assets/signs/KNr-152.svg?url';
import SignKNrHyphenOneFiveTwoa from '@/assets/signs/KNr-152a.svg?url';
import SignKNrHyphenOneFiveTwob from '@/assets/signs/KNr-152b.svg?url';
import SignKNrHyphenOneFiveThree from '@/assets/signs/KNr-153.svg?url';
import SignKNrHyphenOneFiveThreea from '@/assets/signs/KNr-153a.svg?url';
import SignKNrHyphenOneFiveThreeb from '@/assets/signs/KNr-153b.svg?url';
import SignKNrHyphenOneFiveFour from '@/assets/signs/KNr-154.svg?url';
import SignKNrHyphenOneFiveFoura from '@/assets/signs/KNr-154a.svg?url';
import SignKNrHyphenOneFiveFourb from '@/assets/signs/KNr-154b.svg?url';
import SignKNrHyphenOneFiveFive from '@/assets/signs/KNr-155.svg?url';
import SignKNrHyphenOneFiveFivea from '@/assets/signs/KNr-155a.svg?url';
import SignKNrHyphenOneFiveFiveb from '@/assets/signs/KNr-155b.svg?url';
import SignKNrHyphenOneFiveSix from '@/assets/signs/KNr-156.svg?url';
import SignKNrHyphenOneFiveSixa from '@/assets/signs/KNr-156a.svg?url';
import SignKNrHyphenOneFiveSixb from '@/assets/signs/KNr-156b.svg?url';
import SignKNrHyphenOneFiveSeven from '@/assets/signs/KNr-157.svg?url';
import SignKNrHyphenOneFiveSevena from '@/assets/signs/KNr-157a.svg?url';
import SignKNrHyphenOneFiveSevenb from '@/assets/signs/KNr-157b.svg?url';
import SignKNrHyphenOneFiveEight from '@/assets/signs/KNr-158.svg?url';
import SignKNrHyphenOneFiveEighta from '@/assets/signs/KNr-158a.svg?url';
import SignKNrHyphenOneFiveEightb from '@/assets/signs/KNr-158b.svg?url';
import SignKNrHyphenOneFiveNine from '@/assets/signs/KNr-159.svg?url';
import SignKNrHyphenOneFiveNinea from '@/assets/signs/KNr-159a.svg?url';
import SignKNrHyphenOneFiveNineb from '@/assets/signs/KNr-159b.svg?url';
import SignKNrHyphenOneSixZero from '@/assets/signs/KNr-160.svg?url';
import SignKNrHyphenOneSixZeroa from '@/assets/signs/KNr-160a.svg?url';
import SignKNrHyphenOneSixZerob from '@/assets/signs/KNr-160b.svg?url';
import SignKNrHyphenOneSixOne from '@/assets/signs/KNr-161.svg?url';
import SignKNrHyphenOneSixOnea from '@/assets/signs/KNr-161a.svg?url';
import SignKNrHyphenOneSixOneb from '@/assets/signs/KNr-161b.svg?url';
import SignKNrHyphenOneSixTwo from '@/assets/signs/KNr-162.svg?url';
import SignKNrHyphenOneSixTwoa from '@/assets/signs/KNr-162a.svg?url';
import SignKNrHyphenOneSixTwob from '@/assets/signs/KNr-162b.svg?url';
import SignKNrHyphenOneSixThree from '@/assets/signs/KNr-163.svg?url';
import SignKNrHyphenOneSixThreea from '@/assets/signs/KNr-163a.svg?url';
import SignKNrHyphenOneSixThreeb from '@/assets/signs/KNr-163b.svg?url';
import SignKNrHyphenOneSixFour from '@/assets/signs/KNr-164.svg?url';
import SignKNrHyphenOneSixFoura from '@/assets/signs/KNr-164a.svg?url';
import SignKNrHyphenOneSixFourb from '@/assets/signs/KNr-164b.svg?url';
import SignKNrHyphenOneSixFive from '@/assets/signs/KNr-165.svg?url';
import SignKNrHyphenOneSixFivea from '@/assets/signs/KNr-165a.svg?url';
import SignKNrHyphenOneSixFiveb from '@/assets/signs/KNr-165b.svg?url';
import SignKNrHyphenOneSixSix from '@/assets/signs/KNr-166.svg?url';
import SignKNrHyphenOneSixSixa from '@/assets/signs/KNr-166a.svg?url';
import SignKNrHyphenOneSixSixb from '@/assets/signs/KNr-166b.svg?url';
import SignKNrHyphenOneSixSeven from '@/assets/signs/KNr-167.svg?url';
import SignKNrHyphenOneSixSevena from '@/assets/signs/KNr-167a.svg?url';
import SignKNrHyphenOneSixSevenb from '@/assets/signs/KNr-167b.svg?url';
import SignKNrHyphenOneSixEight from '@/assets/signs/KNr-168.svg?url';
import SignKNrHyphenOneSixEighta from '@/assets/signs/KNr-168a.svg?url';
import SignKNrHyphenOneSixEightb from '@/assets/signs/KNr-168b.svg?url';
import SignKNrHyphenOneSixNine from '@/assets/signs/KNr-169.svg?url';
import SignKNrHyphenOneSixNinea from '@/assets/signs/KNr-169a.svg?url';
import SignKNrHyphenOneSixNineb from '@/assets/signs/KNr-169b.svg?url';
import SignKNrHyphenOneSevenZero from '@/assets/signs/KNr-170.svg?url';
import SignKNrHyphenOneSevenZeroa from '@/assets/signs/KNr-170a.svg?url';
import SignKNrHyphenOneSevenZerob from '@/assets/signs/KNr-170b.svg?url';
import SignKNrHyphenOneSevenOne from '@/assets/signs/KNr-171.svg?url';
import SignKNrHyphenOneSevenOnea from '@/assets/signs/KNr-171a.svg?url';
import SignKNrHyphenOneSevenOneb from '@/assets/signs/KNr-171b.svg?url';
import SignKNrHyphenOneSevenTwo from '@/assets/signs/KNr-172.svg?url';
import SignKNrHyphenOneSevenTwoa from '@/assets/signs/KNr-172a.svg?url';
import SignKNrHyphenOneSevenTwob from '@/assets/signs/KNr-172b.svg?url';
import SignKNrHyphenOneSevenThree from '@/assets/signs/KNr-173.svg?url';
import SignKNrHyphenOneSevenThreea from '@/assets/signs/KNr-173a.svg?url';
import SignKNrHyphenOneSevenThreeb from '@/assets/signs/KNr-173b.svg?url';
import SignKNrHyphenOneSevenFour from '@/assets/signs/KNr-174.svg?url';
import SignKNrHyphenOneSevenFoura from '@/assets/signs/KNr-174a.svg?url';
import SignKNrHyphenOneSevenFourb from '@/assets/signs/KNr-174b.svg?url';
import SignKNrHyphenOneSevenFive from '@/assets/signs/KNr-175.svg?url';
import SignKNrHyphenOneSevenFivea from '@/assets/signs/KNr-175a.svg?url';
import SignKNrHyphenOneSevenFiveb from '@/assets/signs/KNr-175b.svg?url';
import SignKNrHyphenOneSevenSix from '@/assets/signs/KNr-176.svg?url';
import SignKNrHyphenOneSevenSixa from '@/assets/signs/KNr-176a.svg?url';
import SignKNrHyphenOneSevenSixb from '@/assets/signs/KNr-176b.svg?url';
import SignKNrHyphenOneSevenSeven from '@/assets/signs/KNr-177.svg?url';
import SignKNrHyphenOneSevenSevena from '@/assets/signs/KNr-177a.svg?url';
import SignKNrHyphenOneSevenSevenb from '@/assets/signs/KNr-177b.svg?url';
import SignKNrHyphenOneSevenEight from '@/assets/signs/KNr-178.svg?url';
import SignKNrHyphenOneSevenEighta from '@/assets/signs/KNr-178a.svg?url';
import SignKNrHyphenOneSevenEightb from '@/assets/signs/KNr-178b.svg?url';
import SignKNrHyphenOneSevenNine from '@/assets/signs/KNr-179.svg?url';
import SignKNrHyphenOneSevenNinea from '@/assets/signs/KNr-179a.svg?url';
import SignKNrHyphenOneSevenNineb from '@/assets/signs/KNr-179b.svg?url';
import SignKNrHyphenOneEightZero from '@/assets/signs/KNr-180.svg?url';
import SignKNrHyphenOneEightZeroa from '@/assets/signs/KNr-180a.svg?url';
import SignKNrHyphenOneEightZerob from '@/assets/signs/KNr-180b.svg?url';
import SignKNrHyphenOneEightOne from '@/assets/signs/KNr-181.svg?url';
import SignKNrHyphenOneEightOnea from '@/assets/signs/KNr-181a.svg?url';
import SignKNrHyphenOneEightOneb from '@/assets/signs/KNr-181b.svg?url';
import SignKNrHyphenOneEightTwo from '@/assets/signs/KNr-182.svg?url';
import SignKNrHyphenOneEightTwoa from '@/assets/signs/KNr-182a.svg?url';
import SignKNrHyphenOneEightTwob from '@/assets/signs/KNr-182b.svg?url';
import SignKNrHyphenOneEightThree from '@/assets/signs/KNr-183.svg?url';
import SignKNrHyphenOneEightThreea from '@/assets/signs/KNr-183a.svg?url';
import SignKNrHyphenOneEightThreeb from '@/assets/signs/KNr-183b.svg?url';
import SignKNrHyphenOneEightFour from '@/assets/signs/KNr-184.svg?url';
import SignKNrHyphenOneEightFoura from '@/assets/signs/KNr-184a.svg?url';
import SignKNrHyphenOneEightFourb from '@/assets/signs/KNr-184b.svg?url';
import SignKNrHyphenOneEightFive from '@/assets/signs/KNr-185.svg?url';
import SignKNrHyphenOneEightFivea from '@/assets/signs/KNr-185a.svg?url';
import SignKNrHyphenOneEightFiveb from '@/assets/signs/KNr-185b.svg?url';
import SignKNrHyphenOneEightSix from '@/assets/signs/KNr-186.svg?url';
import SignKNrHyphenOneEightSixa from '@/assets/signs/KNr-186a.svg?url';
import SignKNrHyphenOneEightSixb from '@/assets/signs/KNr-186b.svg?url';
import SignKNrHyphenOneEightSeven from '@/assets/signs/KNr-187.svg?url';
import SignKNrHyphenOneEightSevena from '@/assets/signs/KNr-187a.svg?url';
import SignKNrHyphenOneEightSevenb from '@/assets/signs/KNr-187b.svg?url';
import SignKNrHyphenOneEightEight from '@/assets/signs/KNr-188.svg?url';
import SignKNrHyphenOneEightEighta from '@/assets/signs/KNr-188a.svg?url';
import SignKNrHyphenOneEightEightb from '@/assets/signs/KNr-188b.svg?url';
import SignKNrHyphenOneEightNine from '@/assets/signs/KNr-189.svg?url';
import SignKNrHyphenOneEightNinea from '@/assets/signs/KNr-189a.svg?url';
import SignKNrHyphenOneEightNineb from '@/assets/signs/KNr-189b.svg?url';
import SignKNrHyphenOneNineZero from '@/assets/signs/KNr-190.svg?url';
import SignKNrHyphenOneNineZeroa from '@/assets/signs/KNr-190a.svg?url';
import SignKNrHyphenOneNineZerob from '@/assets/signs/KNr-190b.svg?url';
import SignKNrHyphenOneNineOne from '@/assets/signs/KNr-191.svg?url';
import SignKNrHyphenOneNineOnea from '@/assets/signs/KNr-191a.svg?url';
import SignKNrHyphenOneNineOneb from '@/assets/signs/KNr-191b.svg?url';
import SignKNrHyphenOneNineTwo from '@/assets/signs/KNr-192.svg?url';
import SignKNrHyphenOneNineTwoa from '@/assets/signs/KNr-192a.svg?url';
import SignKNrHyphenOneNineTwob from '@/assets/signs/KNr-192b.svg?url';
import SignKNrHyphenOneNineThree from '@/assets/signs/KNr-193.svg?url';
import SignKNrHyphenOneNineThreea from '@/assets/signs/KNr-193a.svg?url';
import SignKNrHyphenOneNineThreeb from '@/assets/signs/KNr-193b.svg?url';
import SignKNrHyphenOneNineFour from '@/assets/signs/KNr-194.svg?url';
import SignKNrHyphenOneNineFoura from '@/assets/signs/KNr-194a.svg?url';
import SignKNrHyphenOneNineFourb from '@/assets/signs/KNr-194b.svg?url';
import SignKNrHyphenOneNineFive from '@/assets/signs/KNr-195.svg?url';
import SignKNrHyphenOneNineFivea from '@/assets/signs/KNr-195a.svg?url';
import SignKNrHyphenOneNineFiveb from '@/assets/signs/KNr-195b.svg?url';
import SignKNrHyphenOneNineSix from '@/assets/signs/KNr-196.svg?url';
import SignKNrHyphenOneNineSixa from '@/assets/signs/KNr-196a.svg?url';
import SignKNrHyphenOneNineSixb from '@/assets/signs/KNr-196b.svg?url';
import SignKNrHyphenOneNineSeven from '@/assets/signs/KNr-197.svg?url';
import SignKNrHyphenOneNineSevena from '@/assets/signs/KNr-197a.svg?url';
import SignKNrHyphenOneNineSevenb from '@/assets/signs/KNr-197b.svg?url';
import SignKNrHyphenOneNineEight from '@/assets/signs/KNr-198.svg?url';
import SignKNrHyphenOneNineEighta from '@/assets/signs/KNr-198a.svg?url';
import SignKNrHyphenOneNineEightb from '@/assets/signs/KNr-198b.svg?url';
import SignKNrHyphenOneNineNine from '@/assets/signs/KNr-199.svg?url';
import SignKNrHyphenOneNineNinea from '@/assets/signs/KNr-199a.svg?url';
import SignKNrHyphenOneNineNineb from '@/assets/signs/KNr-199b.svg?url';
import SignkNrHyphenZeroZeroOne from '@/assets/signs/kNr-001.svg?url';
import SignkNrHyphenZeroZeroTwo from '@/assets/signs/kNr-002.svg?url';
import SignkNrHyphenZeroZeroThree from '@/assets/signs/kNr-003.svg?url';
import SignkNrHyphenZeroZeroFour from '@/assets/signs/kNr-004.svg?url';
import SignkNrHyphenZeroZeroFive from '@/assets/signs/kNr-005.svg?url';
import SignkNrHyphenZeroZeroSix from '@/assets/signs/kNr-006.svg?url';
import SignkNrHyphenZeroZeroSeven from '@/assets/signs/kNr-007.svg?url';
import SignkNrHyphenZeroZeroEight from '@/assets/signs/kNr-008.svg?url';
import SignkNrHyphenZeroZeroNine from '@/assets/signs/kNr-009.svg?url';
import SignkNrHyphenZeroOneZero from '@/assets/signs/kNr-010.svg?url';
import SignkNrHyphenZeroOneOne from '@/assets/signs/kNr-011.svg?url';
import SignkNrHyphenZeroOneTwo from '@/assets/signs/kNr-012.svg?url';
import SignkNrHyphenZeroOneThree from '@/assets/signs/kNr-013.svg?url';
import SignkNrHyphenZeroOneFour from '@/assets/signs/kNr-014.svg?url';
import SignkNrHyphenZeroOneFive from '@/assets/signs/kNr-015.svg?url';
import SignkNrHyphenZeroOneSix from '@/assets/signs/kNr-016.svg?url';
import SignkNrHyphenZeroOneSeven from '@/assets/signs/kNr-017.svg?url';
import SignkNrHyphenZeroOneEight from '@/assets/signs/kNr-018.svg?url';
import SignkNrHyphenZeroOneNine from '@/assets/signs/kNr-019.svg?url';
import SignkNrHyphenZeroTwoZero from '@/assets/signs/kNr-020.svg?url';
import SignkNrHyphenZeroTwoOne from '@/assets/signs/kNr-021.svg?url';
import SignkNrHyphenZeroTwoTwo from '@/assets/signs/kNr-022.svg?url';
import SignkNrHyphenZeroTwoThree from '@/assets/signs/kNr-023.svg?url';
import SignkNrHyphenZeroTwoFour from '@/assets/signs/kNr-024.svg?url';
import SignkNrHyphenZeroTwoFive from '@/assets/signs/kNr-025.svg?url';
import SignkNrHyphenZeroTwoSix from '@/assets/signs/kNr-026.svg?url';
import SignkNrHyphenZeroTwoSeven from '@/assets/signs/kNr-027.svg?url';
import SignkNrHyphenZeroTwoEight from '@/assets/signs/kNr-028.svg?url';
import SignkNrHyphenZeroTwoNine from '@/assets/signs/kNr-029.svg?url';
import SignkNrHyphenZeroThreeZero from '@/assets/signs/kNr-030.svg?url';
import SignkNrHyphenZeroThreeOne from '@/assets/signs/kNr-031.svg?url';
import SignkNrHyphenZeroThreeTwo from '@/assets/signs/kNr-032.svg?url';
import SignkNrHyphenZeroThreeThree from '@/assets/signs/kNr-033.svg?url';
import SignkNrHyphenZeroThreeFour from '@/assets/signs/kNr-034.svg?url';
import SignkNrHyphenZeroThreeFive from '@/assets/signs/kNr-035.svg?url';
import SignkNrHyphenZeroThreeSix from '@/assets/signs/kNr-036.svg?url';
import SignkNrHyphenZeroThreeSeven from '@/assets/signs/kNr-037.svg?url';
import SignkNrHyphenZeroThreeEight from '@/assets/signs/kNr-038.svg?url';
import SignkNrHyphenZeroThreeNine from '@/assets/signs/kNr-039.svg?url';
import SignkNrHyphenZeroFourZero from '@/assets/signs/kNr-040.svg?url';
import SignkNrHyphenZeroFourOne from '@/assets/signs/kNr-041.svg?url';
import SignkNrHyphenZeroFourTwo from '@/assets/signs/kNr-042.svg?url';
import SignkNrHyphenZeroFourThree from '@/assets/signs/kNr-043.svg?url';
import SignkNrHyphenZeroFourFour from '@/assets/signs/kNr-044.svg?url';
import SignkNrHyphenZeroFourFive from '@/assets/signs/kNr-045.svg?url';
import SignkNrHyphenZeroFourSix from '@/assets/signs/kNr-046.svg?url';
import SignkNrHyphenZeroFourSeven from '@/assets/signs/kNr-047.svg?url';
import SignkNrHyphenZeroFourEight from '@/assets/signs/kNr-048.svg?url';
import SignkNrHyphenZeroFourNine from '@/assets/signs/kNr-049.svg?url';
import SignkNrHyphenZeroFiveZero from '@/assets/signs/kNr-050.svg?url';
import SignkNrHyphenZeroFiveOne from '@/assets/signs/kNr-051.svg?url';
import SignkNrHyphenZeroFiveTwo from '@/assets/signs/kNr-052.svg?url';
import SignkNrHyphenZeroFiveThree from '@/assets/signs/kNr-053.svg?url';
import SignkNrHyphenZeroFiveFour from '@/assets/signs/kNr-054.svg?url';
import SignkNrHyphenZeroFiveFive from '@/assets/signs/kNr-055.svg?url';
import SignkNrHyphenZeroFiveSix from '@/assets/signs/kNr-056.svg?url';
import SignkNrHyphenZeroFiveSeven from '@/assets/signs/kNr-057.svg?url';
import SignkNrHyphenZeroFiveEight from '@/assets/signs/kNr-058.svg?url';
import SignkNrHyphenZeroFiveNine from '@/assets/signs/kNr-059.svg?url';
import SignkNrHyphenZeroSixZero from '@/assets/signs/kNr-060.svg?url';
import SignkNrHyphenZeroSixOne from '@/assets/signs/kNr-061.svg?url';
import SignkNrHyphenZeroSixTwo from '@/assets/signs/kNr-062.svg?url';
import SignkNrHyphenZeroSixThree from '@/assets/signs/kNr-063.svg?url';
import SignkNrHyphenZeroSixFour from '@/assets/signs/kNr-064.svg?url';
import SignkNrHyphenZeroSixFive from '@/assets/signs/kNr-065.svg?url';
import SignkNrHyphenZeroSixSix from '@/assets/signs/kNr-066.svg?url';
import SignkNrHyphenZeroSixSeven from '@/assets/signs/kNr-067.svg?url';
import SignkNrHyphenZeroSixEight from '@/assets/signs/kNr-068.svg?url';
import SignkNrHyphenZeroSixNine from '@/assets/signs/kNr-069.svg?url';
import SignkNrHyphenZeroSevenZero from '@/assets/signs/kNr-070.svg?url';
import SignkNrHyphenZeroSevenOne from '@/assets/signs/kNr-071.svg?url';
import SignkNrHyphenZeroSevenTwo from '@/assets/signs/kNr-072.svg?url';
import SignkNrHyphenZeroSevenThree from '@/assets/signs/kNr-073.svg?url';
import SignkNrHyphenZeroSevenFour from '@/assets/signs/kNr-074.svg?url';
import SignkNrHyphenZeroSevenFive from '@/assets/signs/kNr-075.svg?url';
import SignkNrHyphenZeroSevenSix from '@/assets/signs/kNr-076.svg?url';
import SignkNrHyphenZeroSevenSeven from '@/assets/signs/kNr-077.svg?url';
import SignkNrHyphenZeroSevenEight from '@/assets/signs/kNr-078.svg?url';
import SignkNrHyphenZeroSevenNine from '@/assets/signs/kNr-079.svg?url';
import SignkNrHyphenZeroEightZero from '@/assets/signs/kNr-080.svg?url';
import SignkNrHyphenZeroEightOne from '@/assets/signs/kNr-081.svg?url';
import SignkNrHyphenZeroEightTwo from '@/assets/signs/kNr-082.svg?url';
import SignkNrHyphenZeroEightThree from '@/assets/signs/kNr-083.svg?url';
import SignkNrHyphenZeroEightFour from '@/assets/signs/kNr-084.svg?url';
import SignkNrHyphenZeroEightFive from '@/assets/signs/kNr-085.svg?url';
import SignkNrHyphenZeroEightSix from '@/assets/signs/kNr-086.svg?url';
import SignkNrHyphenZeroEightSeven from '@/assets/signs/kNr-087.svg?url';
import SignkNrHyphenZeroEightEight from '@/assets/signs/kNr-088.svg?url';
import SignkNrHyphenZeroEightNine from '@/assets/signs/kNr-089.svg?url';
import SignkNrHyphenZeroNineZero from '@/assets/signs/kNr-090.svg?url';
import SignkNrHyphenZeroNineOne from '@/assets/signs/kNr-091.svg?url';
import SignkNrHyphenZeroNineTwo from '@/assets/signs/kNr-092.svg?url';
import SignkNrHyphenZeroNineThree from '@/assets/signs/kNr-093.svg?url';
import SignkNrHyphenZeroNineFour from '@/assets/signs/kNr-094.svg?url';
import SignkNrHyphenZeroNineFive from '@/assets/signs/kNr-095.svg?url';
import SignkNrHyphenZeroNineSix from '@/assets/signs/kNr-096.svg?url';
import SignkNrHyphenZeroNineSeven from '@/assets/signs/kNr-097.svg?url';
import SignkNrHyphenZeroNineEight from '@/assets/signs/kNr-098.svg?url';
import SignkNrHyphenZeroNineNine from '@/assets/signs/kNr-099.svg?url';

export const SIGNS = {
  '1000-10': {
    url: SignOneZeroZeroZeroHyphenOneZero,
    aspectRatio: 1.818179874496221,
  },
  '1000-11': {
    url: SignOneZeroZeroZeroHyphenOneOne,
    aspectRatio: 1.818179874496221,
  },
  '1000-12': {
    url: SignOneZeroZeroZeroHyphenOneTwo,
    aspectRatio: 1.818179874496221,
  },
  '1000-13': {
    url: SignOneZeroZeroZeroHyphenOneThree,
    aspectRatio: 1.3333385597140126,
  },
  '1000-20': {
    url: SignOneZeroZeroZeroHyphenTwoZero,
    aspectRatio: 1.818179874496221,
  },
  '1000-21': {
    url: SignOneZeroZeroZeroHyphenTwoOne,
    aspectRatio: 1.818179874496221,
  },
  '1000-22': {
    url: SignOneZeroZeroZeroHyphenTwoTwo,
    aspectRatio: 1.818179874496221,
  },
  '1000-23': {
    url: SignOneZeroZeroZeroHyphenTwoThree,
    aspectRatio: 1.818179874496221,
  },
  '1000-30': {
    url: SignOneZeroZeroZeroHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1000-31': {
    url: SignOneZeroZeroZeroHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1000-32': {
    url: SignOneZeroZeroZeroHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1000-34': {
    url: SignOneZeroZeroZeroHyphenThreeFour,
    aspectRatio: 1,
  },
  '1001-30': {
    url: SignOneZeroZeroOneHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1001-31': {
    url: SignOneZeroZeroOneHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1001-32': {
    url: SignOneZeroZeroOneHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1001-33': {
    url: SignOneZeroZeroOneHyphenThreeThree,
    aspectRatio: 1.3333385597140126,
  },
  '1001-34': {
    url: SignOneZeroZeroOneHyphenThreeFour,
    aspectRatio: 2.5000035278097243,
  },
  '1001-35': {
    url: SignOneZeroZeroOneHyphenThreeFive,
    aspectRatio: 2.5000035278097243,
  },
  '1002-10': {
    url: SignOneZeroZeroTwoHyphenOneZero,
    aspectRatio: 1,
  },
  '1002-11': {
    url: SignOneZeroZeroTwoHyphenOneOne,
    aspectRatio: 1,
  },
  '1002-12': {
    url: SignOneZeroZeroTwoHyphenOneTwo,
    aspectRatio: 1,
  },
  '1002-13': {
    url: SignOneZeroZeroTwoHyphenOneThree,
    aspectRatio: 1,
  },
  '1002-14': {
    url: SignOneZeroZeroTwoHyphenOneFour,
    aspectRatio: 1,
  },
  '1002-20': {
    url: SignOneZeroZeroTwoHyphenTwoZero,
    aspectRatio: 1,
  },
  '1002-21': {
    url: SignOneZeroZeroTwoHyphenTwoOne,
    aspectRatio: 1,
  },
  '1002-22': {
    url: SignOneZeroZeroTwoHyphenTwoTwo,
    aspectRatio: 1,
  },
  '1002-23': {
    url: SignOneZeroZeroTwoHyphenTwoThree,
    aspectRatio: 1,
  },
  '1002-24': {
    url: SignOneZeroZeroTwoHyphenTwoFour,
    aspectRatio: 1,
  },
  '1004-30': {
    url: SignOneZeroZeroFourHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1004-31': {
    url: SignOneZeroZeroFourHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1004-32': {
    url: SignOneZeroZeroFourHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1005-30': {
    url: SignOneZeroZeroFiveHyphenThreeZero,
    aspectRatio: 2.5000035278097243,
  },
  '1006-30': {
    url: SignOneZeroZeroSixHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1006-31': {
    url: SignOneZeroZeroSixHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1007-30': {
    url: SignOneZeroZeroSevenHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1007-31': {
    url: SignOneZeroZeroSevenHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1007-32': {
    url: SignOneZeroZeroSevenHyphenThreeTwo,
    aspectRatio: 1.818179874496221,
  },
  '1007-33': {
    url: SignOneZeroZeroSevenHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '1007-34': {
    url: SignOneZeroZeroSevenHyphenThreeFour,
    aspectRatio: 1.818179874496221,
  },
  '1007-35': {
    url: SignOneZeroZeroSevenHyphenThreeFive,
    aspectRatio: 1.818179874496221,
  },
  '1007-36': {
    url: SignOneZeroZeroSevenHyphenThreeSix,
    aspectRatio: 1.818179874496221,
  },
  '1007-37': {
    url: SignOneZeroZeroSevenHyphenThreeSeven,
    aspectRatio: 1.818179874496221,
  },
  '1007-38': {
    url: SignOneZeroZeroSevenHyphenThreeEight,
    aspectRatio: 1.818179874496221,
  },
  '1007-39': {
    url: SignOneZeroZeroSevenHyphenThreeNine,
    aspectRatio: 1.3333385597140126,
  },
  '1007-50': {
    url: SignOneZeroZeroSevenHyphenFiveZero,
    aspectRatio: 1.818179874496221,
  },
  '1007-51': {
    url: SignOneZeroZeroSevenHyphenFiveOne,
    aspectRatio: 1.818179874496221,
  },
  '1007-52': {
    url: SignOneZeroZeroSevenHyphenFiveTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1007-53': {
    url: SignOneZeroZeroSevenHyphenFiveThree,
    aspectRatio: 1.818179874496221,
  },
  '1007-54': {
    url: SignOneZeroZeroSevenHyphenFiveFour,
    aspectRatio: 1.818179874496221,
  },
  '1007-55': {
    url: SignOneZeroZeroSevenHyphenFiveFive,
    aspectRatio: 1.818179874496221,
  },
  '1007-56': {
    url: SignOneZeroZeroSevenHyphenFiveSix,
    aspectRatio: 1.818179874496221,
  },
  '1007-57': {
    url: SignOneZeroZeroSevenHyphenFiveSeven,
    aspectRatio: 1.818179874496221,
  },
  '1007-58': {
    url: SignOneZeroZeroSevenHyphenFiveEight,
    aspectRatio: 1.818179874496221,
  },
  '1007-59': {
    url: SignOneZeroZeroSevenHyphenFiveNine,
    aspectRatio: 1.3333385597140126,
  },
  '1007-60': {
    url: SignOneZeroZeroSevenHyphenSixZero,
    aspectRatio: 1.3333385597140126,
  },
  '1007-61': {
    url: SignOneZeroZeroSevenHyphenSixOne,
    aspectRatio: 1.818179874496221,
  },
  '1007-62': {
    url: SignOneZeroZeroSevenHyphenSixTwo,
    aspectRatio: 1.818179874496221,
  },
  '1008-30': {
    url: SignOneZeroZeroEightHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1008-31': {
    url: SignOneZeroZeroEightHyphenThreeOne,
    aspectRatio: 1.3333385597140126,
  },
  '1008-32': {
    url: SignOneZeroZeroEightHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1008-33': {
    url: SignOneZeroZeroEightHyphenThreeThree,
    aspectRatio: 1.3333385597140126,
  },
  '1008-34': {
    url: SignOneZeroZeroEightHyphenThreeFour,
    aspectRatio: 1.818179874496221,
  },
  '101-10': {
    url: SignOneZeroOneHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '101-11': {
    url: SignOneZeroOneHyphenOneOne,
    aspectRatio: 1.1379634444820825,
  },
  '101-12': {
    url: SignOneZeroOneHyphenOneTwo,
    aspectRatio: 1.1379634444820825,
  },
  '101-13': {
    url: SignOneZeroOneHyphenOneThree,
    aspectRatio: 1.1379634444820825,
  },
  '101-14': {
    url: SignOneZeroOneHyphenOneFour,
    aspectRatio: 1.1379634444820825,
  },
  '101-15': {
    url: SignOneZeroOneHyphenOneFive,
    aspectRatio: 1.1379634444820825,
  },
  '101-20': {
    url: SignOneZeroOneHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '101-21': {
    url: SignOneZeroOneHyphenTwoOne,
    aspectRatio: 1.1379634444820825,
  },
  '101-22': {
    url: SignOneZeroOneHyphenTwoTwo,
    aspectRatio: 1.1379634444820825,
  },
  '101-23': {
    url: SignOneZeroOneHyphenTwoThree,
    aspectRatio: 1.1379634444820825,
  },
  '101-24': {
    url: SignOneZeroOneHyphenTwoFour,
    aspectRatio: 1.1379634444820825,
  },
  '101-25': {
    url: SignOneZeroOneHyphenTwoFive,
    aspectRatio: 1.1379634444820825,
  },
  '101-51': {
    url: SignOneZeroOneHyphenFiveOne,
    aspectRatio: 1.1379634444820825,
  },
  '101-52': {
    url: SignOneZeroOneHyphenFiveTwo,
    aspectRatio: 1.1379634444820825,
  },
  '101-53': {
    url: SignOneZeroOneHyphenFiveThree,
    aspectRatio: 1.1379634444820825,
  },
  '101-54': {
    url: SignOneZeroOneHyphenFiveFour,
    aspectRatio: 1.1379634444820825,
  },
  '101-55': {
    url: SignOneZeroOneHyphenFiveFive,
    aspectRatio: 1.1379634444820825,
  },
  '101': {
    url: SignOneZeroOne,
    aspectRatio: 1.1379634444820825,
  },
  '1010-10': {
    url: SignOneZeroOneZeroHyphenOneZero,
    aspectRatio: 1.818179874496221,
  },
  '1010-11': {
    url: SignOneZeroOneZeroHyphenOneOne,
    aspectRatio: 1.818179874496221,
  },
  '1010-12': {
    url: SignOneZeroOneZeroHyphenOneTwo,
    aspectRatio: 1.818179874496221,
  },
  '1010-13': {
    url: SignOneZeroOneZeroHyphenOneThree,
    aspectRatio: 1.818179874496221,
  },
  '1010-14': {
    url: SignOneZeroOneZeroHyphenOneFour,
    aspectRatio: 1.818179874496221,
  },
  '1010-15': {
    url: SignOneZeroOneZeroHyphenOneFive,
    aspectRatio: 1.7777777777777777,
  },
  '1010-50': {
    url: SignOneZeroOneZeroHyphenFiveZero,
    aspectRatio: 1.818179874496221,
  },
  '1010-51': {
    url: SignOneZeroOneZeroHyphenFiveOne,
    aspectRatio: 1.818179874496221,
  },
  '1010-52': {
    url: SignOneZeroOneZeroHyphenFiveTwo,
    aspectRatio: 1.818179874496221,
  },
  '1010-53': {
    url: SignOneZeroOneZeroHyphenFiveThree,
    aspectRatio: 1.818179874496221,
  },
  '1010-54': {
    url: SignOneZeroOneZeroHyphenFiveFour,
    aspectRatio: 1.818179874496221,
  },
  '1010-55': {
    url: SignOneZeroOneZeroHyphenFiveFive,
    aspectRatio: 1.818179874496221,
  },
  '1010-56': {
    url: SignOneZeroOneZeroHyphenFiveSix,
    aspectRatio: 1.818179874496221,
  },
  '1010-57': {
    url: SignOneZeroOneZeroHyphenFiveSeven,
    aspectRatio: 1.818179874496221,
  },
  '1010-58': {
    url: SignOneZeroOneZeroHyphenFiveEight,
    aspectRatio: 1.818179874496221,
  },
  '1010-59': {
    url: SignOneZeroOneZeroHyphenFiveNine,
    aspectRatio: 1.818179874496221,
  },
  '1010-60': {
    url: SignOneZeroOneZeroHyphenSixZero,
    aspectRatio: 1.818179874496221,
  },
  '1010-61': {
    url: SignOneZeroOneZeroHyphenSixOne,
    aspectRatio: 1.818179874496221,
  },
  '1010-62': {
    url: SignOneZeroOneZeroHyphenSixTwo,
    aspectRatio: 1.818179874496221,
  },
  '1010-63': {
    url: SignOneZeroOneZeroHyphenSixThree,
    aspectRatio: 1.818179874496221,
  },
  '1010-64': {
    url: SignOneZeroOneZeroHyphenSixFour,
    aspectRatio: 1.818179874496221,
  },
  '1010-65': {
    url: SignOneZeroOneZeroHyphenSixFive,
    aspectRatio: 1.818179874496221,
  },
  '1010-66': {
    url: SignOneZeroOneZeroHyphenSixSix,
    aspectRatio: 1.818179874496221,
  },
  '1010-67': {
    url: SignOneZeroOneZeroHyphenSixSeven,
    aspectRatio: 1.818179874496221,
  },
  '1010-68': {
    url: SignOneZeroOneZeroHyphenSixEight,
    aspectRatio: 1.3333385597140126,
  },
  '1010-69': {
    url: SignOneZeroOneZeroHyphenSixNine,
    aspectRatio: 1.818179874496221,
  },
  '1010-70': {
    url: SignOneZeroOneZeroHyphenSevenZero,
    aspectRatio: 1,
  },
  '1010-71': {
    url: SignOneZeroOneZeroHyphenSevenOne,
    aspectRatio: 1.818179874496221,
  },
  '1010-72': {
    url: SignOneZeroOneZeroHyphenSevenTwo,
    aspectRatio: 1,
  },
  '1012-30': {
    url: SignOneZeroOneTwoHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1012-31': {
    url: SignOneZeroOneTwoHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1012-32': {
    url: SignOneZeroOneTwoHyphenThreeTwo,
    aspectRatio: 1.818179874496221,
  },
  '1012-33': {
    url: SignOneZeroOneTwoHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '1012-34': {
    url: SignOneZeroOneTwoHyphenThreeFour,
    aspectRatio: 1.818179874496221,
  },
  '1012-35': {
    url: SignOneZeroOneTwoHyphenThreeFive,
    aspectRatio: 1.818179874496221,
  },
  '1012-36': {
    url: SignOneZeroOneTwoHyphenThreeSix,
    aspectRatio: 1.818179874496221,
  },
  '1012-37': {
    url: SignOneZeroOneTwoHyphenThreeSeven,
    aspectRatio: 1.818179874496221,
  },
  '1012-38': {
    url: SignOneZeroOneTwoHyphenThreeEight,
    aspectRatio: 4.205318163778277,
  },
  '1012-50': {
    url: SignOneZeroOneTwoHyphenFiveZero,
    aspectRatio: 1.818179874496221,
  },
  '1012-51': {
    url: SignOneZeroOneTwoHyphenFiveOne,
    aspectRatio: 1.818179874496221,
  },
  '1012-52': {
    url: SignOneZeroOneTwoHyphenFiveTwo,
    aspectRatio: 1.818179874496221,
  },
  '1012-53': {
    url: SignOneZeroOneTwoHyphenFiveThree,
    aspectRatio: 1.818179874496221,
  },
  '1012-54': {
    url: SignOneZeroOneTwoHyphenFiveFour,
    aspectRatio: 1.818179874496221,
  },
  '1013-50': {
    url: SignOneZeroOneThreeHyphenFiveZero,
    aspectRatio: 2.8125016536578915,
  },
  '1013-51': {
    url: SignOneZeroOneThreeHyphenFiveOne,
    aspectRatio: 2.8125016536578915,
  },
  '1013-52': {
    url: SignOneZeroOneThreeHyphenFiveTwo,
    aspectRatio: 4.500010583429172,
  },
  '1014-50': {
    url: SignOneZeroOneFourHyphenFiveZero,
    aspectRatio: 1.818179874496221,
  },
  '1014-51': {
    url: SignOneZeroOneFourHyphenFiveOne,
    aspectRatio: 1.818179874496221,
  },
  '1014-52': {
    url: SignOneZeroOneFourHyphenFiveTwo,
    aspectRatio: 1.818179874496221,
  },
  '1014-53': {
    url: SignOneZeroOneFourHyphenFiveThree,
    aspectRatio: 1.818179874496221,
  },
  '102': {
    url: SignOneZeroTwo,
    aspectRatio: 1.1379634444820825,
  },
  '1020-11': {
    url: SignOneZeroTwoZeroHyphenOneOne,
    aspectRatio: 1.818179874496221,
  },
  '1020-12': {
    url: SignOneZeroTwoZeroHyphenOneTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1020-13': {
    url: SignOneZeroTwoZeroHyphenOneThree,
    aspectRatio: 1.818179874496221,
  },
  '1020-14': {
    url: SignOneZeroTwoZeroHyphenOneFour,
    aspectRatio: 1.818179874496221,
  },
  '1020-30': {
    url: SignOneZeroTwoZeroHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1020-31': {
    url: SignOneZeroTwoZeroHyphenThreeOne,
    aspectRatio: 1.3333385597140126,
  },
  '1020-32': {
    url: SignOneZeroTwoZeroHyphenThreeTwo,
    aspectRatio: 1.818179874496221,
  },
  '1022-10': {
    url: SignOneZeroTwoTwoHyphenOneZero,
    aspectRatio: 1.3333385597140126,
  },
  '1022-11': {
    url: SignOneZeroTwoTwoHyphenOneOne,
    aspectRatio: 1.3333385597140126,
  },
  '1022-12': {
    url: SignOneZeroTwoTwoHyphenOneTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1022-13': {
    url: SignOneZeroTwoTwoHyphenOneThree,
    aspectRatio: 1.3333385597140126,
  },
  '1022-14': {
    url: SignOneZeroTwoTwoHyphenOneFour,
    aspectRatio: 1,
  },
  '1022-15': {
    url: SignOneZeroTwoTwoHyphenOneFive,
    aspectRatio: 1,
  },
  '1022-16': {
    url: SignOneZeroTwoTwoHyphenOneSix,
    aspectRatio: 1,
  },
  '1022-17': {
    url: SignOneZeroTwoTwoHyphenOneSeven,
    aspectRatio: 1.3333385597140126,
  },
  '1024-10': {
    url: SignOneZeroTwoFourHyphenOneZero,
    aspectRatio: 1.3333385597140126,
  },
  '1024-11': {
    url: SignOneZeroTwoFourHyphenOneOne,
    aspectRatio: 1.3333385597140126,
  },
  '1024-12': {
    url: SignOneZeroTwoFourHyphenOneTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1024-13': {
    url: SignOneZeroTwoFourHyphenOneThree,
    aspectRatio: 1.3333385597140126,
  },
  '1024-14': {
    url: SignOneZeroTwoFourHyphenOneFour,
    aspectRatio: 1.3333385597140126,
  },
  '1024-15': {
    url: SignOneZeroTwoFourHyphenOneFive,
    aspectRatio: 1.3333385597140126,
  },
  '1024-16': {
    url: SignOneZeroTwoFourHyphenOneSix,
    aspectRatio: 1.3333385597140126,
  },
  '1024-17': {
    url: SignOneZeroTwoFourHyphenOneSeven,
    aspectRatio: 1.3333385597140126,
  },
  '1024-18': {
    url: SignOneZeroTwoFourHyphenOneEight,
    aspectRatio: 1.3333385597140126,
  },
  '1024-19': {
    url: SignOneZeroTwoFourHyphenOneNine,
    aspectRatio: 1,
  },
  '1024-20': {
    url: SignOneZeroTwoFourHyphenTwoZero,
    aspectRatio: 1.3333385597140126,
  },
  '1024-21': {
    url: SignOneZeroTwoFourHyphenTwoOne,
    aspectRatio: 1,
  },
  '1026-30': {
    url: SignOneZeroTwoSixHyphenThreeZero,
    aspectRatio: 1.3333385597140126,
  },
  '1026-31': {
    url: SignOneZeroTwoSixHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1026-32': {
    url: SignOneZeroTwoSixHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1026-33': {
    url: SignOneZeroTwoSixHyphenThreeThree,
    aspectRatio: 1.3333385597140126,
  },
  '1026-34': {
    url: SignOneZeroTwoSixHyphenThreeFour,
    aspectRatio: 1.3333385597140126,
  },
  '1026-35': {
    url: SignOneZeroTwoSixHyphenThreeFive,
    aspectRatio: 1.3333385597140126,
  },
  '1026-36': {
    url: SignOneZeroTwoSixHyphenThreeSix,
    aspectRatio: 1.3333385597140126,
  },
  '1026-37': {
    url: SignOneZeroTwoSixHyphenThreeSeven,
    aspectRatio: 1.3333385597140126,
  },
  '1026-38': {
    url: SignOneZeroTwoSixHyphenThreeEight,
    aspectRatio: 1.3333385597140126,
  },
  '1026-39': {
    url: SignOneZeroTwoSixHyphenThreeNine,
    aspectRatio: 1.818179874496221,
  },
  '1026-60': {
    url: SignOneZeroTwoSixHyphenSixZero,
    aspectRatio: 1,
  },
  '1026-61': {
    url: SignOneZeroTwoSixHyphenSixOne,
    aspectRatio: 1.3333385597140126,
  },
  '1026-62': {
    url: SignOneZeroTwoSixHyphenSixTwo,
    aspectRatio: 1.818179874496221,
  },
  '1026-63': {
    url: SignOneZeroTwoSixHyphenSixThree,
    aspectRatio: 1.818179874496221,
  },
  '1028-30': {
    url: SignOneZeroTwoEightHyphenThreeZero,
    aspectRatio: 1.3333385597140126,
  },
  '1028-31': {
    url: SignOneZeroTwoEightHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1028-32': {
    url: SignOneZeroTwoEightHyphenThreeTwo,
    aspectRatio: 1.818179874496221,
  },
  '1028-33': {
    url: SignOneZeroTwoEightHyphenThreeThree,
    aspectRatio: 1.3333385597140126,
  },
  '1028-34': {
    url: SignOneZeroTwoEightHyphenThreeFour,
    aspectRatio: 1.3333385597140126,
  },
  '103-10': {
    url: SignOneZeroThreeHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '103-20': {
    url: SignOneZeroThreeHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '1031-50': {
    url: SignOneZeroThreeOneHyphenFiveZero,
    aspectRatio: 1.3333385597140126,
  },
  '1031-51': {
    url: SignOneZeroThreeOneHyphenFiveOne,
    aspectRatio: 1.3333385597140126,
  },
  '1031-52': {
    url: SignOneZeroThreeOneHyphenFiveTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1040-10': {
    url: SignOneZeroFourZeroHyphenOneZero,
    aspectRatio: 1.818179874496221,
  },
  '1040-30': {
    url: SignOneZeroFourZeroHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1040-31': {
    url: SignOneZeroFourZeroHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1040-32': {
    url: SignOneZeroFourZeroHyphenThreeTwo,
    aspectRatio: 1.818179874496221,
  },
  '1040-33': {
    url: SignOneZeroFourZeroHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '1040-34': {
    url: SignOneZeroFourZeroHyphenThreeFour,
    aspectRatio: 1.818179874496221,
  },
  '1040-35': {
    url: SignOneZeroFourZeroHyphenThreeFive,
    aspectRatio: 1.818179874496221,
  },
  '1040-36': {
    url: SignOneZeroFourZeroHyphenThreeSix,
    aspectRatio: 1.818179874496221,
  },
  '1042-30': {
    url: SignOneZeroFourTwoHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1042-31': {
    url: SignOneZeroFourTwoHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1042-32': {
    url: SignOneZeroFourTwoHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1042-33': {
    url: SignOneZeroFourTwoHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '1042-34': {
    url: SignOneZeroFourTwoHyphenThreeFour,
    aspectRatio: 1.818179874496221,
  },
  '1042-35': {
    url: SignOneZeroFourTwoHyphenThreeFive,
    aspectRatio: 1.3333385597140126,
  },
  '1042-36': {
    url: SignOneZeroFourTwoHyphenThreeSix,
    aspectRatio: 1.3333385597140126,
  },
  '1042-37': {
    url: SignOneZeroFourTwoHyphenThreeSeven,
    aspectRatio: 1.3333385597140126,
  },
  '1042-38': {
    url: SignOneZeroFourTwoHyphenThreeEight,
    aspectRatio: 1.818179874496221,
  },
  '1042-50': {
    url: SignOneZeroFourTwoHyphenFiveZero,
    aspectRatio: 1,
  },
  '1042-51': {
    url: SignOneZeroFourTwoHyphenFiveOne,
    aspectRatio: 1.818179874496221,
  },
  '1042-52': {
    url: SignOneZeroFourTwoHyphenFiveTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1042-53': {
    url: SignOneZeroFourTwoHyphenFiveThree,
    aspectRatio: 1.3333385597140126,
  },
  '1044-10': {
    url: SignOneZeroFourFourHyphenOneZero,
    aspectRatio: 1.818179874496221,
  },
  '1044-11': {
    url: SignOneZeroFourFourHyphenOneOne,
    aspectRatio: 1.818179874496221,
  },
  '1044-12': {
    url: SignOneZeroFourFourHyphenOneTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1044-30': {
    url: SignOneZeroFourFourHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1048-14': {
    url: SignOneZeroFourEightHyphenOneFour,
    aspectRatio: 1.818179874496221,
  },
  '1048-15': {
    url: SignOneZeroFourEightHyphenOneFive,
    aspectRatio: 1.3333385597140126,
  },
  '1048-18': {
    url: SignOneZeroFourEightHyphenOneEight,
    aspectRatio: 1.3333385597140126,
  },
  '1048-20': {
    url: SignOneZeroFourEightHyphenTwoZero,
    aspectRatio: 1.3333385597140126,
  },
  '1049-11': {
    url: SignOneZeroFourNineHyphenOneOne,
    aspectRatio: 1.3333385597140126,
  },
  '1049-12': {
    url: SignOneZeroFourNineHyphenOneTwo,
    aspectRatio: 1.818179874496221,
  },
  '1049-13': {
    url: SignOneZeroFourNineHyphenOneThree,
    aspectRatio: 1,
  },
  '105-10': {
    url: SignOneZeroFiveHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '105-20': {
    url: SignOneZeroFiveHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '1050-30': {
    url: SignOneZeroFiveZeroHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1050-31': {
    url: SignOneZeroFiveZeroHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1050-32': {
    url: SignOneZeroFiveZeroHyphenThreeTwo,
    aspectRatio: 1.3333385597140126,
  },
  '1050-33': {
    url: SignOneZeroFiveZeroHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '1052-30': {
    url: SignOneZeroFiveTwoHyphenThreeZero,
    aspectRatio: 1.3333385597140126,
  },
  '1052-31': {
    url: SignOneZeroFiveTwoHyphenThreeOne,
    aspectRatio: 1.3333385597140126,
  },
  '1053-30': {
    url: SignOneZeroFiveThreeHyphenThreeZero,
    aspectRatio: 1.818179874496221,
  },
  '1053-31': {
    url: SignOneZeroFiveThreeHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1053-32': {
    url: SignOneZeroFiveThreeHyphenThreeTwo,
    aspectRatio: 1.818179874496221,
  },
  '1053-33': {
    url: SignOneZeroFiveThreeHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '1053-34': {
    url: SignOneZeroFiveThreeHyphenThreeFour,
    aspectRatio: 1.818179874496221,
  },
  '1053-35': {
    url: SignOneZeroFiveThreeHyphenThreeFive,
    aspectRatio: 1,
  },
  '1053-36': {
    url: SignOneZeroFiveThreeHyphenThreeSix,
    aspectRatio: 1.818179874496221,
  },
  '1053-37': {
    url: SignOneZeroFiveThreeHyphenThreeSeven,
    aspectRatio: 1.818179874496221,
  },
  '1053-38': {
    url: SignOneZeroFiveThreeHyphenThreeEight,
    aspectRatio: 1,
  },
  '1053-39': {
    url: SignOneZeroFiveThreeHyphenThreeNine,
    aspectRatio: 1,
  },
  '1053-52': {
    url: SignOneZeroFiveThreeHyphenFiveTwo,
    aspectRatio: 1,
  },
  '1053-53': {
    url: SignOneZeroFiveThreeHyphenFiveThree,
    aspectRatio: 1,
  },
  '1053-54': {
    url: SignOneZeroFiveThreeHyphenFiveFour,
    aspectRatio: 1.818179874496221,
  },
  '1060-31': {
    url: SignOneZeroSixZeroHyphenThreeOne,
    aspectRatio: 1.818179874496221,
  },
  '1060-32': {
    url: SignOneZeroSixZeroHyphenThreeTwo,
    aspectRatio: 1,
  },
  '1060-33': {
    url: SignOneZeroSixZeroHyphenThreeThree,
    aspectRatio: 1.818179874496221,
  },
  '108-10': {
    url: SignOneZeroEightHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '108-11': {
    url: SignOneZeroEightHyphenOneOne,
    aspectRatio: 1.1379634444820825,
  },
  '108-12': {
    url: SignOneZeroEightHyphenOneTwo,
    aspectRatio: 1.1379634444820825,
  },
  '108-13': {
    url: SignOneZeroEightHyphenOneThree,
    aspectRatio: 1.1379634444820825,
  },
  '108-14': {
    url: SignOneZeroEightHyphenOneFour,
    aspectRatio: 1.1379634444820825,
  },
  '108-15': {
    url: SignOneZeroEightHyphenOneFive,
    aspectRatio: 1.1379634444820825,
  },
  '108-16': {
    url: SignOneZeroEightHyphenOneSix,
    aspectRatio: 1.1379634444820825,
  },
  '108-17': {
    url: SignOneZeroEightHyphenOneSeven,
    aspectRatio: 1.1379634444820825,
  },
  '108-18': {
    url: SignOneZeroEightHyphenOneEight,
    aspectRatio: 1.1379634444820825,
  },
  '108-19': {
    url: SignOneZeroEightHyphenOneNine,
    aspectRatio: 1.1379634444820825,
  },
  '108-20': {
    url: SignOneZeroEightHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '108-21': {
    url: SignOneZeroEightHyphenTwoOne,
    aspectRatio: 1.1379634444820825,
  },
  '108-22': {
    url: SignOneZeroEightHyphenTwoTwo,
    aspectRatio: 1.1379634444820825,
  },
  '108-23': {
    url: SignOneZeroEightHyphenTwoThree,
    aspectRatio: 1.1379634444820825,
  },
  '108-24': {
    url: SignOneZeroEightHyphenTwoFour,
    aspectRatio: 1.1379634444820825,
  },
  '108-25': {
    url: SignOneZeroEightHyphenTwoFive,
    aspectRatio: 1.1379634444820825,
  },
  '108-4': {
    url: SignOneZeroEightHyphenFour,
    aspectRatio: 1.1379634444820825,
  },
  '108-5': {
    url: SignOneZeroEightHyphenFive,
    aspectRatio: 1.1379634444820825,
  },
  '108-6': {
    url: SignOneZeroEightHyphenSix,
    aspectRatio: 1.1379634444820825,
  },
  '108-7': {
    url: SignOneZeroEightHyphenSeven,
    aspectRatio: 1.1379634444820825,
  },
  '108-8': {
    url: SignOneZeroEightHyphenEight,
    aspectRatio: 1.1379634444820825,
  },
  '108-9': {
    url: SignOneZeroEightHyphenNine,
    aspectRatio: 1.1379634444820825,
  },
  '110-10': {
    url: SignOneOneZeroHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '110-11': {
    url: SignOneOneZeroHyphenOneOne,
    aspectRatio: 1.1379634444820825,
  },
  '110-12': {
    url: SignOneOneZeroHyphenOneTwo,
    aspectRatio: 1.1379634444820825,
  },
  '110-13': {
    url: SignOneOneZeroHyphenOneThree,
    aspectRatio: 1.1379634444820825,
  },
  '110-14': {
    url: SignOneOneZeroHyphenOneFour,
    aspectRatio: 1.1379634444820825,
  },
  '110-15': {
    url: SignOneOneZeroHyphenOneFive,
    aspectRatio: 1.1379634444820825,
  },
  '110-16': {
    url: SignOneOneZeroHyphenOneSix,
    aspectRatio: 1.1379634444820825,
  },
  '110-17': {
    url: SignOneOneZeroHyphenOneSeven,
    aspectRatio: 1.1379634444820825,
  },
  '110-18': {
    url: SignOneOneZeroHyphenOneEight,
    aspectRatio: 1.1379634444820825,
  },
  '110-19': {
    url: SignOneOneZeroHyphenOneNine,
    aspectRatio: 1.1379634444820825,
  },
  '110-20': {
    url: SignOneOneZeroHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '110-21': {
    url: SignOneOneZeroHyphenTwoOne,
    aspectRatio: 1.1379634444820825,
  },
  '110-22': {
    url: SignOneOneZeroHyphenTwoTwo,
    aspectRatio: 1.1379634444820825,
  },
  '110-23': {
    url: SignOneOneZeroHyphenTwoThree,
    aspectRatio: 1.1379634444820825,
  },
  '110-24': {
    url: SignOneOneZeroHyphenTwoFour,
    aspectRatio: 1.1379634444820825,
  },
  '110-25': {
    url: SignOneOneZeroHyphenTwoFive,
    aspectRatio: 1.1379634444820825,
  },
  '110-4': {
    url: SignOneOneZeroHyphenFour,
    aspectRatio: 1.1379634444820825,
  },
  '110-5': {
    url: SignOneOneZeroHyphenFive,
    aspectRatio: 1.1379634444820825,
  },
  '110-6': {
    url: SignOneOneZeroHyphenSix,
    aspectRatio: 1.1379634444820825,
  },
  '110-7': {
    url: SignOneOneZeroHyphenSeven,
    aspectRatio: 1.1379634444820825,
  },
  '110-8': {
    url: SignOneOneZeroHyphenEight,
    aspectRatio: 1.1379634444820825,
  },
  '110-9': {
    url: SignOneOneZeroHyphenNine,
    aspectRatio: 1.1379634444820825,
  },
  '112': {
    url: SignOneOneTwo,
    aspectRatio: 1.1379634444820825,
  },
  '114': {
    url: SignOneOneFour,
    aspectRatio: 1.1379634444820825,
  },
  '117-10': {
    url: SignOneOneSevenHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '117-20': {
    url: SignOneOneSevenHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '120': {
    url: SignOneTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '121-10': {
    url: SignOneTwoOneHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '121-20': {
    url: SignOneTwoOneHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '123': {
    url: SignOneTwoThree,
    aspectRatio: 1.1379634444820825,
  },
  '124': {
    url: SignOneTwoFour,
    aspectRatio: 1.1379634444820825,
  },
  '125': {
    url: SignOneTwoFive,
    aspectRatio: 1.1379634444820825,
  },
  '131': {
    url: SignOneThreeOne,
    aspectRatio: 1.1379634444820825,
  },
  '133-10': {
    url: SignOneThreeThreeHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '133-20': {
    url: SignOneThreeThreeHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '136-10-1': {
    url: SignOneThreeSixHyphenOneZeroHyphenOne,
    aspectRatio: 1.01,
  },
  '136-10': {
    url: SignOneThreeSixHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '136-20': {
    url: SignOneThreeSixHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '138-10': {
    url: SignOneThreeEightHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '138-20': {
    url: SignOneThreeEightHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '142-10': {
    url: SignOneFourTwoHyphenOneZero,
    aspectRatio: 1.1379634444820825,
  },
  '142-20': {
    url: SignOneFourTwoHyphenTwoZero,
    aspectRatio: 1.1379634444820825,
  },
  '151': {
    url: SignOneFiveOne,
    aspectRatio: 1.1379634444820825,
  },
  '156-10': {
    url: SignOneFiveSixHyphenOneZero,
    aspectRatio: 0.48097988287866805,
  },
  '156-11': {
    url: SignOneFiveSixHyphenOneOne,
    aspectRatio: 0.48097988287866805,
  },
  '156-20': {
    url: SignOneFiveSixHyphenTwoZero,
    aspectRatio: 0.48097988287866805,
  },
  '156-21': {
    url: SignOneFiveSixHyphenTwoOne,
    aspectRatio: 0.48097988287866805,
  },
  '157-10': {
    url: SignOneFiveSevenHyphenOneZero,
    aspectRatio: 0.30000035277972786,
  },
  '157-11': {
    url: SignOneFiveSevenHyphenOneOne,
    aspectRatio: 0.30000035277972786,
  },
  '157-20': {
    url: SignOneFiveSevenHyphenTwoZero,
    aspectRatio: 0.30000035277972786,
  },
  '157-21': {
    url: SignOneFiveSevenHyphenTwoOne,
    aspectRatio: 0.30000035277972786,
  },
  '159-10': {
    url: SignOneFiveNineHyphenOneZero,
    aspectRatio: 0.30000035277972786,
  },
  '159-11': {
    url: SignOneFiveNineHyphenOneOne,
    aspectRatio: 0.30000035277972786,
  },
  '159-20': {
    url: SignOneFiveNineHyphenTwoZero,
    aspectRatio: 0.30000035277972786,
  },
  '159-21': {
    url: SignOneFiveNineHyphenTwoOne,
    aspectRatio: 0.30000035277972786,
  },
  '162-10': {
    url: SignOneSixTwoHyphenOneZero,
    aspectRatio: 0.30000035277972786,
  },
  '162-11': {
    url: SignOneSixTwoHyphenOneOne,
    aspectRatio: 0.30000035277972786,
  },
  '162-20': {
    url: SignOneSixTwoHyphenTwoZero,
    aspectRatio: 0.30000035277972786,
  },
  '162-21': {
    url: SignOneSixTwoHyphenTwoOne,
    aspectRatio: 0.30000035277972786,
  },
  '201-50': {
    url: SignTwoZeroOneHyphenFiveZero,
    aspectRatio: 0.6598854638880639,
  },
  '201-51': {
    url: SignTwoZeroOneHyphenFiveOne,
    aspectRatio: 0.6598854638880639,
  },
  '201-52': {
    url: SignTwoZeroOneHyphenFiveTwo,
    aspectRatio: 1.5154144995223435,
  },
  '201-53': {
    url: SignTwoZeroOneHyphenFiveThree,
    aspectRatio: 1.5154144995223435,
  },
  '205': {
    url: SignTwoZeroFive,
    aspectRatio: 1.1379634444820825,
  },
  '206': {
    url: SignTwoZeroSix,
    aspectRatio: 1,
  },
  '208': {
    url: SignTwoZeroEight,
    aspectRatio: 1,
  },
  '209-10': {
    url: SignTwoZeroNineHyphenOneZero,
    aspectRatio: 1,
  },
  '209-30': {
    url: SignTwoZeroNineHyphenThreeZero,
    aspectRatio: 1,
  },
  '209': {
    url: SignTwoZeroNine,
    aspectRatio: 1,
  },
  '211-10': {
    url: SignTwoOneOneHyphenOneZero,
    aspectRatio: 1,
  },
  '211': {
    url: SignTwoOneOne,
    aspectRatio: 1,
  },
  '214-10': {
    url: SignTwoOneFourHyphenOneZero,
    aspectRatio: 1,
  },
  '214-30': {
    url: SignTwoOneFourHyphenThreeZero,
    aspectRatio: 1,
  },
  '214': {
    url: SignTwoOneFour,
    aspectRatio: 1,
  },
  '215': {
    url: SignTwoOneFive,
    aspectRatio: 1,
  },
  '220-10': {
    url: SignTwoTwoZeroHyphenOneZero,
    aspectRatio: 2.666658827126377,
  },
  '220-20': {
    url: SignTwoTwoZeroHyphenTwoZero,
    aspectRatio: 2.666658827126377,
  },
  '222-10': {
    url: SignTwoTwoTwoHyphenOneZero,
    aspectRatio: 1,
  },
  '222': {
    url: SignTwoTwoTwo,
    aspectRatio: 1,
  },
  '223.1-50': {
    url: SignTwoTwoThreeDotOneHyphenFiveZero,
    aspectRatio: 1,
  },
  '223.1-51': {
    url: SignTwoTwoThreeDotOneHyphenFiveOne,
    aspectRatio: 1,
  },
  '223.1-52': {
    url: SignTwoTwoThreeDotOneHyphenFiveTwo,
    aspectRatio: 1,
  },
  '223.2-50': {
    url: SignTwoTwoThreeDotTwoHyphenFiveZero,
    aspectRatio: 1,
  },
  '223.2-51': {
    url: SignTwoTwoThreeDotTwoHyphenFiveOne,
    aspectRatio: 1,
  },
  '223.2-52': {
    url: SignTwoTwoThreeDotTwoHyphenFiveTwo,
    aspectRatio: 1,
  },
  '223.3-50': {
    url: SignTwoTwoThreeDotThreeHyphenFiveZero,
    aspectRatio: 1,
  },
  '223.3-51': {
    url: SignTwoTwoThreeDotThreeHyphenFiveOne,
    aspectRatio: 1,
  },
  '223.3-52': {
    url: SignTwoTwoThreeDotThreeHyphenFiveTwo,
    aspectRatio: 1,
  },
  '224-51': {
    url: SignTwoTwoFourHyphenFiveOne,
    aspectRatio: 0.6666666666666666,
  },
  '224': {
    url: SignTwoTwoFour,
    aspectRatio: 1,
  },
  '229-10': {
    url: SignTwoTwoNineHyphenOneZero,
    aspectRatio: 0.6666692798570063,
  },
  '229-11': {
    url: SignTwoTwoNineHyphenOneOne,
    aspectRatio: 0.6666692798570063,
  },
  '229-20': {
    url: SignTwoTwoNineHyphenTwoZero,
    aspectRatio: 0.6666692798570063,
  },
  '229-21': {
    url: SignTwoTwoNineHyphenTwoOne,
    aspectRatio: 0.6666692798570063,
  },
  '229-30': {
    url: SignTwoTwoNineHyphenThreeZero,
    aspectRatio: 0.6666692798570063,
  },
  '229-31': {
    url: SignTwoTwoNineHyphenThreeOne,
    aspectRatio: 0.6666692798570063,
  },
  '229': {
    url: SignTwoTwoNine,
    aspectRatio: 0.6666692798570063,
  },
  '237': {
    url: SignTwoThreeSeven,
    aspectRatio: 1,
  },
  '238': {
    url: SignTwoThreeEight,
    aspectRatio: 1,
  },
  '239': {
    url: SignTwoThreeNine,
    aspectRatio: 1,
  },
  '240': {
    url: SignTwoFourZero,
    aspectRatio: 1,
  },
  '241-30': {
    url: SignTwoFourOneHyphenThreeZero,
    aspectRatio: 1,
  },
  '241-31': {
    url: SignTwoFourOneHyphenThreeOne,
    aspectRatio: 1,
  },
  '242.1': {
    url: SignTwoFourTwoDotOne,
    aspectRatio: 1,
  },
  '242.2': {
    url: SignTwoFourTwoDotTwo,
    aspectRatio: 1,
  },
  '244.1': {
    url: SignTwoFourFourDotOne,
    aspectRatio: 1,
  },
  '244.2': {
    url: SignTwoFourFourDotTwo,
    aspectRatio: 1,
  },
  '244.3': {
    url: SignTwoFourFourDotThree,
    aspectRatio: 1,
  },
  '244.4': {
    url: SignTwoFourFourDotFour,
    aspectRatio: 1,
  },
  '245': {
    url: SignTwoFourFive,
    aspectRatio: 1,
  },
  '250': {
    url: SignTwoFiveZero,
    aspectRatio: 1,
  },
  '251': {
    url: SignTwoFiveOne,
    aspectRatio: 1,
  },
  '253': {
    url: SignTwoFiveThree,
    aspectRatio: 1,
  },
  '254': {
    url: SignTwoFiveFour,
    aspectRatio: 1,
  },
  '255': {
    url: SignTwoFiveFive,
    aspectRatio: 1,
  },
  '257-50': {
    url: SignTwoFiveSevenHyphenFiveZero,
    aspectRatio: 1,
  },
  '257-51': {
    url: SignTwoFiveSevenHyphenFiveOne,
    aspectRatio: 1,
  },
  '257-52': {
    url: SignTwoFiveSevenHyphenFiveTwo,
    aspectRatio: 1,
  },
  '257-53': {
    url: SignTwoFiveSevenHyphenFiveThree,
    aspectRatio: 1,
  },
  '257-54': {
    url: SignTwoFiveSevenHyphenFiveFour,
    aspectRatio: 1,
  },
  '257-55': {
    url: SignTwoFiveSevenHyphenFiveFive,
    aspectRatio: 1,
  },
  '257-56': {
    url: SignTwoFiveSevenHyphenFiveSix,
    aspectRatio: 1,
  },
  '257-57': {
    url: SignTwoFiveSevenHyphenFiveSeven,
    aspectRatio: 1,
  },
  '257-58': {
    url: SignTwoFiveSevenHyphenFiveEight,
    aspectRatio: 1,
  },
  '259': {
    url: SignTwoFiveNine,
    aspectRatio: 1,
  },
  '260': {
    url: SignTwoSixZero,
    aspectRatio: 1,
  },
  '261': {
    url: SignTwoSixOne,
    aspectRatio: 1,
  },
  '262': {
    url: SignTwoSixTwo,
    aspectRatio: 1,
  },
  '263': {
    url: SignTwoSixThree,
    aspectRatio: 1,
  },
  '264-2.3': {
    url: SignTwoSixFourHyphenTwoDotThree,
    aspectRatio: 1,
  },
  '264-2': {
    url: SignTwoSixFourHyphenTwo,
    aspectRatio: 1,
  },
  '264': {
    url: SignTwoSixFour,
    aspectRatio: 1,
  },
  '265': {
    url: SignTwoSixFive,
    aspectRatio: 1,
  },
  '266': {
    url: SignTwoSixSix,
    aspectRatio: 1,
  },
  '267': {
    url: SignTwoSixSeven,
    aspectRatio: 1,
  },
  '268': {
    url: SignTwoSixEight,
    aspectRatio: 1,
  },
  '269': {
    url: SignTwoSixNine,
    aspectRatio: 1,
  },
  '270.1': {
    url: SignTwoSevenZeroDotOne,
    aspectRatio: 1,
  },
  '270.2': {
    url: SignTwoSevenZeroDotTwo,
    aspectRatio: 1,
  },
  '272': {
    url: SignTwoSevenTwo,
    aspectRatio: 1,
  },
  '273': {
    url: SignTwoSevenThree,
    aspectRatio: 1,
  },
  '274-10': {
    url: SignTwoSevenFourHyphenOneZero,
    aspectRatio: 1,
  },
  '274-100': {
    url: SignTwoSevenFourHyphenOneZeroZero,
    aspectRatio: 1,
  },
  '274-110': {
    url: SignTwoSevenFourHyphenOneOneZero,
    aspectRatio: 1,
  },
  '274-120': {
    url: SignTwoSevenFourHyphenOneTwoZero,
    aspectRatio: 1,
  },
  '274-130': {
    url: SignTwoSevenFourHyphenOneThreeZero,
    aspectRatio: 1,
  },
  '274-20': {
    url: SignTwoSevenFourHyphenTwoZero,
    aspectRatio: 1,
  },
  '274-30': {
    url: SignTwoSevenFourHyphenThreeZero,
    aspectRatio: 1,
  },
  '274-40': {
    url: SignTwoSevenFourHyphenFourZero,
    aspectRatio: 1,
  },
  '274-5': {
    url: SignTwoSevenFourHyphenFive,
    aspectRatio: 1,
  },
  '274-50': {
    url: SignTwoSevenFourHyphenFiveZero,
    aspectRatio: 1,
  },
  '274-60': {
    url: SignTwoSevenFourHyphenSixZero,
    aspectRatio: 1,
  },
  '274-70': {
    url: SignTwoSevenFourHyphenSevenZero,
    aspectRatio: 1,
  },
  '274-80': {
    url: SignTwoSevenFourHyphenEightZero,
    aspectRatio: 1,
  },
  '274-90': {
    url: SignTwoSevenFourHyphenNineZero,
    aspectRatio: 1,
  },
  '274.1-20': {
    url: SignTwoSevenFourDotOneHyphenTwoZero,
    aspectRatio: 1,
  },
  '274.1': {
    url: SignTwoSevenFourDotOne,
    aspectRatio: 1,
  },
  '274.2-20': {
    url: SignTwoSevenFourDotTwoHyphenTwoZero,
    aspectRatio: 1,
  },
  '274.2': {
    url: SignTwoSevenFourDotTwo,
    aspectRatio: 1,
  },
  '275': {
    url: SignTwoSevenFive,
    aspectRatio: 1,
  },
  '276': {
    url: SignTwoSevenSix,
    aspectRatio: 1,
  },
  '277.1': {
    url: SignTwoSevenSevenDotOne,
    aspectRatio: 1,
  },
  '277': {
    url: SignTwoSevenSeven,
    aspectRatio: 1,
  },
  '278-10': {
    url: SignTwoSevenEightHyphenOneZero,
    aspectRatio: 1,
  },
  '278-100': {
    url: SignTwoSevenEightHyphenOneZeroZero,
    aspectRatio: 1,
  },
  '278-110': {
    url: SignTwoSevenEightHyphenOneOneZero,
    aspectRatio: 1,
  },
  '278-120': {
    url: SignTwoSevenEightHyphenOneTwoZero,
    aspectRatio: 1,
  },
  '278-130': {
    url: SignTwoSevenEightHyphenOneThreeZero,
    aspectRatio: 1,
  },
  '278-20': {
    url: SignTwoSevenEightHyphenTwoZero,
    aspectRatio: 1,
  },
  '278-30': {
    url: SignTwoSevenEightHyphenThreeZero,
    aspectRatio: 1,
  },
  '278-40': {
    url: SignTwoSevenEightHyphenFourZero,
    aspectRatio: 1,
  },
  '278-5': {
    url: SignTwoSevenEightHyphenFive,
    aspectRatio: 1,
  },
  '278-50': {
    url: SignTwoSevenEightHyphenFiveZero,
    aspectRatio: 1,
  },
  '278-60': {
    url: SignTwoSevenEightHyphenSixZero,
    aspectRatio: 1,
  },
  '278-70': {
    url: SignTwoSevenEightHyphenSevenZero,
    aspectRatio: 1,
  },
  '278-80': {
    url: SignTwoSevenEightHyphenEightZero,
    aspectRatio: 1,
  },
  '278-90': {
    url: SignTwoSevenEightHyphenNineZero,
    aspectRatio: 1,
  },
  '279': {
    url: SignTwoSevenNine,
    aspectRatio: 1,
  },
  '280': {
    url: SignTwoEightZero,
    aspectRatio: 1,
  },
  '281.1': {
    url: SignTwoEightOneDotOne,
    aspectRatio: 1,
  },
  '281': {
    url: SignTwoEightOne,
    aspectRatio: 1,
  },
  '282': {
    url: SignTwoEightTwo,
    aspectRatio: 1,
  },
  '283-10': {
    url: SignTwoEightThreeHyphenOneZero,
    aspectRatio: 1,
  },
  '283-11': {
    url: SignTwoEightThreeHyphenOneOne,
    aspectRatio: 1,
  },
  '283-20': {
    url: SignTwoEightThreeHyphenTwoZero,
    aspectRatio: 1,
  },
  '283-21': {
    url: SignTwoEightThreeHyphenTwoOne,
    aspectRatio: 1,
  },
  '283-30': {
    url: SignTwoEightThreeHyphenThreeZero,
    aspectRatio: 1,
  },
  '283-31': {
    url: SignTwoEightThreeHyphenThreeOne,
    aspectRatio: 1,
  },
  '283': {
    url: SignTwoEightThree,
    aspectRatio: 1,
  },
  '286-10': {
    url: SignTwoEightSixHyphenOneZero,
    aspectRatio: 1,
  },
  '286-11': {
    url: SignTwoEightSixHyphenOneOne,
    aspectRatio: 1,
  },
  '286-20': {
    url: SignTwoEightSixHyphenTwoZero,
    aspectRatio: 1,
  },
  '286-21': {
    url: SignTwoEightSixHyphenTwoOne,
    aspectRatio: 1,
  },
  '286-30': {
    url: SignTwoEightSixHyphenThreeZero,
    aspectRatio: 1,
  },
  '286-31': {
    url: SignTwoEightSixHyphenThreeOne,
    aspectRatio: 1,
  },
  '286': {
    url: SignTwoEightSix,
    aspectRatio: 1,
  },
  '290.1': {
    url: SignTwoNineZeroDotOne,
    aspectRatio: 1,
  },
  '290.2': {
    url: SignTwoNineZeroDotTwo,
    aspectRatio: 1,
  },
  '293': {
    url: SignTwoNineThree,
    aspectRatio: 5.016822051074179,
  },
  '294': {
    url: SignTwoNineFour,
    aspectRatio: 1.5423445339820587,
  },
  '295': {
    url: SignTwoNineFive,
    aspectRatio: 2.1870114251352972,
  },
  '296': {
    url: SignTwoNineSix,
    aspectRatio: 2.184305885293015,
  },
  '297.1': {
    url: SignTwoNineSevenDotOne,
    aspectRatio: 0.9373962690035185,
  },
  '297': {
    url: SignTwoNineSeven,
    aspectRatio: 1.215989348153294,
  },
  '298': {
    url: SignTwoNineEight,
    aspectRatio: 1.060918918918919,
  },
  '299': {
    url: SignTwoNineNine,
    aspectRatio: 1.166519644432381,
  },
  '301': {
    url: SignThreeZeroOne,
    aspectRatio: 1.1379634444820825,
  },
  '306': {
    url: SignThreeZeroSix,
    aspectRatio: 1,
  },
  '307': {
    url: SignThreeZeroSeven,
    aspectRatio: 1,
  },
  '308': {
    url: SignThreeZeroEight,
    aspectRatio: 1,
  },
  '310': {
    url: SignThreeOneZero,
    aspectRatio: 1.5,
  },
  '311': {
    url: SignThreeOneOne,
    aspectRatio: 1.5,
  },
  '314-10': {
    url: SignThreeOneFourHyphenOneZero,
    aspectRatio: 1,
  },
  '314-20': {
    url: SignThreeOneFourHyphenTwoZero,
    aspectRatio: 1,
  },
  '314-30': {
    url: SignThreeOneFourHyphenThreeZero,
    aspectRatio: 1,
  },
  '314-31': {
    url: SignThreeOneFourHyphenThreeOne,
    aspectRatio: 1,
  },
  '314-50': {
    url: SignThreeOneFourHyphenFiveZero,
    aspectRatio: 1,
  },
  '314.1': {
    url: SignThreeOneFourDotOne,
    aspectRatio: 1,
  },
  '314.2': {
    url: SignThreeOneFourDotTwo,
    aspectRatio: 1,
  },
  '314': {
    url: SignThreeOneFour,
    aspectRatio: 1,
  },
  '315-50': {
    url: SignThreeOneFiveHyphenFiveZero,
    aspectRatio: 0.6666692798570063,
  },
  '315-51': {
    url: SignThreeOneFiveHyphenFiveOne,
    aspectRatio: 0.6666692798570063,
  },
  '315-52': {
    url: SignThreeOneFiveHyphenFiveTwo,
    aspectRatio: 0.6666692798570063,
  },
  '315-53': {
    url: SignThreeOneFiveHyphenFiveThree,
    aspectRatio: 0.6666692798570063,
  },
  '315-55': {
    url: SignThreeOneFiveHyphenFiveFive,
    aspectRatio: 0.6666692798570063,
  },
  '315-56': {
    url: SignThreeOneFiveHyphenFiveSix,
    aspectRatio: 0.6666692798570063,
  },
  '315-57': {
    url: SignThreeOneFiveHyphenFiveSeven,
    aspectRatio: 0.6666692798570063,
  },
  '315-58': {
    url: SignThreeOneFiveHyphenFiveEight,
    aspectRatio: 0.6666692798570063,
  },
  '315-60': {
    url: SignThreeOneFiveHyphenSixZero,
    aspectRatio: 0.6666692798570063,
  },
  '315-61': {
    url: SignThreeOneFiveHyphenSixOne,
    aspectRatio: 0.6666692798570063,
  },
  '315-62': {
    url: SignThreeOneFiveHyphenSixTwo,
    aspectRatio: 0.6666692798570063,
  },
  '315-63': {
    url: SignThreeOneFiveHyphenSixThree,
    aspectRatio: 0.6666692798570063,
  },
  '315-65': {
    url: SignThreeOneFiveHyphenSixFive,
    aspectRatio: 0.6666692798570063,
  },
  '315-66': {
    url: SignThreeOneFiveHyphenSixSix,
    aspectRatio: 0.6666692798570063,
  },
  '315-67': {
    url: SignThreeOneFiveHyphenSixSeven,
    aspectRatio: 0.6666692798570063,
  },
  '315-68': {
    url: SignThreeOneFiveHyphenSixEight,
    aspectRatio: 0.6666692798570063,
  },
  '315-70': {
    url: SignThreeOneFiveHyphenSevenZero,
    aspectRatio: 0.6666692798570063,
  },
  '315-71': {
    url: SignThreeOneFiveHyphenSevenOne,
    aspectRatio: 0.6666692798570063,
  },
  '315-72': {
    url: SignThreeOneFiveHyphenSevenTwo,
    aspectRatio: 0.6666692798570063,
  },
  '315-73': {
    url: SignThreeOneFiveHyphenSevenThree,
    aspectRatio: 0.6666692798570063,
  },
  '315-75': {
    url: SignThreeOneFiveHyphenSevenFive,
    aspectRatio: 0.6666692798570063,
  },
  '315-76': {
    url: SignThreeOneFiveHyphenSevenSix,
    aspectRatio: 0.6666692798570063,
  },
  '315-77': {
    url: SignThreeOneFiveHyphenSevenSeven,
    aspectRatio: 0.6666692798570063,
  },
  '315-78': {
    url: SignThreeOneFiveHyphenSevenEight,
    aspectRatio: 0.6666692798570063,
  },
  '315-80': {
    url: SignThreeOneFiveHyphenEightZero,
    aspectRatio: 0.6666692798570063,
  },
  '315-81': {
    url: SignThreeOneFiveHyphenEightOne,
    aspectRatio: 0.6666692798570063,
  },
  '315-82': {
    url: SignThreeOneFiveHyphenEightTwo,
    aspectRatio: 0.6666692798570063,
  },
  '315-83': {
    url: SignThreeOneFiveHyphenEightThree,
    aspectRatio: 0.6666692798570063,
  },
  '315-85': {
    url: SignThreeOneFiveHyphenEightFive,
    aspectRatio: 0.6666692798570063,
  },
  '315-86': {
    url: SignThreeOneFiveHyphenEightSix,
    aspectRatio: 0.6666692798570063,
  },
  '315-87': {
    url: SignThreeOneFiveHyphenEightSeven,
    aspectRatio: 0.6666692798570063,
  },
  '315-88': {
    url: SignThreeOneFiveHyphenEightEight,
    aspectRatio: 0.6666692798570063,
  },
  '316-50': {
    url: SignThreeOneSixHyphenFiveZero,
    aspectRatio: 1,
  },
  '316': {
    url: SignThreeOneSix,
    aspectRatio: 1,
  },
  '317': {
    url: SignThreeOneSeven,
    aspectRatio: 0.6666692798570063,
  },
  '318': {
    url: SignThreeOneEight,
    aspectRatio: 0.733342740892307,
  },
  '325.1': {
    url: SignThreeTwoFiveDotOne,
    aspectRatio: 1.4999941203447829,
  },
  '325.2': {
    url: SignThreeTwoFiveDotTwo,
    aspectRatio: 1.4999941203447829,
  },
  '327-50': {
    url: SignThreeTwoSevenHyphenFiveZero,
    aspectRatio: 0.6666692798570063,
  },
  '327-51': {
    url: SignThreeTwoSevenHyphenFiveOne,
    aspectRatio: 0.6666666666666666,
  },
  '327': {
    url: SignThreeTwoSeven,
    aspectRatio: 1,
  },
  '328': {
    url: SignThreeTwoEight,
    aspectRatio: 1,
  },
  '330.1': {
    url: SignThreeThreeZeroDotOne,
    aspectRatio: 1,
  },
  '330.2': {
    url: SignThreeThreeZeroDotTwo,
    aspectRatio: 1,
  },
  '331.1': {
    url: SignThreeThreeOneDotOne,
    aspectRatio: 1,
  },
  '331.2': {
    url: SignThreeThreeOneDotTwo,
    aspectRatio: 1,
  },
  '332.1-20': {
    url: SignThreeThreeTwoDotOneHyphenTwoZero,
    aspectRatio: 1.0241863951190446,
  },
  '332.1': {
    url: SignThreeThreeTwoDotOne,
    aspectRatio: 1.7777777777777777,
  },
  '332': {
    url: SignThreeThreeTwo,
    aspectRatio: 1.7777777777777777,
  },
  '333.1-20': {
    url: SignThreeThreeThreeDotOneHyphenTwoZero,
    aspectRatio: 4.0000141112388965,
  },
  '333.1': {
    url: SignThreeThreeThreeDotOne,
    aspectRatio: 4.0000141112388965,
  },
  '333': {
    url: SignThreeThreeThree,
    aspectRatio: 1.7777777777777777,
  },
  '340': {
    url: SignThreeFourZero,
    aspectRatio: 3.0913407472197925,
  },
  '341': {
    url: SignThreeFourOne,
    aspectRatio: 1.5219201074185968,
  },
  '342': {
    url: SignThreeFourTwo,
    aspectRatio: 1.9999435952394382,
  },
  '350-10': {
    url: SignThreeFiveZeroHyphenOneZero,
    aspectRatio: 1,
  },
  '350-20': {
    url: SignThreeFiveZeroHyphenTwoZero,
    aspectRatio: 1,
  },
  '350.1': {
    url: SignThreeFiveZeroDotOne,
    aspectRatio: 1,
  },
  '350.2': {
    url: SignThreeFiveZeroDotTwo,
    aspectRatio: 1,
  },
  '354': {
    url: SignThreeFiveFour,
    aspectRatio: 0.6666692798570063,
  },
  '356': {
    url: SignThreeFiveSix,
    aspectRatio: 0.6666692798570063,
  },
  '357-50': {
    url: SignThreeFiveSevenHyphenFiveZero,
    aspectRatio: 0.6666692798570063,
  },
  '357-51': {
    url: SignThreeFiveSevenHyphenFiveOne,
    aspectRatio: 0.6666692798570063,
  },
  '357-52': {
    url: SignThreeFiveSevenHyphenFiveTwo,
    aspectRatio: 0.6666692798570063,
  },
  '357': {
    url: SignThreeFiveSeven,
    aspectRatio: 1,
  },
  '358': {
    url: SignThreeFiveEight,
    aspectRatio: 1,
  },
  '363': {
    url: SignThreeSixThree,
    aspectRatio: 1,
  },
  '365-50': {
    url: SignThreeSixFiveHyphenFiveZero,
    aspectRatio: 1,
  },
  '365-51': {
    url: SignThreeSixFiveHyphenFiveOne,
    aspectRatio: 1,
  },
  '365-52': {
    url: SignThreeSixFiveHyphenFiveTwo,
    aspectRatio: 1,
  },
  '365-53': {
    url: SignThreeSixFiveHyphenFiveThree,
    aspectRatio: 1,
  },
  '365-54': {
    url: SignThreeSixFiveHyphenFiveFour,
    aspectRatio: 1,
  },
  '365-55': {
    url: SignThreeSixFiveHyphenFiveFive,
    aspectRatio: 1,
  },
  '365-56': {
    url: SignThreeSixFiveHyphenFiveSix,
    aspectRatio: 1,
  },
  '365-57': {
    url: SignThreeSixFiveHyphenFiveSeven,
    aspectRatio: 1,
  },
  '365-58': {
    url: SignThreeSixFiveHyphenFiveEight,
    aspectRatio: 1,
  },
  '365-59': {
    url: SignThreeSixFiveHyphenFiveNine,
    aspectRatio: 1,
  },
  '365-60': {
    url: SignThreeSixFiveHyphenSixZero,
    aspectRatio: 1,
  },
  '365-61': {
    url: SignThreeSixFiveHyphenSixOne,
    aspectRatio: 1,
  },
  '365-62': {
    url: SignThreeSixFiveHyphenSixTwo,
    aspectRatio: 1,
  },
  '365-63': {
    url: SignThreeSixFiveHyphenSixThree,
    aspectRatio: 1,
  },
  '365-64': {
    url: SignThreeSixFiveHyphenSixFour,
    aspectRatio: 1,
  },
  '365-65': {
    url: SignThreeSixFiveHyphenSixFive,
    aspectRatio: 1,
  },
  '365-66': {
    url: SignThreeSixFiveHyphenSixSix,
    aspectRatio: 1,
  },
  '365-67': {
    url: SignThreeSixFiveHyphenSixSeven,
    aspectRatio: 1,
  },
  '365-68': {
    url: SignThreeSixFiveHyphenSixEight,
    aspectRatio: 1,
  },
  '365-69': {
    url: SignThreeSixFiveHyphenSixNine,
    aspectRatio: 1,
  },
  '365-70': {
    url: SignThreeSixFiveHyphenSevenZero,
    aspectRatio: 1.2499970601723913,
  },
  '365-71': {
    url: SignThreeSixFiveHyphenSevenOne,
    aspectRatio: 1.4999941203447829,
  },
  '385': {
    url: SignThreeEightFive,
    aspectRatio: 3,
  },
  '386.1-10': {
    url: SignThreeEightSixDotOneHyphenOneZero,
    aspectRatio: 4.444418312950768,
  },
  '386.1-11': {
    url: SignThreeEightSixDotOneHyphenOneOne,
    aspectRatio: 4.444418312950768,
  },
  '386.1-12': {
    url: SignThreeEightSixDotOneHyphenOneTwo,
    aspectRatio: 4.999823617602963,
  },
  '386.1-20': {
    url: SignThreeEightSixDotOneHyphenTwoZero,
    aspectRatio: 4.444418312950768,
  },
  '386.1-21': {
    url: SignThreeEightSixDotOneHyphenTwoOne,
    aspectRatio: 4.444418312950768,
  },
  '386.1-22': {
    url: SignThreeEightSixDotOneHyphenTwoTwo,
    aspectRatio: 4.374812593703148,
  },
  '386.1-30': {
    url: SignThreeEightSixDotOneHyphenThreeZero,
    aspectRatio: 4.444418312950768,
  },
  '386.1-50': {
    url: SignThreeEightSixDotOneHyphenFiveZero,
    aspectRatio: 2.751546114546921,
  },
  '386.1-51': {
    url: SignThreeEightSixDotOneHyphenFiveOne,
    aspectRatio: 2.751546114546921,
  },
  '386.1-52': {
    url: SignThreeEightSixDotOneHyphenFiveTwo,
    aspectRatio: 2.751546114546921,
  },
  '386.1-53': {
    url: SignThreeEightSixDotOneHyphenFiveThree,
    aspectRatio: 1.5,
  },
  '386.1': {
    url: SignThreeEightSixDotOne,
    aspectRatio: 3.24241258031066,
  },
  '386.2-10': {
    url: SignThreeEightSixDotTwoHyphenOneZero,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-11': {
    url: SignThreeEightSixDotTwoHyphenOneOne,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-12': {
    url: SignThreeEightSixDotTwoHyphenOneTwo,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-20': {
    url: SignThreeEightSixDotTwoHyphenTwoZero,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-21': {
    url: SignThreeEightSixDotTwoHyphenTwoOne,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-22': {
    url: SignThreeEightSixDotTwoHyphenTwoTwo,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-30': {
    url: SignThreeEightSixDotTwoHyphenThreeZero,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-51': {
    url: SignThreeEightSixDotTwoHyphenFiveOne,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-52': {
    url: SignThreeEightSixDotTwoHyphenFiveTwo,
    aspectRatio: 1.7777777777777777,
  },
  '386.2-53': {
    url: SignThreeEightSixDotTwoHyphenFiveThree,
    aspectRatio: 3.124615473686242,
  },
  '386.2': {
    url: SignThreeEightSixDotTwo,
    aspectRatio: 1.903580454928391,
  },
  '386.3-50': {
    url: SignThreeEightSixDotThreeHyphenFiveZero,
    aspectRatio: 1.4998219090642995,
  },
  '386.3': {
    url: SignThreeEightSixDotThree,
    aspectRatio: 1.5,
  },
  '390.2': {
    url: SignThreeNineZeroDotTwo,
    aspectRatio: 1,
  },
  '390': {
    url: SignThreeNineZero,
    aspectRatio: 1,
  },
  '391': {
    url: SignThreeNineOne,
    aspectRatio: 1,
  },
  '392': {
    url: SignThreeNineTwo,
    aspectRatio: 1,
  },
  '393': {
    url: SignThreeNineThree,
    aspectRatio: 1.7777777777777777,
  },
  '394-50': {
    url: SignThreeNineFourHyphenFiveZero,
    aspectRatio: 2.142878742062292,
  },
  '394': {
    url: SignThreeNineFour,
    aspectRatio: 14.286009474851326,
  },
  '401': {
    url: SignFourZeroOne,
    aspectRatio: 1.6799875821973866,
  },
  '405': {
    url: SignFourZeroFive,
    aspectRatio: 1.6799875821973866,
  },
  '406-50': {
    url: SignFourZeroSixHyphenFiveZero,
    aspectRatio: 1,
  },
  '406-51': {
    url: SignFourZeroSixHyphenFiveOne,
    aspectRatio: 1.749986219568213,
  },
  '410': {
    url: SignFourOneZero,
    aspectRatio: 1.6799875821973866,
  },
  '415-10': {
    url: SignFourOneFiveHyphenOneZero,
    aspectRatio: 4.000070556692302,
  },
  '415-20': {
    url: SignFourOneFiveHyphenTwoZero,
    aspectRatio: 4.0000141112388965,
  },
  '418-10': {
    url: SignFourOneEightHyphenOneZero,
    aspectRatio: 4.0000141112388965,
  },
  '418-20': {
    url: SignFourOneEightHyphenTwoZero,
    aspectRatio: 4.0000141112388965,
  },
  '419-10': {
    url: SignFourOneNineHyphenOneZero,
    aspectRatio: 3.999985888860667,
  },
  '419-20': {
    url: SignFourOneNineHyphenTwoZero,
    aspectRatio: 3.999985888860667,
  },
  '421-10': {
    url: SignFourTwoOneHyphenOneZero,
    aspectRatio: 4.0000141112388965,
  },
  '421-11': {
    url: SignFourTwoOneHyphenOneOne,
    aspectRatio: 4.0000141112388965,
  },
  '421-12': {
    url: SignFourTwoOneHyphenOneTwo,
    aspectRatio: 4.0000141112388965,
  },
  '421-20': {
    url: SignFourTwoOneHyphenTwoZero,
    aspectRatio: 4.0000141112388965,
  },
  '421-21': {
    url: SignFourTwoOneHyphenTwoOne,
    aspectRatio: 4.0000141112388965,
  },
  '421-22': {
    url: SignFourTwoOneHyphenTwoTwo,
    aspectRatio: 4.0000141112388965,
  },
  '422-10': {
    url: SignFourTwoTwoHyphenOneZero,
    aspectRatio: 0.6666692798570063,
  },
  '422-11': {
    url: SignFourTwoTwoHyphenOneOne,
    aspectRatio: 0.6666692798570063,
  },
  '422-12': {
    url: SignFourTwoTwoHyphenOneTwo,
    aspectRatio: 0.6666692798570063,
  },
  '422-13': {
    url: SignFourTwoTwoHyphenOneThree,
    aspectRatio: 0.6666692798570063,
  },
  '422-14': {
    url: SignFourTwoTwoHyphenOneFour,
    aspectRatio: 0.6666692798570063,
  },
  '422-15': {
    url: SignFourTwoTwoHyphenOneFive,
    aspectRatio: 0.6666692798570063,
  },
  '422-16': {
    url: SignFourTwoTwoHyphenOneSix,
    aspectRatio: 0.6666666666666666,
  },
  '422-17': {
    url: SignFourTwoTwoHyphenOneSeven,
    aspectRatio: 0.6666666666666666,
  },
  '422-20': {
    url: SignFourTwoTwoHyphenTwoZero,
    aspectRatio: 0.6666692798570063,
  },
  '422-21': {
    url: SignFourTwoTwoHyphenTwoOne,
    aspectRatio: 0.6666692798570063,
  },
  '422-22': {
    url: SignFourTwoTwoHyphenTwoTwo,
    aspectRatio: 0.6666692798570063,
  },
  '422-23': {
    url: SignFourTwoTwoHyphenTwoThree,
    aspectRatio: 0.6666692798570063,
  },
  '422-24': {
    url: SignFourTwoTwoHyphenTwoFour,
    aspectRatio: 0.6666692798570063,
  },
  '422-25': {
    url: SignFourTwoTwoHyphenTwoFive,
    aspectRatio: 0.6666692798570063,
  },
  '422-26': {
    url: SignFourTwoTwoHyphenTwoSix,
    aspectRatio: 0.6666666666666666,
  },
  '422-27': {
    url: SignFourTwoTwoHyphenTwoSeven,
    aspectRatio: 0.6666666666666666,
  },
  '422-30': {
    url: SignFourTwoTwoHyphenThreeZero,
    aspectRatio: 0.6666692798570063,
  },
  '422-32': {
    url: SignFourTwoTwoHyphenThreeTwo,
    aspectRatio: 0.6666692798570063,
  },
  '422-34': {
    url: SignFourTwoTwoHyphenThreeFour,
    aspectRatio: 0.6666692798570063,
  },
  '422-36': {
    url: SignFourTwoTwoHyphenThreeSix,
    aspectRatio: 0.6666666666666666,
  },
  '430-10': {
    url: SignFourThreeZeroHyphenOneZero,
    aspectRatio: 3.7500022048771884,
  },
  '430-20': {
    url: SignFourThreeZeroHyphenTwoZero,
    aspectRatio: 4.0000141112388965,
  },
  '432-10': {
    url: SignFourThreeTwoHyphenOneZero,
    aspectRatio: 3.7500022048771884,
  },
  '432-20': {
    url: SignFourThreeTwoHyphenTwoZero,
    aspectRatio: 4.0000141112388965,
  },
  '434-50': {
    url: SignFourThreeFourHyphenFiveZero,
    aspectRatio: 1.2810158673978738,
  },
  '434-51': {
    url: SignFourThreeFourHyphenFiveOne,
    aspectRatio: 1.1553873046063998,
  },
  '434-52': {
    url: SignFourThreeFourHyphenFiveTwo,
    aspectRatio: 1.5,
  },
  '434-53': {
    url: SignFourThreeFourHyphenFiveThree,
    aspectRatio: 1.034482423039212,
  },
  '437': {
    url: SignFourThreeSeven,
    aspectRatio: 5.105789235639983,
  },
  '438': {
    url: SignFourThreeEight,
    aspectRatio: 0.7146631932389326,
  },
  '439': {
    url: SignFourThreeNine,
    aspectRatio: 1.539986122470391,
  },
  '440': {
    url: SignFourFourZero,
    aspectRatio: 1.7777777777777777,
  },
  '441': {
    url: SignFourFourOne,
    aspectRatio: 1.19852893140009,
  },
  '442-10': {
    url: SignFourFourTwoHyphenOneZero,
    aspectRatio: 0.6666692798570063,
  },
  '442-11': {
    url: SignFourFourTwoHyphenOneOne,
    aspectRatio: 0.6666692798570063,
  },
  '442-12': {
    url: SignFourFourTwoHyphenOneTwo,
    aspectRatio: 0.6666692798570063,
  },
  '442-13': {
    url: SignFourFourTwoHyphenOneThree,
    aspectRatio: 0.6666692798570063,
  },
  '442-14': {
    url: SignFourFourTwoHyphenOneFour,
    aspectRatio: 0.6666692798570063,
  },
  '442-15': {
    url: SignFourFourTwoHyphenOneFive,
    aspectRatio: 0.6666692798570063,
  },
  '442-16': {
    url: SignFourFourTwoHyphenOneSix,
    aspectRatio: 0.6666692798570063,
  },
  '442-17': {
    url: SignFourFourTwoHyphenOneSeven,
    aspectRatio: 0.6666692798570063,
  },
  '442-20': {
    url: SignFourFourTwoHyphenTwoZero,
    aspectRatio: 0.6666692798570063,
  },
  '442-21': {
    url: SignFourFourTwoHyphenTwoOne,
    aspectRatio: 0.6666692798570063,
  },
  '442-22': {
    url: SignFourFourTwoHyphenTwoTwo,
    aspectRatio: 0.6666692798570063,
  },
  '442-23': {
    url: SignFourFourTwoHyphenTwoThree,
    aspectRatio: 0.6666692798570063,
  },
  '442-24': {
    url: SignFourFourTwoHyphenTwoFour,
    aspectRatio: 0.6666692798570063,
  },
  '442-25': {
    url: SignFourFourTwoHyphenTwoFive,
    aspectRatio: 0.6666692798570063,
  },
  '442-26': {
    url: SignFourFourTwoHyphenTwoSix,
    aspectRatio: 0.6666692798570063,
  },
  '442-27': {
    url: SignFourFourTwoHyphenTwoSeven,
    aspectRatio: 0.6666692798570063,
  },
  '442-30': {
    url: SignFourFourTwoHyphenThreeZero,
    aspectRatio: 0.6666692798570063,
  },
  '442-31': {
    url: SignFourFourTwoHyphenThreeOne,
    aspectRatio: 0.6666692798570063,
  },
  '442-32': {
    url: SignFourFourTwoHyphenThreeTwo,
    aspectRatio: 0.6666692798570063,
  },
  '442-33': {
    url: SignFourFourTwoHyphenThreeThree,
    aspectRatio: 0.6666692798570063,
  },
  '442-50': {
    url: SignFourFourTwoHyphenFiveZero,
    aspectRatio: 0.6666666666666666,
  },
  '442-51': {
    url: SignFourFourTwoHyphenFiveOne,
    aspectRatio: 0.6666666666666666,
  },
  '442-52': {
    url: SignFourFourTwoHyphenFiveTwo,
    aspectRatio: 0.6666666666666666,
  },
  '442-53': {
    url: SignFourFourTwoHyphenFiveThree,
    aspectRatio: 0.6666666666666666,
  },
  '448-50': {
    url: SignFourFourEightHyphenFiveZero,
    aspectRatio: 1.970695453797126,
  },
  '448.1': {
    url: SignFourFourEightDotOne,
    aspectRatio: 1.3999992944405442,
  },
  '448': {
    url: SignFourFourEight,
    aspectRatio: 1.7777777777777777,
  },
  '448AK': {
    url: SignFourFourEightAK,
    aspectRatio: 1.6382892485063199,
  },
  '449-50': {
    url: SignFourFourNineHyphenFiveZero,
    aspectRatio: 1.1475223648385844,
  },
  '449': {
    url: SignFourFourNine,
    aspectRatio: 1.7777777777777777,
  },
  '450-50': {
    url: SignFourFiveZeroHyphenFiveZero,
    aspectRatio: 0.4333339604980315,
  },
  '450-51': {
    url: SignFourFiveZeroHyphenFiveOne,
    aspectRatio: 0.4333339604980315,
  },
  '450-52': {
    url: SignFourFiveZeroHyphenFiveTwo,
    aspectRatio: 0.4333339604980315,
  },
  '450-53': {
    url: SignFourFiveZeroHyphenFiveThree,
    aspectRatio: 0.4333339604980315,
  },
  '450-54': {
    url: SignFourFiveZeroHyphenFiveFour,
    aspectRatio: 0.4333339604980315,
  },
  '450-55': {
    url: SignFourFiveZeroHyphenFiveFive,
    aspectRatio: 0.4333339604980315,
  },
  '453-50': {
    url: SignFourFiveThreeHyphenFiveZero,
    aspectRatio: 1.9306940703905582,
  },
  '453': {
    url: SignFourFiveThree,
    aspectRatio: 1.7777777777777777,
  },
  '454-10': {
    url: SignFourFiveFourHyphenOneZero,
    aspectRatio: 3.5714228117566424,
  },
  '454-20': {
    url: SignFourFiveFourHyphenTwoZero,
    aspectRatio: 3.5714228117566424,
  },
  '455.1-10': {
    url: SignFourFiveFiveDotOneHyphenOneZero,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-11': {
    url: SignFourFiveFiveDotOneHyphenOneOne,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-12': {
    url: SignFourFiveFiveDotOneHyphenOneTwo,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-13': {
    url: SignFourFiveFiveDotOneHyphenOneThree,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-20': {
    url: SignFourFiveFiveDotOneHyphenTwoZero,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-21': {
    url: SignFourFiveFiveDotOneHyphenTwoOne,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-22': {
    url: SignFourFiveFiveDotOneHyphenTwoTwo,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-23': {
    url: SignFourFiveFiveDotOneHyphenTwoThree,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-30': {
    url: SignFourFiveFiveDotOneHyphenThreeZero,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-31': {
    url: SignFourFiveFiveDotOneHyphenThreeOne,
    aspectRatio: 0.6666692798570063,
  },
  '455.1-50': {
    url: SignFourFiveFiveDotOneHyphenFiveZero,
    aspectRatio: 0.6666666666666666,
  },
  '455.2': {
    url: SignFourFiveFiveDotTwo,
    aspectRatio: 0.6666692798570063,
  },
  '457.1': {
    url: SignFourFiveSevenDotOne,
    aspectRatio: 3,
  },
  '457.2': {
    url: SignFourFiveSevenDotTwo,
    aspectRatio: 3,
  },
  '458': {
    url: SignFourFiveEight,
    aspectRatio: 0.7812497243903516,
  },
  '460-10': {
    url: SignFourSixZeroHyphenOneZero,
    aspectRatio: 0.6666692798570063,
  },
  '460-11': {
    url: SignFourSixZeroHyphenOneOne,
    aspectRatio: 0.6666692798570063,
  },
  '460-12': {
    url: SignFourSixZeroHyphenOneTwo,
    aspectRatio: 0.6666692798570063,
  },
  '460-13': {
    url: SignFourSixZeroHyphenOneThree,
    aspectRatio: 0.6666692798570063,
  },
  '460-20': {
    url: SignFourSixZeroHyphenTwoZero,
    aspectRatio: 0.6666692798570063,
  },
  '460-21': {
    url: SignFourSixZeroHyphenTwoOne,
    aspectRatio: 0.6666692798570063,
  },
  '460-22': {
    url: SignFourSixZeroHyphenTwoTwo,
    aspectRatio: 0.6666692798570063,
  },
  '460-23': {
    url: SignFourSixZeroHyphenTwoThree,
    aspectRatio: 0.6666692798570063,
  },
  '460-30': {
    url: SignFourSixZeroHyphenThreeZero,
    aspectRatio: 0.6666692798570063,
  },
  '460-31': {
    url: SignFourSixZeroHyphenThreeOne,
    aspectRatio: 0.6666692798570063,
  },
  '460-50': {
    url: SignFourSixZeroHyphenFiveZero,
    aspectRatio: 0.6666666666666666,
  },
  '466': {
    url: SignFourSixSix,
    aspectRatio: 0.7812497243903516,
  },
  '467.1-10': {
    url: SignFourSixSevenDotOneHyphenOneZero,
    aspectRatio: 1.5625016536578913,
  },
  '467.1-20': {
    url: SignFourSixSevenDotOneHyphenTwoZero,
    aspectRatio: 1.5625016536578913,
  },
  '467.1-30': {
    url: SignFourSixSevenDotOneHyphenThreeZero,
    aspectRatio: 0.6399993226624445,
  },
  '467.2': {
    url: SignFourSixSevenDotTwo,
    aspectRatio: 0.6399993226624445,
  },
  '501-10': {
    url: SignFiveZeroOneHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '501-11': {
    url: SignFiveZeroOneHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '501-12': {
    url: SignFiveZeroOneHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '501-13': {
    url: SignFiveZeroOneHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '501-14': {
    url: SignFiveZeroOneHyphenOneFour,
    aspectRatio: 0.7812497243903516,
  },
  '501-15': {
    url: SignFiveZeroOneHyphenOneFive,
    aspectRatio: 0.7812497243903516,
  },
  '501-16': {
    url: SignFiveZeroOneHyphenOneSix,
    aspectRatio: 0.7812497243903516,
  },
  '501-17': {
    url: SignFiveZeroOneHyphenOneSeven,
    aspectRatio: 0.7812497243903516,
  },
  '501-18': {
    url: SignFiveZeroOneHyphenOneEight,
    aspectRatio: 0.7812497243903516,
  },
  '501-19': {
    url: SignFiveZeroOneHyphenOneNine,
    aspectRatio: 1,
  },
  '501-20': {
    url: SignFiveZeroOneHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '501-21': {
    url: SignFiveZeroOneHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '501-22': {
    url: SignFiveZeroOneHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '501-23': {
    url: SignFiveZeroOneHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '501-24': {
    url: SignFiveZeroOneHyphenTwoFour,
    aspectRatio: 0.7812497243903516,
  },
  '501-25': {
    url: SignFiveZeroOneHyphenTwoFive,
    aspectRatio: 0.7812497243903516,
  },
  '501-26': {
    url: SignFiveZeroOneHyphenTwoSix,
    aspectRatio: 0.7812497243903516,
  },
  '501-27': {
    url: SignFiveZeroOneHyphenTwoSeven,
    aspectRatio: 0.7812497243903516,
  },
  '501-28': {
    url: SignFiveZeroOneHyphenTwoEight,
    aspectRatio: 0.7812497243903516,
  },
  '501-29': {
    url: SignFiveZeroOneHyphenTwoNine,
    aspectRatio: 1,
  },
  '501-50': {
    url: SignFiveZeroOneHyphenFiveZero,
    aspectRatio: 1,
  },
  '501-51': {
    url: SignFiveZeroOneHyphenFiveOne,
    aspectRatio: 1,
  },
  '501-52': {
    url: SignFiveZeroOneHyphenFiveTwo,
    aspectRatio: 1,
  },
  '501-53': {
    url: SignFiveZeroOneHyphenFiveThree,
    aspectRatio: 1,
  },
  '501-54': {
    url: SignFiveZeroOneHyphenFiveFour,
    aspectRatio: 1,
  },
  '501-60': {
    url: SignFiveZeroOneHyphenSixZero,
    aspectRatio: 1,
  },
  '501-61': {
    url: SignFiveZeroOneHyphenSixOne,
    aspectRatio: 1,
  },
  '501-62': {
    url: SignFiveZeroOneHyphenSixTwo,
    aspectRatio: 1,
  },
  '501-63': {
    url: SignFiveZeroOneHyphenSixThree,
    aspectRatio: 1,
  },
  '501-64': {
    url: SignFiveZeroOneHyphenSixFour,
    aspectRatio: 1,
  },
  '501-70': {
    url: SignFiveZeroOneHyphenSevenZero,
    aspectRatio: 0.7812497243903516,
  },
  '501-71': {
    url: SignFiveZeroOneHyphenSevenOne,
    aspectRatio: 1,
  },
  '501-72': {
    url: SignFiveZeroOneHyphenSevenTwo,
    aspectRatio: 1,
  },
  '501-73': {
    url: SignFiveZeroOneHyphenSevenThree,
    aspectRatio: 1,
  },
  '501-74': {
    url: SignFiveZeroOneHyphenSevenFour,
    aspectRatio: 1,
  },
  '501-75': {
    url: SignFiveZeroOneHyphenSevenFive,
    aspectRatio: 1,
  },
  '501-80': {
    url: SignFiveZeroOneHyphenEightZero,
    aspectRatio: 0.7812497243903516,
  },
  '501-81': {
    url: SignFiveZeroOneHyphenEightOne,
    aspectRatio: 1,
  },
  '501-82': {
    url: SignFiveZeroOneHyphenEightTwo,
    aspectRatio: 1,
  },
  '501-83': {
    url: SignFiveZeroOneHyphenEightThree,
    aspectRatio: 1,
  },
  '501-84': {
    url: SignFiveZeroOneHyphenEightFour,
    aspectRatio: 1,
  },
  '501-85': {
    url: SignFiveZeroOneHyphenEightFive,
    aspectRatio: 1,
  },
  '505-11': {
    url: SignFiveZeroFiveHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '505-12': {
    url: SignFiveZeroFiveHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '505-21': {
    url: SignFiveZeroFiveHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '505-22': {
    url: SignFiveZeroFiveHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '511-10': {
    url: SignFiveOneOneHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '511-11': {
    url: SignFiveOneOneHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '511-12': {
    url: SignFiveOneOneHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '511-13': {
    url: SignFiveOneOneHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '511-20': {
    url: SignFiveOneOneHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '511-21': {
    url: SignFiveOneOneHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '511-22': {
    url: SignFiveOneOneHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '511-23': {
    url: SignFiveOneOneHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '511-25': {
    url: SignFiveOneOneHyphenTwoFive,
    aspectRatio: 0.7812497243903516,
  },
  '511-26': {
    url: SignFiveOneOneHyphenTwoSix,
    aspectRatio: 0.7812497243903516,
  },
  '511-27': {
    url: SignFiveOneOneHyphenTwoSeven,
    aspectRatio: 0.7812497243903516,
  },
  '511-28': {
    url: SignFiveOneOneHyphenTwoEight,
    aspectRatio: 1,
  },
  '512-10': {
    url: SignFiveOneTwoHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '512-11': {
    url: SignFiveOneTwoHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '512-12': {
    url: SignFiveOneTwoHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '512-20': {
    url: SignFiveOneTwoHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '512-21': {
    url: SignFiveOneTwoHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '512-22': {
    url: SignFiveOneTwoHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '513-10': {
    url: SignFiveOneThreeHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '513-11': {
    url: SignFiveOneThreeHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '513-12': {
    url: SignFiveOneThreeHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '513-13': {
    url: SignFiveOneThreeHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '513-14': {
    url: SignFiveOneThreeHyphenOneFour,
    aspectRatio: 1,
  },
  '513-20': {
    url: SignFiveOneThreeHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '513-21': {
    url: SignFiveOneThreeHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '513-22': {
    url: SignFiveOneThreeHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '513-23': {
    url: SignFiveOneThreeHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '513-24': {
    url: SignFiveOneThreeHyphenTwoFour,
    aspectRatio: 1,
  },
  '514-10': {
    url: SignFiveOneFourHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '514-11': {
    url: SignFiveOneFourHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '514-12': {
    url: SignFiveOneFourHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '514-13': {
    url: SignFiveOneFourHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '514-14': {
    url: SignFiveOneFourHyphenOneFour,
    aspectRatio: 0.7812497243903516,
  },
  '514-15': {
    url: SignFiveOneFourHyphenOneFive,
    aspectRatio: 1,
  },
  '514-16': {
    url: SignFiveOneFourHyphenOneSix,
    aspectRatio: 0.7812497243903516,
  },
  '514-17': {
    url: SignFiveOneFourHyphenOneSeven,
    aspectRatio: 1,
  },
  '514-18': {
    url: SignFiveOneFourHyphenOneEight,
    aspectRatio: 1,
  },
  '514-20': {
    url: SignFiveOneFourHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '514-21': {
    url: SignFiveOneFourHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '514-22': {
    url: SignFiveOneFourHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '514-23': {
    url: SignFiveOneFourHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '514-24': {
    url: SignFiveOneFourHyphenTwoFour,
    aspectRatio: 0.7812497243903516,
  },
  '514-25': {
    url: SignFiveOneFourHyphenTwoFive,
    aspectRatio: 1,
  },
  '514-26': {
    url: SignFiveOneFourHyphenTwoSix,
    aspectRatio: 0.7812497243903516,
  },
  '514-27': {
    url: SignFiveOneFourHyphenTwoSeven,
    aspectRatio: 1,
  },
  '514-28': {
    url: SignFiveOneFourHyphenTwoEight,
    aspectRatio: 1,
  },
  '515-11': {
    url: SignFiveOneFiveHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '515-12': {
    url: SignFiveOneFiveHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '515-21': {
    url: SignFiveOneFiveHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '515-22': {
    url: SignFiveOneFiveHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '521-30': {
    url: SignFiveTwoOneHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '521-31': {
    url: SignFiveTwoOneHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '521-32': {
    url: SignFiveTwoOneHyphenThreeTwo,
    aspectRatio: 0.7812497243903516,
  },
  '521-33': {
    url: SignFiveTwoOneHyphenThreeThree,
    aspectRatio: 0.7812497243903516,
  },
  '522-30': {
    url: SignFiveTwoTwoHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '522-31': {
    url: SignFiveTwoTwoHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '522-32': {
    url: SignFiveTwoTwoHyphenThreeTwo,
    aspectRatio: 0.7812497243903516,
  },
  '522-33': {
    url: SignFiveTwoTwoHyphenThreeThree,
    aspectRatio: 0.7812497243903516,
  },
  '522-34': {
    url: SignFiveTwoTwoHyphenThreeFour,
    aspectRatio: 0.7812497243903516,
  },
  '522-35': {
    url: SignFiveTwoTwoHyphenThreeFive,
    aspectRatio: 0.7812497243903516,
  },
  '522-36': {
    url: SignFiveTwoTwoHyphenThreeSix,
    aspectRatio: 0.7812497243903516,
  },
  '522-37': {
    url: SignFiveTwoTwoHyphenThreeSeven,
    aspectRatio: 0.7812497243903516,
  },
  '522-38': {
    url: SignFiveTwoTwoHyphenThreeEight,
    aspectRatio: 0.7812497243903516,
  },
  '523-30': {
    url: SignFiveTwoThreeHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '523-31': {
    url: SignFiveTwoThreeHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '524-30': {
    url: SignFiveTwoFourHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '524-31': {
    url: SignFiveTwoFourHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '524-32': {
    url: SignFiveTwoFourHyphenThreeTwo,
    aspectRatio: 0.7812497243903516,
  },
  '524-33': {
    url: SignFiveTwoFourHyphenThreeThree,
    aspectRatio: 0.7812497243903516,
  },
  '525-31': {
    url: SignFiveTwoFiveHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '526-31': {
    url: SignFiveTwoSixHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '526-33': {
    url: SignFiveTwoSixHyphenThreeThree,
    aspectRatio: 0.7812497243903516,
  },
  '527-30': {
    url: SignFiveTwoSevenHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '527-31': {
    url: SignFiveTwoSevenHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '528-30': {
    url: SignFiveTwoEightHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '528-31': {
    url: SignFiveTwoEightHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '529-30': {
    url: SignFiveTwoNineHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '529-31': {
    url: SignFiveTwoNineHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '531-10': {
    url: SignFiveThreeOneHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '531-11': {
    url: SignFiveThreeOneHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '531-12': {
    url: SignFiveThreeOneHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '531-13': {
    url: SignFiveThreeOneHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '531-14': {
    url: SignFiveThreeOneHyphenOneFour,
    aspectRatio: 0.7812497243903516,
  },
  '531-15': {
    url: SignFiveThreeOneHyphenOneFive,
    aspectRatio: 0.7812497243903516,
  },
  '531-16': {
    url: SignFiveThreeOneHyphenOneSix,
    aspectRatio: 1,
  },
  '531-20': {
    url: SignFiveThreeOneHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '531-21': {
    url: SignFiveThreeOneHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '531-22': {
    url: SignFiveThreeOneHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '531-23': {
    url: SignFiveThreeOneHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '531-24': {
    url: SignFiveThreeOneHyphenTwoFour,
    aspectRatio: 0.7812497243903516,
  },
  '531-25': {
    url: SignFiveThreeOneHyphenTwoFive,
    aspectRatio: 0.7812497243903516,
  },
  '531-26': {
    url: SignFiveThreeOneHyphenTwoSix,
    aspectRatio: 1,
  },
  '532-10': {
    url: SignFiveThreeTwoHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '532-20': {
    url: SignFiveThreeTwoHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '532-21': {
    url: SignFiveThreeTwoHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '533-20': {
    url: SignFiveThreeThreeHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '533-21': {
    url: SignFiveThreeThreeHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '533-22': {
    url: SignFiveThreeThreeHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '533-23': {
    url: SignFiveThreeThreeHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '533-24': {
    url: SignFiveThreeThreeHyphenTwoFour,
    aspectRatio: 1,
  },
  '533-25': {
    url: SignFiveThreeThreeHyphenTwoFive,
    aspectRatio: 1,
  },
  '533-26': {
    url: SignFiveThreeThreeHyphenTwoSix,
    aspectRatio: 1,
  },
  '533-27': {
    url: SignFiveThreeThreeHyphenTwoSeven,
    aspectRatio: 1,
  },
  '533-28': {
    url: SignFiveThreeThreeHyphenTwoEight,
    aspectRatio: 1.2500022048771884,
  },
  '533-29': {
    url: SignFiveThreeThreeHyphenTwoNine,
    aspectRatio: 1.2500022048771884,
  },
  '533-60': {
    url: SignFiveThreeThreeHyphenSixZero,
    aspectRatio: 0.7812497243903516,
  },
  '533-61': {
    url: SignFiveThreeThreeHyphenSixOne,
    aspectRatio: 0.7812497243903516,
  },
  '533-62': {
    url: SignFiveThreeThreeHyphenSixTwo,
    aspectRatio: 1,
  },
  '533-63': {
    url: SignFiveThreeThreeHyphenSixThree,
    aspectRatio: 1,
  },
  '535-11': {
    url: SignFiveThreeFiveHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '535-21': {
    url: SignFiveThreeFiveHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '536-20': {
    url: SignFiveThreeSixHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '536-21': {
    url: SignFiveThreeSixHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '537-30': {
    url: SignFiveThreeSevenHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '537-31': {
    url: SignFiveThreeSevenHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '538-30': {
    url: SignFiveThreeEightHyphenThreeZero,
    aspectRatio: 0.7812497243903516,
  },
  '538-31': {
    url: SignFiveThreeEightHyphenThreeOne,
    aspectRatio: 0.7812497243903516,
  },
  '541-10': {
    url: SignFiveFourOneHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '541-11': {
    url: SignFiveFourOneHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '541-12': {
    url: SignFiveFourOneHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '541-13': {
    url: SignFiveFourOneHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '541-20': {
    url: SignFiveFourOneHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '541-21': {
    url: SignFiveFourOneHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '541-22': {
    url: SignFiveFourOneHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '541-23': {
    url: SignFiveFourOneHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '542-10': {
    url: SignFiveFourTwoHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '542-11': {
    url: SignFiveFourTwoHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '542-12': {
    url: SignFiveFourTwoHyphenOneTwo,
    aspectRatio: 0.7812497243903516,
  },
  '542-13': {
    url: SignFiveFourTwoHyphenOneThree,
    aspectRatio: 0.7812497243903516,
  },
  '542-14': {
    url: SignFiveFourTwoHyphenOneFour,
    aspectRatio: 0.7812497243903516,
  },
  '542-15': {
    url: SignFiveFourTwoHyphenOneFive,
    aspectRatio: 1,
  },
  '545-11': {
    url: SignFiveFourFiveHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '546-10': {
    url: SignFiveFourSixHyphenOneZero,
    aspectRatio: 0.7812497243903516,
  },
  '546-11': {
    url: SignFiveFourSixHyphenOneOne,
    aspectRatio: 0.7812497243903516,
  },
  '550-20': {
    url: SignFiveFiveZeroHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '550-21': {
    url: SignFiveFiveZeroHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '550-22': {
    url: SignFiveFiveZeroHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '550-23': {
    url: SignFiveFiveZeroHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '550-24': {
    url: SignFiveFiveZeroHyphenTwoFour,
    aspectRatio: 0.7812497243903516,
  },
  '550-25': {
    url: SignFiveFiveZeroHyphenTwoFive,
    aspectRatio: 0.7812497243903516,
  },
  '550-26': {
    url: SignFiveFiveZeroHyphenTwoSix,
    aspectRatio: 1,
  },
  '550-27': {
    url: SignFiveFiveZeroHyphenTwoSeven,
    aspectRatio: 1.2500022048771884,
  },
  '550-28': {
    url: SignFiveFiveZeroHyphenTwoEight,
    aspectRatio: 1,
  },
  '550-29': {
    url: SignFiveFiveZeroHyphenTwoNine,
    aspectRatio: 1.2500022048771884,
  },
  '550-60': {
    url: SignFiveFiveZeroHyphenSixZero,
    aspectRatio: 1.2500022048771884,
  },
  '551-20': {
    url: SignFiveFiveOneHyphenTwoZero,
    aspectRatio: 0.7812497243903516,
  },
  '551-21': {
    url: SignFiveFiveOneHyphenTwoOne,
    aspectRatio: 0.7812497243903516,
  },
  '551-22': {
    url: SignFiveFiveOneHyphenTwoTwo,
    aspectRatio: 0.7812497243903516,
  },
  '551-23': {
    url: SignFiveFiveOneHyphenTwoThree,
    aspectRatio: 0.7812497243903516,
  },
  '551-24': {
    url: SignFiveFiveOneHyphenTwoFour,
    aspectRatio: 0.7812497243903516,
  },
  '551-25': {
    url: SignFiveFiveOneHyphenTwoFive,
    aspectRatio: 0.7812497243903516,
  },
  '551-26': {
    url: SignFiveFiveOneHyphenTwoSix,
    aspectRatio: 1,
  },
  '551-27': {
    url: SignFiveFiveOneHyphenTwoSeven,
    aspectRatio: 1,
  },
  '551-28': {
    url: SignFiveFiveOneHyphenTwoEight,
    aspectRatio: 1,
  },
  '551-29': {
    url: SignFiveFiveOneHyphenTwoNine,
    aspectRatio: 1,
  },
  '551-60': {
    url: SignFiveFiveOneHyphenSixZero,
    aspectRatio: 1,
  },
  '590-10': {
    url: SignFiveNineZeroHyphenOneZero,
    aspectRatio: 1,
  },
  '590-11': {
    url: SignFiveNineZeroHyphenOneOne,
    aspectRatio: 1,
  },
  '600-30': {
    url: SignSixZeroZeroHyphenThreeZero,
    aspectRatio: 8.000070556692302,
  },
  '600-31': {
    url: SignSixZeroZeroHyphenThreeOne,
    aspectRatio: 12.000105835038456,
  },
  '600-32': {
    url: SignSixZeroZeroHyphenThreeTwo,
    aspectRatio: 16.000141113384604,
  },
  '600-33': {
    url: SignSixZeroZeroHyphenThreeThree,
    aspectRatio: 4.7999745999492,
  },
  '600-34': {
    url: SignSixZeroZeroHyphenThreeFour,
    aspectRatio: 6.3999661332655995,
  },
  '600-35': {
    url: SignSixZeroZeroHyphenThreeFive,
    aspectRatio: 7.999971777721334,
  },
  '600-36': {
    url: SignSixZeroZeroHyphenThreeSix,
    aspectRatio: 9.599963311037733,
  },
  '600-37': {
    url: SignSixZeroZeroHyphenThreeSeven,
    aspectRatio: 3.2000056444955582,
  },
  '600-38': {
    url: SignSixZeroZeroHyphenThreeEight,
    aspectRatio: 4.0000141112388965,
  },
  '600-39': {
    url: SignSixZeroZeroHyphenThreeNine,
    aspectRatio: 4.800015522362786,
  },
  '600-60': {
    url: SignSixZeroZeroHyphenSixZero,
    aspectRatio: 0.1666647067815943,
  },
  '605-10': {
    url: SignSixZeroFiveHyphenOneZero,
    aspectRatio: 0.25000088194931963,
  },
  '605-11': {
    url: SignSixZeroFiveHyphenOneOne,
    aspectRatio: 0.25000088194931963,
  },
  '605-12': {
    url: SignSixZeroFiveHyphenOneTwo,
    aspectRatio: 0.12500044097465982,
  },
  '605-13': {
    url: SignSixZeroFiveHyphenOneThree,
    aspectRatio: 0.19999943555203717,
  },
  '605-14': {
    url: SignSixZeroFiveHyphenOneFour,
    aspectRatio: 0.19999943555203717,
  },
  '605-20': {
    url: SignSixZeroFiveHyphenTwoZero,
    aspectRatio: 0.25000088194931963,
  },
  '605-21': {
    url: SignSixZeroFiveHyphenTwoOne,
    aspectRatio: 0.25000088194931963,
  },
  '605-22': {
    url: SignSixZeroFiveHyphenTwoTwo,
    aspectRatio: 0.12500044097465982,
  },
  '605-23': {
    url: SignSixZeroFiveHyphenTwoThree,
    aspectRatio: 0.19999943555203717,
  },
  '605-24': {
    url: SignSixZeroFiveHyphenTwoFour,
    aspectRatio: 0.19999943555203717,
  },
  '610-40': {
    url: SignSixOneZeroHyphenFourZero,
    aspectRatio: 0.5454510467980296,
  },
  '610-41': {
    url: SignSixOneZeroHyphenFourOne,
    aspectRatio: 0.5882362706687031,
  },
  '610-42': {
    url: SignSixOneZeroHyphenFourTwo,
    aspectRatio: 0.5384611209708495,
  },
  '610-43': {
    url: SignSixOneZeroHyphenFourThree,
    aspectRatio: 0.4999980401149276,
  },
  '615': {
    url: SignSixOneFive,
    aspectRatio: 0.6800003386687777,
  },
  '616-30': {
    url: SignSixOneSixHyphenThreeZero,
    aspectRatio: 1.7777777777777777,
  },
  '616-31': {
    url: SignSixOneSixHyphenThreeOne,
    aspectRatio: 0.6800003386687777,
  },
  '620-40': {
    url: SignSixTwoZeroHyphenFourZero,
    aspectRatio: 0.11428389038960339,
  },
  '620-41': {
    url: SignSixTwoZeroHyphenFourOne,
    aspectRatio: 0.11428389038960339,
  },
  '625-10': {
    url: SignSixTwoFiveHyphenOneZero,
    aspectRatio: 1,
  },
  '625-11': {
    url: SignSixTwoFiveHyphenOneOne,
    aspectRatio: 3.000007055619448,
  },
  '625-12': {
    url: SignSixTwoFiveHyphenOneTwo,
    aspectRatio: 4.0000141112388965,
  },
  '625-13': {
    url: SignSixTwoFiveHyphenOneThree,
    aspectRatio: 5.0000141112388965,
  },
  '625-20': {
    url: SignSixTwoFiveHyphenTwoZero,
    aspectRatio: 1,
  },
  '625-21': {
    url: SignSixTwoFiveHyphenTwoOne,
    aspectRatio: 3.000007055619448,
  },
  '625-22': {
    url: SignSixTwoFiveHyphenTwoTwo,
    aspectRatio: 4.0000141112388965,
  },
  '625-23': {
    url: SignSixTwoFiveHyphenTwoThree,
    aspectRatio: 5.0000141112388965,
  },
  '626-10': {
    url: SignSixTwoSixHyphenOneZero,
    aspectRatio: 0.6666650987549213,
  },
  '626-20': {
    url: SignSixTwoSixHyphenTwoZero,
    aspectRatio: 0.6666650987549213,
  },
  '626-30': {
    url: SignSixTwoSixHyphenThreeZero,
    aspectRatio: 0.6666650987549213,
  },
  '626-31': {
    url: SignSixTwoSixHyphenThreeOne,
    aspectRatio: 0.5000014699181256,
  },
  '626-32': {
    url: SignSixTwoSixHyphenThreeTwo,
    aspectRatio: 0.19999943555203717,
  },
  '627-10': {
    url: SignSixTwoSevenHyphenOneZero,
    aspectRatio: 0.096154289738305,
  },
  '627-20': {
    url: SignSixTwoSevenHyphenTwoZero,
    aspectRatio: 0.096154289738305,
  },
  '627-30': {
    url: SignSixTwoSevenHyphenThreeZero,
    aspectRatio: 7.999971777721334,
  },
  '627-50': {
    url: SignSixTwoSevenHyphenFiveZero,
    aspectRatio: 0.6727860678338641,
  },
  '628-10': {
    url: SignSixTwoEightHyphenOneZero,
    aspectRatio: 0.3473154773573809,
  },
  '628-11': {
    url: SignSixTwoEightHyphenOneOne,
    aspectRatio: 0.3473154773573809,
  },
  '628-20': {
    url: SignSixTwoEightHyphenTwoZero,
    aspectRatio: 0.3473154773573809,
  },
  '628-21': {
    url: SignSixTwoEightHyphenTwoOne,
    aspectRatio: 0.3473154773573809,
  },
  '629-10': {
    url: SignSixTwoNineHyphenOneZero,
    aspectRatio: 0.31904364416885284,
  },
  '629-11': {
    url: SignSixTwoNineHyphenOneOne,
    aspectRatio: 0.31904364416885284,
  },
  '629-20': {
    url: SignSixTwoNineHyphenTwoZero,
    aspectRatio: 0.3190388651190031,
  },
  '629-21': {
    url: SignSixTwoNineHyphenTwoOne,
    aspectRatio: 0.31904364416885284,
  },
  '630-10': {
    url: SignSixThreeZeroHyphenOneZero,
    aspectRatio: 1,
  },
  '630-20': {
    url: SignSixThreeZeroHyphenTwoZero,
    aspectRatio: 1,
  },
  '720': {
    url: SignSevenTwoZero,
    aspectRatio: 1,
  },
  '721': {
    url: SignSevenTwoOne,
    aspectRatio: 0.7500041997748921,
  },
  'KNr-100': {
    url: SignKNrHyphenOneZeroZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-100a': {
    url: SignKNrHyphenOneZeroZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-100b': {
    url: SignKNrHyphenOneZeroZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-101': {
    url: SignKNrHyphenOneZeroOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-101a': {
    url: SignKNrHyphenOneZeroOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-101b': {
    url: SignKNrHyphenOneZeroOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-102': {
    url: SignKNrHyphenOneZeroTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-102a': {
    url: SignKNrHyphenOneZeroTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-102b': {
    url: SignKNrHyphenOneZeroTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-103': {
    url: SignKNrHyphenOneZeroThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-103a': {
    url: SignKNrHyphenOneZeroThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-103b': {
    url: SignKNrHyphenOneZeroThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-104': {
    url: SignKNrHyphenOneZeroFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-104a': {
    url: SignKNrHyphenOneZeroFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-104b': {
    url: SignKNrHyphenOneZeroFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-105': {
    url: SignKNrHyphenOneZeroFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-105a': {
    url: SignKNrHyphenOneZeroFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-105b': {
    url: SignKNrHyphenOneZeroFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-106': {
    url: SignKNrHyphenOneZeroSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-106a': {
    url: SignKNrHyphenOneZeroSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-106b': {
    url: SignKNrHyphenOneZeroSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-107': {
    url: SignKNrHyphenOneZeroSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-107a': {
    url: SignKNrHyphenOneZeroSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-107b': {
    url: SignKNrHyphenOneZeroSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-108': {
    url: SignKNrHyphenOneZeroEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-108a': {
    url: SignKNrHyphenOneZeroEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-108b': {
    url: SignKNrHyphenOneZeroEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-109': {
    url: SignKNrHyphenOneZeroNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-109a': {
    url: SignKNrHyphenOneZeroNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-109b': {
    url: SignKNrHyphenOneZeroNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-110': {
    url: SignKNrHyphenOneOneZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-110a': {
    url: SignKNrHyphenOneOneZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-110b': {
    url: SignKNrHyphenOneOneZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-111': {
    url: SignKNrHyphenOneOneOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-111a': {
    url: SignKNrHyphenOneOneOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-111b': {
    url: SignKNrHyphenOneOneOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-112': {
    url: SignKNrHyphenOneOneTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-112a': {
    url: SignKNrHyphenOneOneTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-112b': {
    url: SignKNrHyphenOneOneTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-113': {
    url: SignKNrHyphenOneOneThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-113a': {
    url: SignKNrHyphenOneOneThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-113b': {
    url: SignKNrHyphenOneOneThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-114': {
    url: SignKNrHyphenOneOneFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-114a': {
    url: SignKNrHyphenOneOneFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-114b': {
    url: SignKNrHyphenOneOneFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-115': {
    url: SignKNrHyphenOneOneFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-115a': {
    url: SignKNrHyphenOneOneFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-115b': {
    url: SignKNrHyphenOneOneFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-116': {
    url: SignKNrHyphenOneOneSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-116a': {
    url: SignKNrHyphenOneOneSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-116b': {
    url: SignKNrHyphenOneOneSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-117': {
    url: SignKNrHyphenOneOneSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-117a': {
    url: SignKNrHyphenOneOneSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-117b': {
    url: SignKNrHyphenOneOneSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-118': {
    url: SignKNrHyphenOneOneEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-118a': {
    url: SignKNrHyphenOneOneEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-118b': {
    url: SignKNrHyphenOneOneEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-119': {
    url: SignKNrHyphenOneOneNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-119a': {
    url: SignKNrHyphenOneOneNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-119b': {
    url: SignKNrHyphenOneOneNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-120': {
    url: SignKNrHyphenOneTwoZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-120a': {
    url: SignKNrHyphenOneTwoZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-120b': {
    url: SignKNrHyphenOneTwoZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-121': {
    url: SignKNrHyphenOneTwoOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-121a': {
    url: SignKNrHyphenOneTwoOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-121b': {
    url: SignKNrHyphenOneTwoOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-122': {
    url: SignKNrHyphenOneTwoTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-122a': {
    url: SignKNrHyphenOneTwoTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-122b': {
    url: SignKNrHyphenOneTwoTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-123': {
    url: SignKNrHyphenOneTwoThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-123a': {
    url: SignKNrHyphenOneTwoThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-123b': {
    url: SignKNrHyphenOneTwoThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-124': {
    url: SignKNrHyphenOneTwoFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-124a': {
    url: SignKNrHyphenOneTwoFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-124b': {
    url: SignKNrHyphenOneTwoFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-125': {
    url: SignKNrHyphenOneTwoFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-125a': {
    url: SignKNrHyphenOneTwoFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-125b': {
    url: SignKNrHyphenOneTwoFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-126': {
    url: SignKNrHyphenOneTwoSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-126a': {
    url: SignKNrHyphenOneTwoSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-126b': {
    url: SignKNrHyphenOneTwoSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-127': {
    url: SignKNrHyphenOneTwoSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-127a': {
    url: SignKNrHyphenOneTwoSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-127b': {
    url: SignKNrHyphenOneTwoSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-128': {
    url: SignKNrHyphenOneTwoEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-128a': {
    url: SignKNrHyphenOneTwoEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-128b': {
    url: SignKNrHyphenOneTwoEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-129': {
    url: SignKNrHyphenOneTwoNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-129a': {
    url: SignKNrHyphenOneTwoNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-129b': {
    url: SignKNrHyphenOneTwoNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-130': {
    url: SignKNrHyphenOneThreeZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-130a': {
    url: SignKNrHyphenOneThreeZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-130b': {
    url: SignKNrHyphenOneThreeZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-131': {
    url: SignKNrHyphenOneThreeOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-131a': {
    url: SignKNrHyphenOneThreeOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-131b': {
    url: SignKNrHyphenOneThreeOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-132': {
    url: SignKNrHyphenOneThreeTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-132a': {
    url: SignKNrHyphenOneThreeTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-132b': {
    url: SignKNrHyphenOneThreeTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-133': {
    url: SignKNrHyphenOneThreeThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-133a': {
    url: SignKNrHyphenOneThreeThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-133b': {
    url: SignKNrHyphenOneThreeThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-134': {
    url: SignKNrHyphenOneThreeFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-134a': {
    url: SignKNrHyphenOneThreeFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-134b': {
    url: SignKNrHyphenOneThreeFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-135': {
    url: SignKNrHyphenOneThreeFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-135a': {
    url: SignKNrHyphenOneThreeFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-135b': {
    url: SignKNrHyphenOneThreeFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-136': {
    url: SignKNrHyphenOneThreeSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-136a': {
    url: SignKNrHyphenOneThreeSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-136b': {
    url: SignKNrHyphenOneThreeSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-137': {
    url: SignKNrHyphenOneThreeSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-137a': {
    url: SignKNrHyphenOneThreeSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-137b': {
    url: SignKNrHyphenOneThreeSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-138': {
    url: SignKNrHyphenOneThreeEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-138a': {
    url: SignKNrHyphenOneThreeEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-138b': {
    url: SignKNrHyphenOneThreeEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-139': {
    url: SignKNrHyphenOneThreeNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-139a': {
    url: SignKNrHyphenOneThreeNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-139b': {
    url: SignKNrHyphenOneThreeNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-140': {
    url: SignKNrHyphenOneFourZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-140a': {
    url: SignKNrHyphenOneFourZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-140b': {
    url: SignKNrHyphenOneFourZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-141': {
    url: SignKNrHyphenOneFourOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-141a': {
    url: SignKNrHyphenOneFourOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-141b': {
    url: SignKNrHyphenOneFourOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-142': {
    url: SignKNrHyphenOneFourTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-142a': {
    url: SignKNrHyphenOneFourTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-142b': {
    url: SignKNrHyphenOneFourTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-143': {
    url: SignKNrHyphenOneFourThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-143a': {
    url: SignKNrHyphenOneFourThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-143b': {
    url: SignKNrHyphenOneFourThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-144': {
    url: SignKNrHyphenOneFourFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-144a': {
    url: SignKNrHyphenOneFourFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-144b': {
    url: SignKNrHyphenOneFourFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-145': {
    url: SignKNrHyphenOneFourFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-145a': {
    url: SignKNrHyphenOneFourFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-145b': {
    url: SignKNrHyphenOneFourFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-146': {
    url: SignKNrHyphenOneFourSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-146a': {
    url: SignKNrHyphenOneFourSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-146b': {
    url: SignKNrHyphenOneFourSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-147': {
    url: SignKNrHyphenOneFourSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-147a': {
    url: SignKNrHyphenOneFourSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-147b': {
    url: SignKNrHyphenOneFourSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-148': {
    url: SignKNrHyphenOneFourEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-148a': {
    url: SignKNrHyphenOneFourEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-148b': {
    url: SignKNrHyphenOneFourEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-149': {
    url: SignKNrHyphenOneFourNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-149a': {
    url: SignKNrHyphenOneFourNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-149b': {
    url: SignKNrHyphenOneFourNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-150': {
    url: SignKNrHyphenOneFiveZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-150a': {
    url: SignKNrHyphenOneFiveZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-150b': {
    url: SignKNrHyphenOneFiveZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-151': {
    url: SignKNrHyphenOneFiveOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-151a': {
    url: SignKNrHyphenOneFiveOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-151b': {
    url: SignKNrHyphenOneFiveOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-152': {
    url: SignKNrHyphenOneFiveTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-152a': {
    url: SignKNrHyphenOneFiveTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-152b': {
    url: SignKNrHyphenOneFiveTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-153': {
    url: SignKNrHyphenOneFiveThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-153a': {
    url: SignKNrHyphenOneFiveThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-153b': {
    url: SignKNrHyphenOneFiveThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-154': {
    url: SignKNrHyphenOneFiveFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-154a': {
    url: SignKNrHyphenOneFiveFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-154b': {
    url: SignKNrHyphenOneFiveFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-155': {
    url: SignKNrHyphenOneFiveFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-155a': {
    url: SignKNrHyphenOneFiveFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-155b': {
    url: SignKNrHyphenOneFiveFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-156': {
    url: SignKNrHyphenOneFiveSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-156a': {
    url: SignKNrHyphenOneFiveSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-156b': {
    url: SignKNrHyphenOneFiveSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-157': {
    url: SignKNrHyphenOneFiveSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-157a': {
    url: SignKNrHyphenOneFiveSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-157b': {
    url: SignKNrHyphenOneFiveSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-158': {
    url: SignKNrHyphenOneFiveEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-158a': {
    url: SignKNrHyphenOneFiveEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-158b': {
    url: SignKNrHyphenOneFiveEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-159': {
    url: SignKNrHyphenOneFiveNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-159a': {
    url: SignKNrHyphenOneFiveNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-159b': {
    url: SignKNrHyphenOneFiveNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-160': {
    url: SignKNrHyphenOneSixZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-160a': {
    url: SignKNrHyphenOneSixZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-160b': {
    url: SignKNrHyphenOneSixZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-161': {
    url: SignKNrHyphenOneSixOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-161a': {
    url: SignKNrHyphenOneSixOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-161b': {
    url: SignKNrHyphenOneSixOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-162': {
    url: SignKNrHyphenOneSixTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-162a': {
    url: SignKNrHyphenOneSixTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-162b': {
    url: SignKNrHyphenOneSixTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-163': {
    url: SignKNrHyphenOneSixThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-163a': {
    url: SignKNrHyphenOneSixThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-163b': {
    url: SignKNrHyphenOneSixThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-164': {
    url: SignKNrHyphenOneSixFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-164a': {
    url: SignKNrHyphenOneSixFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-164b': {
    url: SignKNrHyphenOneSixFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-165': {
    url: SignKNrHyphenOneSixFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-165a': {
    url: SignKNrHyphenOneSixFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-165b': {
    url: SignKNrHyphenOneSixFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-166': {
    url: SignKNrHyphenOneSixSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-166a': {
    url: SignKNrHyphenOneSixSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-166b': {
    url: SignKNrHyphenOneSixSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-167': {
    url: SignKNrHyphenOneSixSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-167a': {
    url: SignKNrHyphenOneSixSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-167b': {
    url: SignKNrHyphenOneSixSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-168': {
    url: SignKNrHyphenOneSixEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-168a': {
    url: SignKNrHyphenOneSixEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-168b': {
    url: SignKNrHyphenOneSixEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-169': {
    url: SignKNrHyphenOneSixNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-169a': {
    url: SignKNrHyphenOneSixNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-169b': {
    url: SignKNrHyphenOneSixNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-170': {
    url: SignKNrHyphenOneSevenZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-170a': {
    url: SignKNrHyphenOneSevenZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-170b': {
    url: SignKNrHyphenOneSevenZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-171': {
    url: SignKNrHyphenOneSevenOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-171a': {
    url: SignKNrHyphenOneSevenOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-171b': {
    url: SignKNrHyphenOneSevenOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-172': {
    url: SignKNrHyphenOneSevenTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-172a': {
    url: SignKNrHyphenOneSevenTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-172b': {
    url: SignKNrHyphenOneSevenTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-173': {
    url: SignKNrHyphenOneSevenThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-173a': {
    url: SignKNrHyphenOneSevenThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-173b': {
    url: SignKNrHyphenOneSevenThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-174': {
    url: SignKNrHyphenOneSevenFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-174a': {
    url: SignKNrHyphenOneSevenFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-174b': {
    url: SignKNrHyphenOneSevenFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-175': {
    url: SignKNrHyphenOneSevenFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-175a': {
    url: SignKNrHyphenOneSevenFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-175b': {
    url: SignKNrHyphenOneSevenFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-176': {
    url: SignKNrHyphenOneSevenSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-176a': {
    url: SignKNrHyphenOneSevenSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-176b': {
    url: SignKNrHyphenOneSevenSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-177': {
    url: SignKNrHyphenOneSevenSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-177a': {
    url: SignKNrHyphenOneSevenSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-177b': {
    url: SignKNrHyphenOneSevenSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-178': {
    url: SignKNrHyphenOneSevenEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-178a': {
    url: SignKNrHyphenOneSevenEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-178b': {
    url: SignKNrHyphenOneSevenEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-179': {
    url: SignKNrHyphenOneSevenNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-179a': {
    url: SignKNrHyphenOneSevenNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-179b': {
    url: SignKNrHyphenOneSevenNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-180': {
    url: SignKNrHyphenOneEightZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-180a': {
    url: SignKNrHyphenOneEightZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-180b': {
    url: SignKNrHyphenOneEightZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-181': {
    url: SignKNrHyphenOneEightOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-181a': {
    url: SignKNrHyphenOneEightOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-181b': {
    url: SignKNrHyphenOneEightOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-182': {
    url: SignKNrHyphenOneEightTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-182a': {
    url: SignKNrHyphenOneEightTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-182b': {
    url: SignKNrHyphenOneEightTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-183': {
    url: SignKNrHyphenOneEightThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-183a': {
    url: SignKNrHyphenOneEightThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-183b': {
    url: SignKNrHyphenOneEightThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-184': {
    url: SignKNrHyphenOneEightFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-184a': {
    url: SignKNrHyphenOneEightFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-184b': {
    url: SignKNrHyphenOneEightFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-185': {
    url: SignKNrHyphenOneEightFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-185a': {
    url: SignKNrHyphenOneEightFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-185b': {
    url: SignKNrHyphenOneEightFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-186': {
    url: SignKNrHyphenOneEightSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-186a': {
    url: SignKNrHyphenOneEightSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-186b': {
    url: SignKNrHyphenOneEightSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-187': {
    url: SignKNrHyphenOneEightSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-187a': {
    url: SignKNrHyphenOneEightSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-187b': {
    url: SignKNrHyphenOneEightSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-188': {
    url: SignKNrHyphenOneEightEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-188a': {
    url: SignKNrHyphenOneEightEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-188b': {
    url: SignKNrHyphenOneEightEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-189': {
    url: SignKNrHyphenOneEightNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-189a': {
    url: SignKNrHyphenOneEightNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-189b': {
    url: SignKNrHyphenOneEightNineb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-190': {
    url: SignKNrHyphenOneNineZero,
    aspectRatio: 1.749986219568213,
  },
  'KNr-190a': {
    url: SignKNrHyphenOneNineZeroa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-190b': {
    url: SignKNrHyphenOneNineZerob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-191': {
    url: SignKNrHyphenOneNineOne,
    aspectRatio: 1.749986219568213,
  },
  'KNr-191a': {
    url: SignKNrHyphenOneNineOnea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-191b': {
    url: SignKNrHyphenOneNineOneb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-192': {
    url: SignKNrHyphenOneNineTwo,
    aspectRatio: 1.749986219568213,
  },
  'KNr-192a': {
    url: SignKNrHyphenOneNineTwoa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-192b': {
    url: SignKNrHyphenOneNineTwob,
    aspectRatio: 1.749986219568213,
  },
  'KNr-193': {
    url: SignKNrHyphenOneNineThree,
    aspectRatio: 1.749986219568213,
  },
  'KNr-193a': {
    url: SignKNrHyphenOneNineThreea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-193b': {
    url: SignKNrHyphenOneNineThreeb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-194': {
    url: SignKNrHyphenOneNineFour,
    aspectRatio: 1.749986219568213,
  },
  'KNr-194a': {
    url: SignKNrHyphenOneNineFoura,
    aspectRatio: 1.749986219568213,
  },
  'KNr-194b': {
    url: SignKNrHyphenOneNineFourb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-195': {
    url: SignKNrHyphenOneNineFive,
    aspectRatio: 1.749986219568213,
  },
  'KNr-195a': {
    url: SignKNrHyphenOneNineFivea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-195b': {
    url: SignKNrHyphenOneNineFiveb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-196': {
    url: SignKNrHyphenOneNineSix,
    aspectRatio: 1.749986219568213,
  },
  'KNr-196a': {
    url: SignKNrHyphenOneNineSixa,
    aspectRatio: 1.749986219568213,
  },
  'KNr-196b': {
    url: SignKNrHyphenOneNineSixb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-197': {
    url: SignKNrHyphenOneNineSeven,
    aspectRatio: 1.749986219568213,
  },
  'KNr-197a': {
    url: SignKNrHyphenOneNineSevena,
    aspectRatio: 1.749986219568213,
  },
  'KNr-197b': {
    url: SignKNrHyphenOneNineSevenb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-198': {
    url: SignKNrHyphenOneNineEight,
    aspectRatio: 1.749986219568213,
  },
  'KNr-198a': {
    url: SignKNrHyphenOneNineEighta,
    aspectRatio: 1.749986219568213,
  },
  'KNr-198b': {
    url: SignKNrHyphenOneNineEightb,
    aspectRatio: 1.749986219568213,
  },
  'KNr-199': {
    url: SignKNrHyphenOneNineNine,
    aspectRatio: 1.749986219568213,
  },
  'KNr-199a': {
    url: SignKNrHyphenOneNineNinea,
    aspectRatio: 1.749986219568213,
  },
  'KNr-199b': {
    url: SignKNrHyphenOneNineNineb,
    aspectRatio: 1.749986219568213,
  },
  'kNr-001': {
    url: SignkNrHyphenZeroZeroOne,
    aspectRatio: 1,
  },
  'kNr-002': {
    url: SignkNrHyphenZeroZeroTwo,
    aspectRatio: 1,
  },
  'kNr-003': {
    url: SignkNrHyphenZeroZeroThree,
    aspectRatio: 1,
  },
  'kNr-004': {
    url: SignkNrHyphenZeroZeroFour,
    aspectRatio: 1,
  },
  'kNr-005': {
    url: SignkNrHyphenZeroZeroFive,
    aspectRatio: 1,
  },
  'kNr-006': {
    url: SignkNrHyphenZeroZeroSix,
    aspectRatio: 1,
  },
  'kNr-007': {
    url: SignkNrHyphenZeroZeroSeven,
    aspectRatio: 1,
  },
  'kNr-008': {
    url: SignkNrHyphenZeroZeroEight,
    aspectRatio: 1,
  },
  'kNr-009': {
    url: SignkNrHyphenZeroZeroNine,
    aspectRatio: 1,
  },
  'kNr-010': {
    url: SignkNrHyphenZeroOneZero,
    aspectRatio: 1,
  },
  'kNr-011': {
    url: SignkNrHyphenZeroOneOne,
    aspectRatio: 1,
  },
  'kNr-012': {
    url: SignkNrHyphenZeroOneTwo,
    aspectRatio: 1,
  },
  'kNr-013': {
    url: SignkNrHyphenZeroOneThree,
    aspectRatio: 1,
  },
  'kNr-014': {
    url: SignkNrHyphenZeroOneFour,
    aspectRatio: 1,
  },
  'kNr-015': {
    url: SignkNrHyphenZeroOneFive,
    aspectRatio: 1,
  },
  'kNr-016': {
    url: SignkNrHyphenZeroOneSix,
    aspectRatio: 1,
  },
  'kNr-017': {
    url: SignkNrHyphenZeroOneSeven,
    aspectRatio: 1,
  },
  'kNr-018': {
    url: SignkNrHyphenZeroOneEight,
    aspectRatio: 1,
  },
  'kNr-019': {
    url: SignkNrHyphenZeroOneNine,
    aspectRatio: 1,
  },
  'kNr-020': {
    url: SignkNrHyphenZeroTwoZero,
    aspectRatio: 1,
  },
  'kNr-021': {
    url: SignkNrHyphenZeroTwoOne,
    aspectRatio: 1,
  },
  'kNr-022': {
    url: SignkNrHyphenZeroTwoTwo,
    aspectRatio: 1,
  },
  'kNr-023': {
    url: SignkNrHyphenZeroTwoThree,
    aspectRatio: 1,
  },
  'kNr-024': {
    url: SignkNrHyphenZeroTwoFour,
    aspectRatio: 1,
  },
  'kNr-025': {
    url: SignkNrHyphenZeroTwoFive,
    aspectRatio: 1,
  },
  'kNr-026': {
    url: SignkNrHyphenZeroTwoSix,
    aspectRatio: 1,
  },
  'kNr-027': {
    url: SignkNrHyphenZeroTwoSeven,
    aspectRatio: 1,
  },
  'kNr-028': {
    url: SignkNrHyphenZeroTwoEight,
    aspectRatio: 1,
  },
  'kNr-029': {
    url: SignkNrHyphenZeroTwoNine,
    aspectRatio: 1,
  },
  'kNr-030': {
    url: SignkNrHyphenZeroThreeZero,
    aspectRatio: 1,
  },
  'kNr-031': {
    url: SignkNrHyphenZeroThreeOne,
    aspectRatio: 1,
  },
  'kNr-032': {
    url: SignkNrHyphenZeroThreeTwo,
    aspectRatio: 1,
  },
  'kNr-033': {
    url: SignkNrHyphenZeroThreeThree,
    aspectRatio: 1,
  },
  'kNr-034': {
    url: SignkNrHyphenZeroThreeFour,
    aspectRatio: 1,
  },
  'kNr-035': {
    url: SignkNrHyphenZeroThreeFive,
    aspectRatio: 1,
  },
  'kNr-036': {
    url: SignkNrHyphenZeroThreeSix,
    aspectRatio: 1,
  },
  'kNr-037': {
    url: SignkNrHyphenZeroThreeSeven,
    aspectRatio: 1,
  },
  'kNr-038': {
    url: SignkNrHyphenZeroThreeEight,
    aspectRatio: 1,
  },
  'kNr-039': {
    url: SignkNrHyphenZeroThreeNine,
    aspectRatio: 1,
  },
  'kNr-040': {
    url: SignkNrHyphenZeroFourZero,
    aspectRatio: 1,
  },
  'kNr-041': {
    url: SignkNrHyphenZeroFourOne,
    aspectRatio: 1,
  },
  'kNr-042': {
    url: SignkNrHyphenZeroFourTwo,
    aspectRatio: 1,
  },
  'kNr-043': {
    url: SignkNrHyphenZeroFourThree,
    aspectRatio: 1,
  },
  'kNr-044': {
    url: SignkNrHyphenZeroFourFour,
    aspectRatio: 1,
  },
  'kNr-045': {
    url: SignkNrHyphenZeroFourFive,
    aspectRatio: 1,
  },
  'kNr-046': {
    url: SignkNrHyphenZeroFourSix,
    aspectRatio: 1,
  },
  'kNr-047': {
    url: SignkNrHyphenZeroFourSeven,
    aspectRatio: 1,
  },
  'kNr-048': {
    url: SignkNrHyphenZeroFourEight,
    aspectRatio: 1,
  },
  'kNr-049': {
    url: SignkNrHyphenZeroFourNine,
    aspectRatio: 1,
  },
  'kNr-050': {
    url: SignkNrHyphenZeroFiveZero,
    aspectRatio: 1,
  },
  'kNr-051': {
    url: SignkNrHyphenZeroFiveOne,
    aspectRatio: 1,
  },
  'kNr-052': {
    url: SignkNrHyphenZeroFiveTwo,
    aspectRatio: 1,
  },
  'kNr-053': {
    url: SignkNrHyphenZeroFiveThree,
    aspectRatio: 1,
  },
  'kNr-054': {
    url: SignkNrHyphenZeroFiveFour,
    aspectRatio: 1,
  },
  'kNr-055': {
    url: SignkNrHyphenZeroFiveFive,
    aspectRatio: 1,
  },
  'kNr-056': {
    url: SignkNrHyphenZeroFiveSix,
    aspectRatio: 1,
  },
  'kNr-057': {
    url: SignkNrHyphenZeroFiveSeven,
    aspectRatio: 1,
  },
  'kNr-058': {
    url: SignkNrHyphenZeroFiveEight,
    aspectRatio: 1,
  },
  'kNr-059': {
    url: SignkNrHyphenZeroFiveNine,
    aspectRatio: 1,
  },
  'kNr-060': {
    url: SignkNrHyphenZeroSixZero,
    aspectRatio: 1,
  },
  'kNr-061': {
    url: SignkNrHyphenZeroSixOne,
    aspectRatio: 1,
  },
  'kNr-062': {
    url: SignkNrHyphenZeroSixTwo,
    aspectRatio: 1,
  },
  'kNr-063': {
    url: SignkNrHyphenZeroSixThree,
    aspectRatio: 1,
  },
  'kNr-064': {
    url: SignkNrHyphenZeroSixFour,
    aspectRatio: 1,
  },
  'kNr-065': {
    url: SignkNrHyphenZeroSixFive,
    aspectRatio: 1,
  },
  'kNr-066': {
    url: SignkNrHyphenZeroSixSix,
    aspectRatio: 1,
  },
  'kNr-067': {
    url: SignkNrHyphenZeroSixSeven,
    aspectRatio: 1,
  },
  'kNr-068': {
    url: SignkNrHyphenZeroSixEight,
    aspectRatio: 1,
  },
  'kNr-069': {
    url: SignkNrHyphenZeroSixNine,
    aspectRatio: 1,
  },
  'kNr-070': {
    url: SignkNrHyphenZeroSevenZero,
    aspectRatio: 1,
  },
  'kNr-071': {
    url: SignkNrHyphenZeroSevenOne,
    aspectRatio: 1,
  },
  'kNr-072': {
    url: SignkNrHyphenZeroSevenTwo,
    aspectRatio: 1,
  },
  'kNr-073': {
    url: SignkNrHyphenZeroSevenThree,
    aspectRatio: 1,
  },
  'kNr-074': {
    url: SignkNrHyphenZeroSevenFour,
    aspectRatio: 1,
  },
  'kNr-075': {
    url: SignkNrHyphenZeroSevenFive,
    aspectRatio: 1,
  },
  'kNr-076': {
    url: SignkNrHyphenZeroSevenSix,
    aspectRatio: 1,
  },
  'kNr-077': {
    url: SignkNrHyphenZeroSevenSeven,
    aspectRatio: 1,
  },
  'kNr-078': {
    url: SignkNrHyphenZeroSevenEight,
    aspectRatio: 1,
  },
  'kNr-079': {
    url: SignkNrHyphenZeroSevenNine,
    aspectRatio: 1,
  },
  'kNr-080': {
    url: SignkNrHyphenZeroEightZero,
    aspectRatio: 1,
  },
  'kNr-081': {
    url: SignkNrHyphenZeroEightOne,
    aspectRatio: 1,
  },
  'kNr-082': {
    url: SignkNrHyphenZeroEightTwo,
    aspectRatio: 1,
  },
  'kNr-083': {
    url: SignkNrHyphenZeroEightThree,
    aspectRatio: 1,
  },
  'kNr-084': {
    url: SignkNrHyphenZeroEightFour,
    aspectRatio: 1,
  },
  'kNr-085': {
    url: SignkNrHyphenZeroEightFive,
    aspectRatio: 1,
  },
  'kNr-086': {
    url: SignkNrHyphenZeroEightSix,
    aspectRatio: 1,
  },
  'kNr-087': {
    url: SignkNrHyphenZeroEightSeven,
    aspectRatio: 1,
  },
  'kNr-088': {
    url: SignkNrHyphenZeroEightEight,
    aspectRatio: 1,
  },
  'kNr-089': {
    url: SignkNrHyphenZeroEightNine,
    aspectRatio: 1,
  },
  'kNr-090': {
    url: SignkNrHyphenZeroNineZero,
    aspectRatio: 1,
  },
  'kNr-091': {
    url: SignkNrHyphenZeroNineOne,
    aspectRatio: 1,
  },
  'kNr-092': {
    url: SignkNrHyphenZeroNineTwo,
    aspectRatio: 1,
  },
  'kNr-093': {
    url: SignkNrHyphenZeroNineThree,
    aspectRatio: 1,
  },
  'kNr-094': {
    url: SignkNrHyphenZeroNineFour,
    aspectRatio: 1,
  },
  'kNr-095': {
    url: SignkNrHyphenZeroNineFive,
    aspectRatio: 1,
  },
  'kNr-096': {
    url: SignkNrHyphenZeroNineSix,
    aspectRatio: 1,
  },
  'kNr-097': {
    url: SignkNrHyphenZeroNineSeven,
    aspectRatio: 1,
  },
  'kNr-098': {
    url: SignkNrHyphenZeroNineEight,
    aspectRatio: 1,
  },
  'kNr-099': {
    url: SignkNrHyphenZeroNineNine,
    aspectRatio: 1,
  },
};
